import PagamentoLegadoParcela from '../../../../components/Financeiro/PagamentoLegadoParcela';
import PagamentoLegadoContextual from '../../../../components/Financeiro/PagamentoLegadoContextual';
import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaThumbsUp, FaPen, FaPlus, FaSearch, FaFileAlt, FaFileInvoice, FaUpload, FaFileInvoiceDollar, FaEdit, FaThumbsDown, FaClock, FaCheck, FaCalendarAlt, FaEllipsisV, FaTimes, FaUniversity, FaCreditCard, FaSync, FaFilter, FaEye, FaLock } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import IconButton from '../../../../components/IconButton';
import Alert from '../../../../components/Alert';
import api from '../../../../services/api';
import moment from 'moment';
import { useLocation, useHistory } from 'react-router-dom';
import Data from '../../../../components/Data';
import FormButton from '../../../../components/FormButton';
import { dataMysql, moeda, copiarTexto } from '../../../../util/util';
import ReactSelect from '../../../../components/ReactSelect';
import { FinField, FinInput, FinTextarea } from '../../../../components/FinField';
import { calcularCotacao, pendenciaCotacao, numeroCampo } from './cambioBancoPolicy';
import { motivoNaoVolta } from './voltaParaPlanosPolicy';
import ModalVoltaParaPlanos from './ModalVoltaParaPlanos';
import { rotaDetalheAdiantamento, cliqueEmControle } from '../../Adiantamento/adiantamentoDetalhePolicy';
import { rotaDetalhePrevisao } from './previsaoDetalhePolicy';
import { abaDaUrl, gravarAbasNaUrl } from '../../abasNaUrlPolicy';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import axios from 'axios';
import { datasParcelasDaLinha, nomeOrcamentoDaLinha, parcelasDataFormaDaLinha, totalAtualOrcamentoBrl, vaiParaContasPagar } from './custoPrevistoPolicy';
import { dataLocalMaisDias } from '../../../Orcamento/dataParcelaPolicy';
import { MSG_LIBERAR_NAO_VAI_CONTAS_PAGAR, MSG_LIBERAR_SEM_FORNECEDOR, MSG_LIBERAR_SEM_TITULO, TAG_VINDO_DE_A_DEFINIR, acaoLiberacaoAprovado, nomeFornecedorPlano, planoVindoDeADefinir } from '../../../Orcamento/fornecedorADefinirPolicy';
import { MSG_AGUARDANDO_COMPRAS, MSG_SO_BAIXA, acimaDaEstimativa, aguardandoCompras, ehCartaoFisico, parcelasAcimaDaEstimativa, valorReal } from '../../../Orcamento/cartaoFisicoPolicy';
import ValorComOrigem, { OrigemMoeda } from '../../../../components/ValorComOrigem';
import TagNatureza, { naturezaDaLista } from '../../../../components/TagNatureza';
import { origemDaParcela, origemDoPlano, somarOrigens, formatarCambio } from '../../../../components/moedaOrigemPolicy';
import { podeRenegociarAdiantamento } from '../../../Orcamento/adiantamentoPermissaoPolicy';
import { parteAdiantamentoDaConta } from '../../../Orcamento/adiantamentoParcelaPolicy';
import '../../../../css/financeiro-parcela-pagar.css';
import { NfValidacaoDetalhe, NfValidacaoPill, piorValidacao } from '../../../../components/Financeiro/NfValidacao';
import { NfParcelasTabela } from '../../../../components/Financeiro/NfParcelas';
import { alternar, avisoPedidoDeNovo, notaPadrao, ordenarPeloPlano, pedidoPadrao, rotuloParcelasDaNf, situacaoNfParcela } from '../../../../components/Financeiro/nfParcelasPolicy';

// D-0099: parcelas do plano com a NF de cada uma — só nas linhas de Previsão com o vínculo por parcela.
const nfParcelasDoItem = (item) => ((item && item._tipo === 'previsao' && item.nf_por_parcela) ? (item.nf_parcelas || []) : []);

// Rótulo da forma de pagamento (execução preenchida no Efetivo)
const LABEL_FORMA_PGTO = {
    pix: 'PIX', cartao_credito: 'Crédito', cartao_debito: 'Débito', credito: 'Crédito',
    remessa: 'Remessa / TED', transferencia: 'Transferência', link: 'Link', boleto: 'Boleto', fatura: 'Fatura',
    cartao_fisico: 'Cartão físico', // D-0116
    apolice: 'Apólice', // D-0128
};
function labelFormaPgto(f) { return LABEL_FORMA_PGTO[f] || f || ''; }

// Resumo legível dos dados bancários/PIX que o operador preencheu no Efetivo —
// é o "como/pra onde pagar" que o Financeiro precisa ver na hora de pagar.
function resumoDadosPagamento(dados) {
    if (!dados || typeof dados !== 'object') return '';
    const p = [];
    if (dados.chave) p.push('PIX: ' + dados.chave + (dados.tipo_chave ? ' (' + dados.tipo_chave + ')' : ''));
    if (dados.beneficiario) p.push('Benef.: ' + dados.beneficiario);
    if (dados.favorecido) p.push('Favorecido: ' + dados.favorecido);
    if (dados.banco) p.push('Banco: ' + dados.banco);
    if (dados.agencia) p.push('Ag.: ' + dados.agencia);
    if (dados.conta) p.push('CC: ' + dados.conta);
    if (dados.cpf_cnpj) p.push('CPF/CNPJ: ' + dados.cpf_cnpj);
    if (dados.linha_digitavel) p.push('Linha: ' + dados.linha_digitavel);
    if (dados.ultimos4) p.push('Cartão •••• ' + dados.ultimos4 + (dados.bandeira ? ' ' + dados.bandeira : ''));
    if (dados.titular) p.push('Titular: ' + dados.titular);
    // Fatura: número e vencimento eram preenchidos no Efetivo e não apareciam em
    // lugar nenhum aqui — a conta chegava como "💳 Fatura" e mais nada, sem dizer
    // QUAL fatura pagar.
    if (dados.numero) p.push('Fatura nº ' + dados.numero);
    if (dados.vencimento) p.push('Venc. fatura: ' + formatarDataFatura(dados.vencimento));
    if (dados.descricao) p.push(dados.descricao);
    // D-0116: cartão físico — valor real da compra (o cartão vem como caixa no modal Pagar).
    if (dados.valor_real) p.push('Valor real: R$ ' + moeda(dados.valor_real));
    // A URL não entra no texto: vira link clicável ao lado do resumo (ver a linha
    // da tabela). Colar link no internet banking na mão é pedir erro de digitação.
    return p.join(' · ');
}

// Vencimento da fatura vem do <input type="date"> do Efetivo, em AAAA-MM-DD.
function formatarDataFatura(v) {
    var d = moment(v, ['YYYY-MM-DD', moment.ISO_8601], true);
    return d.isValid() ? d.format('DD/MM/YYYY') : String(v);
}

// URL de pagamento (forma "link"), para render como âncora.
function urlDePagamento(dados) {
    if (!dados || typeof dados !== 'object') return '';
    var u = dados.url || dados.link_pagamento || '';
    return /^https?:\/\//i.test(u) ? u : '';
}

export default function PainelParcelaPagar() {
    let { state } = useLocation();
    const history = useHistory();
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const usuario = localStorage.getItem("idUsuario");
    const [filtro, setFiltro] = useState({
        tipo: 1,
        empresa: empresa,
        idTitulo: state?.idTitulo ?? null,
    }); //1 - pagar | 2 - receber
    const [dados, setDados] = useState({ pagamento: new Date() });
    const [parcelas, setParcelas] = useState([]);
    // Aba "Cancelado" (2026-08-02): parcelas canceladas não somem mais — ficam
    // visíveis, riscadas, com quem/quando/por quê e se foi automático ou manual.
    const [parcelasCanceladas, setParcelasCanceladas] = useState([]);
    const [carregandoCanceladas, setCarregandoCanceladas] = useState(false);
    const [tableSelect, setTableSelect] = useState([]);
    const [tableActions, setTableActions] = useState([]);
    // D-0097: abas lidas da URL (gravarAbasNaUrl, abaixo) — o Voltar das telas de Detalhe reabre a aba de origem.
    // 'cancelado' não entra: a aba só carrega no clique.
    const [abaAtiva, setAbaAtiva] = useState(() => abaDaUrl(window.location.search, 'aba', ['pendentes', 'pagas', 'custoPrevisto', 'adiantamentos'], 'pendentes')); // 'pendentes' | 'pagas' | 'custoPrevisto' | 'adiantamentos'
    const [abaVinculo, setAbaVinculo] = useState('eventos'); // mantido internamente para queries
    const [showActionsModal, setShowActionsModal] = useState(false);
    const [actionsModalData, setActionsModalData] = useState({ parcela: null, actions: [] });
    // Cartão de pagamento seguro (Contas Pendentes, espécie Cartão de Crédito)
    const [cartaoModal, setCartaoModal] = useState(null); // { parcela, contexto } — inserir/alterar dados (Financeiro)
    const [formCartao, setFormCartao] = useState({ caixa_cartao_id: '', numero: '', titular: '', validade: '', cvv: '', operador_id: '', operador_email: '' });
    const [cartoesDisponiveis, setCartoesDisponiveis] = useState([]); // cartões cadastrados no Caixa
    const [cartaoStatusModal, setCartaoStatusModal] = useState(null); // { parcela, contexto } — status/reenviar aviso (Financeiro)
    const [negarCartaoModal, setNegarCartaoModal] = useState(null);   // { parcela, motivo } — banco recusou o cartão
    const [loadingCartao, setLoadingCartao] = useState(false);
    const [showModalAprovar, setShowModalAprovar] = useState(false);
    const [showModalReprovar, setShowModalReprovar] = useState(false);
    const [comentarios, setComentarios] = useState('');
    const [filtroCustoPrevisto, setFiltroCustoPrevisto] = useState({
        evento: null,
        nomeEvento: '',
        orcamento: null,
        nomeOrcamento: '',
        dataPrevisao1: null,
        dataPrevisao2: null
    });
    const [custosPrevistos, setCustosPrevistos] = useState([]);
    // Saldo de adiantamento por evento (Kátia, 04/09): ela precisa comparar, na
    // mesma linha, o que o evento vai custar com o que já foi adiantado — antes
    // tinha de abrir a tela de Saldo de Adiantamento em outra aba para decidir.
    const [saldosPorEvento, setSaldosPorEvento] = useState({});
    const [loadingCustosPrevistos, setLoadingCustosPrevistos] = useState(false);
    // Planos de pagamento aguardando aprovação (novo fluxo)
    const [planosPrevistos, setPlanosPrevistos] = useState([]);
    // Item 15: moeda de origem por OPF (Custo Previsto / Aprovados) — { opfId: origem|null }.
    const [origemOpf, setOrigemOpf] = useState({});
    const [loadingPlanos, setLoadingPlanos] = useState(false);
    // A aba "Aprovados" tem a SUA consulta. Antes as duas liam a mesma lista, e
    // era por isso que o filtro de uma mexia na outra.
    const [aprovadosPrevistos, setAprovadosPrevistos] = useState([]);
    const [loadingAprovados, setLoadingAprovados] = useState(false);
    // Contagem do fluxo inteiro, vinda do servidor sem filtro — alimenta os KPIs
    // do topo e os números das abas, que descrevem o todo e não o recorte.
    const [resumoCusto, setResumoCusto] = useState({ aguardando: 0, aprovados: 0, reprovados: 0, parcial: 0 });
    // Avisos fechados nesta sessão da tela. O X só tira a faixa da frente: não
    // muda dado nenhum e o aviso volta se a condição ainda valer no próximo
    // carregamento — é aviso de estado, não notificação.
    const [avisosFechados, setAvisosFechados] = useState({});
    const [eventosAbertos, setEventosAbertos] = useState({}); // { [evento_id]: true|false }
    // abertoAtual = estado EFETIVO (default-aware) — evita o bug de 2 cliques quando o evento abre por padrão
    const toggleEventoAberto = (eventoId, abertoAtual) => setEventosAbertos(prev => ({ ...prev, [eventoId]: abertoAtual !== undefined ? !abertoAtual : !prev[eventoId] }));
    const [adiantamentos, setAdiantamentos] = useState([]);
    const [loadingAdiantamentos, setLoadingAdiantamentos] = useState(false);
    // Sub-abas do bloco "Aprovados pelo Financeiro — Situação NF"
    const [abaAprovados, setAbaAprovados] = useState(() => abaDaUrl(window.location.search, 'abaAprovados', ['previsoes', 'adiantamentos'], 'previsoes')); // 'previsoes' | 'adiantamentos'
    const [abaContas, setAbaContas] = useState(() => abaDaUrl(window.location.search, 'abaContas', ['previsoes', 'adiantamentos'], 'previsoes')); // 'previsoes' | 'adiantamentos' — sub-aba de Contas Pendentes/Pagas
    // Custo Previsto virou duas abas (Rafael, 10/09): "Planos de Pagamento" e
    // "Aprovados pelo Financeiro". Cada uma guarda o SEU cliente/busca/período —
    // era isso que atrapalhava antes, porque as duas liam o mesmo filtro.
    const [subAbaCusto, setSubAbaCusto] = useState(() => abaDaUrl(window.location.search, 'subAbaCusto', ['planos', 'aprovados'], 'planos')); // 'planos' | 'aprovados'
    const FILTRO_CUSTO_VAZIO = { cliente: null, busca: '', de: null, ate: null };
    const [filtroPlanos, setFiltroPlanos] = useState(FILTRO_CUSTO_VAZIO);
    const [filtroAprovados, setFiltroAprovados] = useState(FILTRO_CUSTO_VAZIO);
    // Rascunho x aplicado: o que está nos campos ainda NÃO filtra — só o botão
    // "Buscar" leva o rascunho para o filtro. Filtrar a cada data escolhida
    // esvaziava a tela no meio da escolha do período, com o operador ainda sem
    // ter dito o "até" (Rafael, 10/09); e nas abas que consultam o servidor era
    // uma ida ao banco por campo mexido.
    const [rascunhoPlanos, setRascunhoPlanos] = useState(FILTRO_CUSTO_VAZIO);
    const [rascunhoAprovados, setRascunhoAprovados] = useState(FILTRO_CUSTO_VAZIO);
    const [rascunhoContas, setRascunhoContas] = useState({ cliente: null, busca: '' });
    const escopoCustoPrevisto = () => (subAbaCusto === 'aprovados'
        ? { valores: filtroAprovados, set: setFiltroAprovados, rascunho: rascunhoAprovados, setRascunho: setRascunhoAprovados }
        : { valores: filtroPlanos, set: setFiltroPlanos, rascunho: rascunhoPlanos, setRascunho: setRascunhoPlanos });
    const fecharAviso = (chave) => setAvisosFechados(prev => Object.assign({}, prev, { [chave]: true }));
    const avisoVisivel = (chave) => !avisosFechados[chave];
    const botaoFecharAviso = (chave) => (
        <button type="button" className="fin-pp__banner-close" title="Fechar aviso"
            aria-label="Fechar aviso" onClick={() => fecharAviso(chave)}>
            <FaTimes size={12} />
        </button>
    );
    const [salvandoStatusPgto, setSalvandoStatusPgto] = useState({}); // { [parcelaId]: true }
    const [salvandoLiberacao, setSalvandoLiberacao] = useState({}); // { [_key]: true }
    // Modal de status de pagamento do adiantamento
    const [modalStatusPgto, setModalStatusPgto] = useState(null); // { item } | null
    const [modalStatusPgtoSel, setModalStatusPgtoSel] = useState(null); // 'creditado' | 'nao_creditado'
    const [modalStatusPgtoObs, setModalStatusPgtoObs] = useState('');
    // Documentos da parcela (1:N) — { row, carregando, docs } | null
    const [modalArquivos, setModalArquivos] = useState(null);
    // Notas fiscais de um item do Custo Previsto (1:N) — { item } | null
    const [modalNFs, setModalNFs] = useState(null);
    // Solicitar NF (seção unificada Aprovados)
    const [solicitarNFUnifModal, setSolicitarNFUnifModal] = useState(null);
    const [emailsSolicitarNFUnif, setEmailsSolicitarNFUnif] = useState(['']);
    const [enviandoNFSolicitacaoUnif, setEnviandoNFSolicitacaoUnif] = useState(false);
    // Vincular NF internamente (seção unificada Aprovados)
    const [vincularNFModal, setVincularNFModal] = useState(null);
    const [vincularNFFile, setVincularNFFile] = useState(null);
    const [vincularNFTipoDoc, setVincularNFTipoDoc] = useState('nf');
    const [vincularNFNumero, setVincularNFNumero] = useState('');
    const [vincularNFObs, setVincularNFObs] = useState('');
    const [salvandoVincularNF, setSalvandoVincularNF] = useState(false);
    // D-0099: parcelas do pedido de NF e da NF vinculada pelo Financeiro
    const [parcelasSolicitarNFUnif, setParcelasSolicitarNFUnif] = useState([]);
    const [parcelasVincularNF, setParcelasVincularNF] = useState([]);
    const [planoAprovarModal, setPlanoAprovarModal] = useState(null); // item do plano
    const [planoReprovarModal, setPlanoReprovarModal] = useState(null); // item do plano
    const [motivoReprovacaoPlano, setMotivoReprovacaoPlano] = useState('');
    // D-0097: Aprovados pelo Financeiro → Planos de Pagamento (item da aba Aprovados).
    const [voltaPlanosModal, setVoltaPlanosModal] = useState(null);
    const [enviarEmailFornecedorNF, setEnviarEmailFornecedorNF] = useState(false);
    const [salvandoPlano, setSalvandoPlano] = useState(false);
    const [salvandoPagamento, setSalvandoPagamento] = useState(false); // duplo clique no Pagar
    const estornandoRef = useRef({}); // { [parcelaId]: true } — duplo clique no estorno
    const [showModalNFRetroativa, setShowModalNFRetroativa] = useState(false);
    const [itemNFRetroativa, setItemNFRetroativa] = useState(null);
    const [arquivosNFRetroativa, setArquivosNFRetroativa] = useState([]);
    const [enviandoNFRetroativa, setEnviandoNFRetroativa] = useState(false);
    const [exportandoContasPagas, setExportandoContasPagas] = useState(false);
    const [exportandoPlanilhaContabilidade, setExportandoPlanilhaContabilidade] = useState(false);
    const [caixas, setCaixas] = useState([]);
    const [saldosLedger, setSaldosLedger] = useState({}); // { caixa_id: saldo } — saldo real do razão (fonte da verdade p/ banco)
    const [pagarModal, setPagarModal] = useState(null); // { parcela, caixa, dataPagamento, novoValor }
    const [reverterModal, setReverterModal] = useState(null); // parcela a devolver para "Aprovados pelo Financeiro"
    // "Travar para pagamento" (Rafael 07/10): { titulo, parcelas: [rows] }
    const [travarModal, setTravarModal] = useState(null);
    const [travando, setTravando] = useState(false);
    const [revertendo, setRevertendo] = useState(false);      // guard de duplo clique
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    // Ajuste das parcelas ao orçamento, quando elas passaram do valor orçado.
    const [ajustando, setAjustando] = useState({});
    const [carregandoCaixas, setCarregandoCaixas] = useState(false);
    const [showModalExportarContasPagas, setShowModalExportarContasPagas] = useState(false);
    const [filtroExportacaoContasPagas, setFiltroExportacaoContasPagas] = useState({
        tiposDocumento: ['todas'],
        vinculos: ['eventos'],
        periodo: 'mes_atual',
        dataInicial: null,
        dataFinal: null,
        formato: 'pdf',
    });
    const params = new URLSearchParams(window.location.search);
    const grupoTitulo = params.get('grupoTitulo');
    const parcelaabater = state?.parcelaabater ?? null;
    // Deep-link vindo do Painel Financeiro (clique no evento) → foca só naquele evento em Contas Pendentes
    const idEventoUrl = params.get('idEvento');
    const nomeEventoUrl = params.get('nomeEvento');
    const [eventoFiltroPendentes, setEventoFiltroPendentes] = useState(idEventoUrl || null);
    const [eventoFiltroNome, setEventoFiltroNome] = useState(nomeEventoUrl || '');
    // Filtro temporal por vencimento (Contas Pendentes): 'tudo'|'vencidas'|'hoje'|'semana'|'7dias'|'30dias'
    const [filtroVencimento, setFiltroVencimento] = useState('tudo');
    // Busca em Contas Pendentes (reunião do Financeiro 2026-08-14): com muitos
    // eventos na tela, achar um pagamento virou rolagem. Cliente e nome do evento
    // são os dois eixos que eles usam para procurar.
    const [filtroClientePagar, setFiltroClientePagar] = useState(null);
    const [buscaEventoPagar, setBuscaEventoPagar] = useState('');
    // Reuso do filtro cliente+busca nas abas que agrupam por CLIENTE → eventos
    // aninhados (Custo Previsto, Cancelado) — forma diferente de Pendentes/Pagas
    // (que filtram uma lista achatada de eventos), mas os mesmos dois campos.
    // Cliente/busca APLICADOS do contexto: no Custo Previsto vêm do escopo da
    // sub-aba (Planos ou Aprovados), nas demais abas do par compartilhado de
    // Contas. É o que as listas leem — o que está digitado mora no rascunho.
    const filtroClienteAtivo = () => (abaAtiva === 'custoPrevisto'
        ? escopoCustoPrevisto().valores.cliente
        : filtroClientePagar);
    const buscaEventoAtiva = () => (abaAtiva === 'custoPrevisto'
        ? escopoCustoPrevisto().valores.busca
        : buscaEventoPagar);

    // Reuso do filtro cliente+busca nas abas que agrupam por CLIENTE → eventos
    // aninhados (Custo Previsto, Cancelado) — forma diferente de Pendentes/Pagas
    // (que filtram uma lista achatada de eventos), mas os mesmos dois campos.
    const filtrarClientesPorFiltro = (clientesOrdenados) => {
        let l = clientesOrdenados;
        const cliente = filtroClienteAtivo();
        if (cliente) {
            l = l.filter(function (cli) { return String(cli.cliente_id) === String(cliente); });
        }
        const termo = (buscaEventoAtiva() || '').trim().toLowerCase();
        if (termo) {
            l = l.filter(function (cli) {
                if ((cli.cliente_nome || '').toLowerCase().indexOf(termo) !== -1) return true;
                return Object.values(cli.eventos).some(function (ev) {
                    return (ev.evento_nome || '').toLowerCase().indexOf(termo) !== -1;
                });
            });
        }
        return l;
    };
    const opcoesClientesDe = (clientesOrdenados) => clientesOrdenados
        .map(function (c) { return { value: c.cliente_id, label: c.cliente_nome }; })
        .sort(function (a, b) { return a.label.localeCompare(b.label); });

    // Barra de filtros da aba ativa: rascunho (o que está nos campos), como
    // aplicar e como limpar. Cada aba filtra pela data que faz sentido nela —
    // previsão no Custo Previsto, pagamento em Contas Pagas, vencimento nas
    // demais — e guarda o SEU conjunto: mexer numa não mexe na outra.
    const escopoBarraFiltro = () => {
        if (abaAtiva === 'custoPrevisto') {
            const esc = escopoCustoPrevisto();
            const v = esc.valores;
            return {
                rotulo: 'Previsão',
                rascunho: esc.rascunho,
                trocar: (patch) => esc.setRascunho(Object.assign({}, esc.rascunho, patch)),
                // O filtro é do servidor: "Buscar" refaz a consulta da sub-aba.
                // O override explícito é obrigatório — o setState só vale no
                // próximo render e a busca sairia com o filtro anterior.
                aplicar: () => {
                    const aplicado = Object.assign({}, esc.rascunho);
                    esc.set(aplicado);
                    recarregarCustoPrevisto(aplicado);
                },
                limpar: () => {
                    const zerado = Object.assign({}, FILTRO_CUSTO_VAZIO);
                    esc.setRascunho(zerado);
                    esc.set(zerado);
                    recarregarCustoPrevisto(zerado);
                },
                temAplicado: !!(v.cliente || v.busca || v.de || v.ate),
            };
        }
        const ehPagas = abaAtiva === 'pagas';
        const rotulo = ehPagas ? 'Pagamento' : 'Vencimento';
        const campoDe = ehPagas ? 'dataPagamento1' : 'dataVencimento1';
        const campoAte = ehPagas ? 'dataPagamento2' : 'dataVencimento2';
        return {
            rotulo,
            // A data destas abas já vive no `filtro`, que é o próprio corpo da
            // consulta — e lá ela nunca valeu sozinha: só quando a busca roda.
            rascunho: { cliente: rascunhoContas.cliente, busca: rascunhoContas.busca, de: filtro[campoDe], ate: filtro[campoAte] },
            trocar: (patch) => {
                if ('cliente' in patch || 'busca' in patch) {
                    setRascunhoContas(function (r) { return Object.assign({}, r, patch); });
                }
                if ('de' in patch)  setFiltro(function (f) { return Object.assign({}, f, { [campoDe]: patch.de }); });
                if ('ate' in patch) setFiltro(function (f) { return Object.assign({}, f, { [campoAte]: patch.ate }); });
            },
            aplicar: () => {
                setFiltroClientePagar(rascunhoContas.cliente);
                setBuscaEventoPagar(rascunhoContas.busca);
                buscar();
            },
            limpar: () => {
                setRascunhoContas({ cliente: null, busca: '' });
                setFiltroClientePagar(null);
                setBuscaEventoPagar('');
                const zerado = { [campoDe]: null, [campoAte]: null };
                setFiltro(function (f) { return Object.assign({}, f, zerado); });
                // Override explícito: o setFiltro acima só vale no próximo render,
                // e a busca sairia com a data antiga.
                buscar(zerado);
            },
            temAplicado: !!(filtroClientePagar || buscaEventoPagar || filtro[campoDe] || filtro[campoAte]),
        };
    };

    // Um filtro que zera a lista NÃO pode levar junto a barra de filtros: sem ela
    // o operador fica sem como desfazer e só sai recarregando a página (print do
    // Rafael, 10/09). Por isso a barra aparece também quando há filtro aplicado,
    // mesmo sem resultado.
    const temFiltroAtivoNaAba = () => escopoBarraFiltro().temAplicado;
    const limparFiltrosDaAba = () => escopoBarraFiltro().limpar();

    // Clientes que aparecem nos planos — alimenta o select do filtro mesmo quando
    // a lista filtrada está vazia (senão o operador perde o seletor junto).
    const clientesDosPlanos = () => {
        const vistos = {};
        planosPrevistos.filter(p => p.status === 'enviado').forEach((p) => {
            const id = p.cliente_id || '__sem_cliente__';
            if (!vistos[id]) vistos[id] = { cliente_id: p.cliente_id, cliente_nome: p.cliente_nome || 'Sem cliente' };
        });
        return Object.values(vistos);
    };

    const renderFiltroClienteEvento = (opcoes) => {
        const cfg = escopoBarraFiltro();
        const r = cfg.rascunho;
        const temRascunho = !!(r.cliente || r.busca || r.de || r.ate);
        return (
            <div className="fin-pp__filters" style={{ marginBottom: 12 }}>
                <FinField label="Cliente">
                    <ReactSelect
                        options={opcoes}
                        value={r.cliente
                            ? opcoes.find(function (c) { return String(c.value) === String(r.cliente); }) || null
                            : null}
                        onChange={function (e) { cfg.trocar({ cliente: e ? e.value : null }); }}
                        isClearable
                        placeholder="Todos os clientes"
                    />
                </FinField>
                <FinField label="Buscar evento" grow>
                    <FinInput
                        value={r.busca}
                        onChange={function (e) { cfg.trocar({ busca: e.target.value }); }}
                        onKeyDown={function (e) { if (e.key === 'Enter') { e.preventDefault(); cfg.aplicar(); } }}
                        placeholder="Nome do evento ou do cliente"
                        style={{ paddingLeft: 14 }}
                    />
                </FinField>
                {/* `Data` já renderiza o próprio label — envolver em FinField
                    duplicaria o rótulo. Só o container do grid é replicado. */}
                <div className="fin-pp__field">
                    <Data label={cfg.rotulo + ' de'} value={r.de} onChange={(d) => cfg.trocar({ de: d })} />
                </div>
                <div className="fin-pp__field">
                    <Data label={'Até ' + cfg.rotulo.toLowerCase()} value={r.ate} onChange={(d) => cfg.trocar({ ate: d })} />
                </div>
                <div className="fin-pp__filters-actions">
                    <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={cfg.aplicar}>
                        <FaSearch size={13} /> Buscar
                    </button>
                    {(cfg.temAplicado || temRascunho) && (
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--icon"
                            title="Limpar filtros"
                            aria-label="Limpar filtros"
                            onClick={cfg.limpar}>
                            <FaTimes size={13} />
                        </button>
                    )}
                </div>
            </div>
        );
    };
    const limparFiltroEvento = () => {
        setEventoFiltroPendentes(null);
        setEventoFiltroNome('');
        history.replace('/financeiroParcelaPagar');
    };

    // D-0097: guarda as abas na URL para o Voltar das telas de Detalhe reabrir aqui. Refaz também
    // depois do limparFiltroEvento, que reescreve a URL.
    useEffect(() => {
        gravarAbasNaUrl(history, { aba: abaAtiva, subAbaCusto, abaAprovados, abaContas });
    }, [abaAtiva, subAbaCusto, abaAprovados, abaContas, eventoFiltroPendentes]); // eslint-disable-line react-hooks/exhaustive-deps

    // Busca só os cancelados (somenteRemovidos=1). Separado do buscar() porque a
    // consulta principal esconde removidos — juntar os dois numa query só faria a
    // aba Pendentes voltar a mostrar cancelado.
    // Redistribui as parcelas de previsão para somar exatamente o orçamento atual,
    // mantendo a quantidade e a proporção entre elas (e as datas).
    const ajustarParcelas = (plano) => {
        setAjustando((a) => Object.assign({}, a, { [plano.id]: true }));
        api({ method: 'put', action: `/orcamentoPagamentoFornecedor/${plano.id}/ajustarParcelas`, token: token })
            .then((r) => {
                toast.success((r.data && r.data.mensagem) || 'Parcelas ajustadas.');
                buscar(true);
            })
            .catch((e) => {
                toast.error((e.response && e.response.data && e.response.data.mensagem) || 'Erro ao ajustar as parcelas.');
            })
            .finally(() => setAjustando((a) => Object.assign({}, a, { [plano.id]: false })));
    };

    const buscarCanceladas = () => {
        setCarregandoCanceladas(true);
        api({
            method: 'get',
            action: '/financeiroParcela',
            token: token,
            params: { tipo: 1, somenteRemovidos: 1 }
        })
            .then(response => setParcelasCanceladas(response.data.data || []))
            .catch(() => setParcelasCanceladas([]))
            .finally(() => setCarregandoCanceladas(false));
    };

    // `over` permite disparar a busca já com o filtro novo, sem esperar o próximo
    // render: ao limpar o período, o estado ainda não chegou aqui e a busca sairia
    // com a data antiga (o filtro parecia não limpar).
    // Cache da lista de orçamentos do filtro do Custo Previsto, por evento
    // (ver o select "Orçamento do Evento"). Falha não fica guardada.
    const orcamentosFiltroCacheRef = useRef({});
    const orcamentosDoFiltro = (eventoId) => {
        const chave = eventoId ? String(eventoId) : '__todos__';
        if (!orcamentosFiltroCacheRef.current[chave]) {
            orcamentosFiltroCacheRef.current[chave] = api({ method: 'get', action: '/orcamento', token: token, params: { evento: eventoId || undefined } })
                .then(r => r.data.data || [])
                .catch(err => { delete orcamentosFiltroCacheRef.current[chave]; throw err; });
        }
        return orcamentosFiltroCacheRef.current[chave];
    };

    const buscar = (over) => {
        const filtroAtual = Object.assign({}, filtro, over || {});
        setFiltro(prev => ({ ...prev, buscando: true }));
        api({
            method: 'get',
            action: '/financeiroParcela',
            token: token,
            params: {
                ...filtroAtual,
                ...{ grupoTitulo: grupoTitulo },
                ...{ parcelaabater: parcelaabater },
            }
        })
            .then(response => {
                setParcelas(response.data.data);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                //console.log(err)
            })
    };

    const normalizarTexto = (valor) => (valor || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

    const ehHospedagemOuABTexto = (texto) => {
        const textoNormalizado = normalizarTexto(texto);
        if (!textoNormalizado) return false;

        const termos = [
            'hospedagem',
            'hotel',
            'a&b',
            'a e b',
            'alimentacao',
            'bebida',
            'buffet',
            'coffee break'
        ];

        return termos.some((termo) => textoNormalizado.includes(termo));
    };

    const ehDiretoContasPendentesItem = (item) => {
        const textos = [
            item?.produto?.grupo?.nome,
            item?.produto?.nome,
            item?.observacaoFechamento,
            item?.titulo,
            item?.descricao
        ];

        return textos.some((texto) => ehHospedagemOuABTexto(texto));
    };

    const ehDiretoContasPendentesParcela = (parcela) => {
        const itens = parcela?.titulo?.orcamento_item ?? [];
        return itens.some((item) => ehDiretoContasPendentesItem(item));
    };

    // "Excluir / voltar para Aprovados" só se aplica a itens que estão em Contas Pendentes
    // PORQUE foram liberados e podem de fato voltar (OPF / adiantamento não-creditado).
    // Itens intrínsecos a Contas Pendentes (adiantamento creditado ou Hospedagem/A&B) NÃO
    // voltam — a ação é ocultada para eles (senão prometeria algo que não acontece).
    // Rafael 08/10: TODA conta em Contas Pendentes pode voltar para o Custo Previsto — inclusive as que
    // não vieram de Previsão (antigas, Hospedagem/A&B direto, ajuste de banco): o servidor cancela a conta
    // e põe o valor no Custo Previsto aguardando aprovação. Só o adiantamento creditado fica de fora.
    const parcelaPodeVoltarParaAprovados = (parcela) => {
        if (!parcela) return false;
        const titulo = parcela.titulo && typeof parcela.titulo === 'object' ? parcela.titulo : null;
        const descricao = (titulo && titulo.descricao) ? String(titulo.descricao) : '';
        const ehAdiantamentoCreditado = descricao.indexOf('Adiantamento') === 0
            && parcela.status_pagamento === 'creditado';
        return !ehAdiantamentoCreditado;
    };

    // "Travar para pagamento" (Rafael 07/10): conta aberta, já em Contas Pendentes e ainda sem trava.
    // Pagar NÃO exige trava (opcional). Destrava só com "Voltar para Custo Previsto".
    const PERFIS_TRAVAR_PAGAMENTO = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'];
    const parcelaPodeTravar = (parcela) => !!parcela
        && (parcela.situacao === '1' || parcela.situacao === 1)
        && !!parcela.liberado_financeiro_at && !parcela.travado_pagamento_em && !parcela.removido_em;

    const getValorOrcadoItem = (item) => {
        const valorBase = parseFloat(item?.totalFechamento) || 0;
        const percentualServico = parseFloat(item?.servicoFechamento) || 0;
        return valorBase + ((valorBase * percentualServico) / 100);
    };

    // O filtro vai para o SERVIDOR, não fica na tela. Sem realtime, recortar no
    // front é recortar a lista que chegou — que pode já estar velha; cada
    // "Buscar" volta ao banco (Rafael, 10/09). Cada sub-aba tem a sua consulta,
    // com o seu conjunto de filtros: é o que as mantém independentes.
    const paramsDoFiltro = (f) => ({
        cliente: f && f.cliente ? f.cliente : undefined,
        busca: f && f.busca ? f.busca : undefined,
        dataPrevisao1: f && f.de ? dataMysql(f.de) : undefined,
        dataPrevisao2: f && f.ate ? dataMysql(f.ate) : undefined,
    });

    // Item 15: origem (moeda, câmbio, valor na moeda) dos OPFs listados. Falha = sem origem
    // (a tela segue como hoje); nunca bloqueia a listagem.
    const carregarOrigemOpf = (planos) => {
        const ids = (planos || []).map(p => p && p.id).filter(Boolean);
        if (!ids.length) return;
        api({ method: 'get', action: '/financeiro/moedaOrigem/opf', token, params: { ids: ids.join(',') } })
            .then(res => {
                const d = (res.data && res.data.data) || {};
                setOrigemOpf(prev => Object.assign({}, prev, d));
            })
            .catch(() => {});
    };

    // Sem `status`: a aba Planos lista os 'enviado' e ainda precisa dos
    // 'aprovado' com NF para o aviso de migração no topo dela.
    const buscarPlanosPrevistos = (f) => {
        const filtroUsado = f || filtroPlanos;
        setLoadingPlanos(true);
        api({
            method: 'get', action: '/orcamentoPagamentoCustoPrevisto', token,
            params: paramsDoFiltro(filtroUsado),
        })
            .then(res => {
                setPlanosPrevistos(res.data.data || []);
                carregarOrigemOpf(res.data.data);
                if (res.data.resumo) setResumoCusto(res.data.resumo);
            })
            .catch(() => { toast.error('Erro ao buscar planos previstos'); setPlanosPrevistos([]); })
            .finally(() => setLoadingPlanos(false));
    };

    const buscarAprovadosPrevistos = (f) => {
        const filtroUsado = f || filtroAprovados;
        setLoadingAprovados(true);
        api({
            method: 'get', action: '/orcamentoPagamentoCustoPrevisto', token,
            params: Object.assign({ status: 'aprovado' }, paramsDoFiltro(filtroUsado)),
        })
            .then(res => {
                setAprovadosPrevistos(res.data.data || []);
                carregarOrigemOpf(res.data.data);
                if (res.data.resumo) setResumoCusto(res.data.resumo);
            })
            .catch(() => { toast.error('Erro ao buscar aprovados'); setAprovadosPrevistos([]); })
            .finally(() => setLoadingAprovados(false));
    };

    // Recarrega a sub-aba visível. O adiantamento vem junto porque a aba
    // Aprovados mistura previsão e adiantamento na mesma lista — e agora os dois
    // levam o MESMO filtro ao servidor, cada um no seu endpoint.
    const recarregarCustoPrevisto = (over) => {
        if (subAbaCusto === 'aprovados') {
            const filtroUsado = over || filtroAprovados;
            buscarAprovadosPrevistos(filtroUsado);
            buscarAdiantamentos(filtroUsado);
            return;
        }
        buscarPlanosPrevistos(over);
    };

    // Previsão Inter (28/09): o Financeiro avisa o Eventos que viu a Previsão do fornecedor pago no
    // exterior. Só avisa — a aprovação continua pelo botão Aprovar.
    const [marcandoVisualizado, setMarcandoVisualizado] = useState({});
    const marcarVisualizado = async (plano) => {
        if (!plano || marcandoVisualizado[plano.id]) return;
        setMarcandoVisualizado((m) => Object.assign({}, m, { [plano.id]: true }));
        try {
            const res = await api({ method: 'put', action: '/orcamentoPagamentoFornecedor/' + plano.id + '/visualizar', token });
            toast.success((res && res.data && res.data.msg) || 'Marcado como visualizado.');
            recarregarCustoPrevisto();
        } catch (err) {
            toast.error((err.response && err.response.data && err.response.data.error) || 'Erro ao marcar como visualizado.');
        } finally {
            setMarcandoVisualizado((m) => Object.assign({}, m, { [plano.id]: false }));
        }
    };

    // Previsão Inter (28/09): cotação do banco no modal Aprovar (fornecedor pago no exterior).
    const COTACAO_VAZIA = { cotacao: '', iofTipo: 'percentual', iof: '', irTipo: 'percentual', ir: '', taxa: '', observacao: '' };
    const [cotacaoForm, setCotacaoForm] = useState(COTACAO_VAZIA);
    const abrirAprovarPlano = (plano) => { setPlanoAprovarModal(plano); setEnviarEmailFornecedorNF(false); setCotacaoForm(COTACAO_VAZIA); };
    const campoCotacao = (campo, valor) => setCotacaoForm((f) => Object.assign({}, f, { [campo]: valor }));

    const aprovarPlano = async () => {
        if (!planoAprovarModal) return;
        const baseCot = planoAprovarModal.cotacao_base;
        if (pendenciaCotacao(baseCot, cotacaoForm)) return;
        setSalvandoPlano(true);
        try {
            const res = await api({
                method: 'put',
                action: `/orcamentoPagamentoFornecedor/${planoAprovarModal.id}/aprovar`,
                token,
                data: Object.assign(
                    { enviar_email_fornecedor: enviarEmailFornecedorNF, observacao: cotacaoForm.observacao || '' },
                    baseCot && baseCot.pode_cotar ? {
                        cotacao: numeroCampo(cotacaoForm.cotacao),
                        iof_tipo: cotacaoForm.iofTipo, iof: numeroCampo(cotacaoForm.iof),
                        ir_tipo: cotacaoForm.irTipo, ir: numeroCampo(cotacaoForm.ir),
                        taxa_operacional: numeroCampo(cotacaoForm.taxa),
                    } : {}
                ),
            });
            const msgBackend = res?.data?.msg || 'Aprovado! Título financeiro criado.';
            const emailEnviado = res?.data?.data?.email_responsavel_enviado;
            const autoLiberado = !!res?.data?.data?.liberado_financeiro_at;
            // Mostra aviso se email não foi enviado (responsável sem email cadastrado)
            if (emailEnviado === false) {
                toast.warning(msgBackend);
            } else {
                toast.success(autoLiberado ? 'Aprovado e liberado para Contas Pendentes!' : msgBackend);
            }
            setPlanoAprovarModal(null);
            setEnviarEmailFornecedorNF(false);
            recarregarCustoPrevisto();
            if (autoLiberado) buscar();
        } catch (err) {
            toast.error('Erro ao aprovar: ' + (err.response?.data?.error ?? err.response?.data?.mensagem ?? 'Erro'));
        } finally {
            setSalvandoPlano(false);
        }
    };

    const reprovarPlano = async () => {
        if (!planoReprovarModal) return;
        setSalvandoPlano(true);
        try {
            await api({
                method: 'put',
                action: `/orcamentoPagamentoFornecedor/${planoReprovarModal.id}/reprovar`,
                token,
                data: { motivo: motivoReprovacaoPlano },
            });
            toast.success('Reprovado. Operador será notificado.');
            setPlanoReprovarModal(null);
            setMotivoReprovacaoPlano('');
            recarregarCustoPrevisto();
        } catch (err) {
            toast.error('Erro ao reprovar: ' + (err.response?.data?.error ?? 'Erro'));
        } finally {
            setSalvandoPlano(false);
        }
    };

    const buscarSaldosPorEvento = () => {
        api({ method: 'get', action: '/eventoConta/saldos', token: token, params: {} })
            .then((r) => {
                const mapa = {};
                ((r && r.data && r.data.data) || []).forEach((linha) => {
                    if (linha && linha.evento_id !== undefined && linha.evento_id !== null) {
                        mapa[String(linha.evento_id)] = linha;
                    }
                });
                setSaldosPorEvento(mapa);
            })
            // Silencioso de propósito: é informação complementar. Se falhar, o
            // Custo Previsto continua utilizável sem os números de adiantamento.
            .catch(() => { });
    };

    const buscarCustosPrevistos = (over) => {
        const fcp = Object.assign({}, filtroCustoPrevisto, over || {});
        setLoadingCustosPrevistos(true);
        buscarSaldosPorEvento();
        api({
            method: 'get',
            action: '/orcamento/itensPendentesNotaFiscal',
            token: token,
            params: {
                financeiro: true,
                evento: fcp.evento || undefined,
                orcamento: fcp.orcamento || undefined,
                dataPrevisao1: fcp.dataPrevisao1 ? dataMysql(fcp.dataPrevisao1) : undefined,
                dataPrevisao2: fcp.dataPrevisao2 ? dataMysql(fcp.dataPrevisao2) : undefined,
            }
        }).then((response) => {
            const itens = response?.data?.data || [];
            const itensSomenteCustoPrevisto = itens.filter((item) => !ehDiretoContasPendentesItem(item));
            setCustosPrevistos(itensSomenteCustoPrevisto);
        }).catch(() => {
            toast.error('Erro ao buscar custos previstos');
            setCustosPrevistos([]);
        }).finally(() => {
            setLoadingCustosPrevistos(false);
        });
    };

    // `f` só vem da aba Aprovados do Custo Previsto, a única que filtra
    // adiantamento. As outras abas chamam sem argumento e recebem a lista
    // inteira — inclusive para desfazer um filtro que ficou da aba anterior,
    // já que `adiantamentos` é um estado só, compartilhado.
    const buscarAdiantamentos = (f) => {
        setLoadingAdiantamentos(true);
        api({
            method: 'get',
            action: '/financeiroParcela',
            token: token,
            params: {
                tipo: 2,
                adiantamento: 1,
                clienteEvento: f && f.cliente ? f.cliente : undefined,
                buscaEvento: f && f.busca ? f.busca : undefined,
                // O período do adiantamento é o vencimento da parcela — é a data
                // que a tela já mostrava na coluna.
                dataVencimento1: f && f.de ? dataMysql(f.de) : undefined,
                dataVencimento2: f && f.ate ? dataMysql(f.ate) : undefined,
            }
        }).then(response => {
            setAdiantamentos(response?.data?.data || []);
        }).catch(() => {
            toast.error('Erro ao buscar adiantamentos');
            setAdiantamentos([]);
        }).finally(() => {
            setLoadingAdiantamentos(false);
        });
    };

    const abrirModalStatusPgto = (item) => {
        setModalStatusPgtoSel(item.status_pagamento || null);
        setModalStatusPgtoObs(item.status_pagamento_obs || '');
        setModalStatusPgto(item);
    };

    const fecharModalStatusPgto = () => {
        setModalStatusPgto(null);
        setModalStatusPgtoSel(null);
        setModalStatusPgtoObs('');
    };

    const salvarStatusPgto = () => {
        if (!modalStatusPgtoSel) { toast.warning('Selecione o status antes de salvar.'); return; }
        const parcelaId = modalStatusPgto._parcelaId;
        setSalvandoStatusPgto(prev => ({ ...prev, [parcelaId]: true }));
        api({
            method: 'put',
            action: '/financeiroParcela/' + parcelaId + '/statusPagamento',
            token: token,
            data: { status: modalStatusPgtoSel, observacao: modalStatusPgtoObs }
        }).then(() => {
            const label = modalStatusPgtoSel === 'creditado' ? 'Creditado' : 'Não Creditado';
            toast.success('Status atualizado: ' + label + '. E-mail enviado ao responsável do evento.');
            fecharModalStatusPgto();
            buscarAdiantamentos();
            // Creditado libera automaticamente para Contas Pendentes → atualiza a lista de parcelas
            if (modalStatusPgtoSel === 'creditado') { buscar(); }
        }).catch(() => {
            toast.error('Erro ao atualizar status do pagamento.');
        }).finally(() => {
            setSalvandoStatusPgto(prev => ({ ...prev, [parcelaId]: false }));
        });
    };

    // A API já diz exatamente o que falta ao liberar (trava de dados de pagamento:
    // 422 com `mensagem` e a lista `pendencias`). Engolir isso e mostrar só
    // "Erro ao liberar para pagamento" deixava o Financeiro sem saber o que fazer —
    // ainda por cima numa pendência que é do operador do evento, não dele.
    // Mesma frase que a API devolve no 422 da liberação — a listagem não repete a
    // mensagem, só as pendências, e as duas telas têm de falar igual.
    const MSG_SEM_DADOS_PGTO = 'Este fornecedor ainda não tem como ser pago. Peça ao operador do evento para completar os dados bancários na aba Efetivo.';
    // Plano aprovado sem parcela (aprovação leve): não existe título nem parcela para
    // ir a Contas Pendentes — liberar faria o plano sumir. Regra do Rafael (13/09).
    const MSG_SEM_PARCELAS = 'Este plano foi aprovado sem parcelas de pagamento. Peça ao operador do evento para montar as parcelas na Previsão de Pagamento e reenviar ao Financeiro — sem parcela nada entra em Contas Pendentes.';

    // Deduções/acréscimos da parcela (Roteiro T6, decisão Rafael 13/09): o porquê
    // de o valor pago diferir da nota. A nota vai ao cliente; isto é interno.
    // A API só devolve/grava para admin, diretor e financeiro (pode_deduzir).
    const TIPOS_DEDUCAO = [
        { value: 'irrf', label: 'IRRF', natureza: 'deducao' },
        { value: 'iss', label: 'ISS', natureza: 'deducao' },
        { value: 'pis', label: 'PIS', natureza: 'deducao' },
        { value: 'cofins', label: 'COFINS', natureza: 'deducao' },
        { value: 'csll', label: 'CSLL', natureza: 'deducao' },
        { value: 'inss', label: 'INSS', natureza: 'deducao' },
        { value: 'ibs', label: 'IBS', natureza: 'deducao' },
        { value: 'cbs', label: 'CBS', natureza: 'deducao' },
        { value: 'desconto', label: 'Desconto', natureza: 'deducao' },
        { value: 'bv', label: 'BV', natureza: 'deducao' },
        { value: 'juros', label: 'Juros', natureza: 'acrescimo' },
        { value: 'outros', label: 'Outros', natureza: null },
    ];
    const rotuloDeducao = (tipo) => { const t = TIPOS_DEDUCAO.find((x) => x.value === tipo); return t ? t.label : tipo; };
    const numBr = (v) => {
        if (v === null || v === undefined) return 0;
        const s = String(v).trim();
        if (!s) return 0;
        if (s.indexOf(',') >= 0) return parseFloat(s.replace(/\./g, '').replace(',', '.')) || 0;
        return parseFloat(s) || 0;
    };
    const fmtBr = (n) => (Math.round((n || 0) * 100) / 100).toFixed(2).replace('.', ',');
    // Valor em R$ de uma linha: digitado em R$, ou % sobre a base (nota / novo valor)
    const valorLinhaDeducao = (l, base) => (l.modo === 'percentual')
        ? Math.round(numBr(base) * numBr(l.percentual)) / 100
        : numBr(l.valor);
    // nota − deduções + acréscimos, nunca negativo (mesma conta da API)
    const calcularPagoDeducoes = (base, linhas) => Math.max(0, (linhas || []).reduce((t, l) => t + (l.natureza === 'acrescimo' ? valorLinhaDeducao(l, base) : -valorLinhaDeducao(l, base)), numBr(base)));
    // Saldo SEM piso: se der zero ou negativo, as deduções zeram/superam a nota e a
    // baixa é bloqueada (tela + API). Antes a API truncava em 0 e quitava a conta.
    const saldoDeducoes = (base, linhas) => (linhas || []).reduce((t, l) => t + (l.natureza === 'acrescimo' ? valorLinhaDeducao(l, base) : -valorLinhaDeducao(l, base)), numBr(base));
    // Motivo que impede o Pagar (aviso vermelho acima do botão + botão desabilitado;
    // a API repete a mesma conta). null = pode pagar.
    const motivoBloqueioPagar = (m) => {
        if (!m || !m.parcela) return null;
        const base = m.novoValor && m.novoValor.trim() !== '' ? numBr(m.novoValor) : numBr(m.parcela.valor);
        const linhas = (m.parcela.pode_deduzir && Array.isArray(m.deducoes))
            ? m.deducoes.filter(function (l) { return (l.modo === 'percentual' ? numBr(l.percentual) : numBr(l.valor)) !== 0; })
            : [];
        if (linhas.some(function (l) { return (l.modo === 'percentual' ? numBr(l.percentual) : numBr(l.valor)) < 0; })) {
            return 'Há linha de dedução com valor negativo. Para somar ao pagamento use Juros ou Outros como acréscimo.';
        }
        if (linhas.length > 0 && saldoDeducoes(base, linhas) <= 0) {
            return 'As deduções zeram ou superam a nota (R$ ' + fmtBr(base) + '): o valor a pagar ficaria R$ ' + fmtBr(saldoDeducoes(base, linhas)) + '. Corrija as linhas.';
        }
        if (m.valorPago && m.valorPago.trim() !== '' && numBr(m.valorPago) <= 0) {
            return 'O valor real pago precisa ser maior que zero.';
        }
        return null;
    };

    // Copiar a linha digitável: é o dado que vai colado no internet banking, e
    // ficava como texto solto no meio do resumo, para selecionar com o mouse.
    const copiarParaAreaDeTransferencia = (texto, mensagem) => {
        copiarTexto(texto).then(function (ok) {
            if (ok) { toast.success(mensagem); }
            else { toast.warning('Não foi possível copiar automaticamente. Selecione o texto e copie.'); }
        });
    };

    const mostrarPendenciasPagamento = (msg, pend) => {
        var esc = function(t) {
            return String(t).replace(/[&<>"]/g, function(c) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
            });
        };
        Alert({
            icon: 'error',
            confirmButton: 'Entendi',
            title: 'Falta completar os dados de pagamento',
            html: esc(msg)
                + '<div style="text-align:left;margin-top:14px">'
                + '<strong>O que está faltando:</strong>'
                + '<ul style="margin:6px 0 0 18px">'
                + pend.map(function(x) { return '<li>' + esc(x) + '</li>'; }).join('')
                + '</ul></div>'
        });
    };

    const mostrarErroLiberacao = (err) => {
        var d = (err && err.response && err.response.data) || {};
        var msg = d.mensagem || d.error || d.message || 'Erro ao liberar para pagamento.';
        var pend = Array.isArray(d.pendencias) ? d.pendencias : [];
        if (pend.length === 0) {
            toast.error(msg);
            return;
        }
        mostrarPendenciasPagamento(msg, pend);
    };

    // ─── Liberar para Contas Pendentes (aprovação financeiro pós-NF) ─────────────
    const liberarFinanceiro = (item) => {
        const key = item._key;
        setSalvandoLiberacao(function(prev) { return Object.assign({}, prev, { [key]: true }); });
        var action, data;
        if (item._tipo === 'previsao') {
            action = '/orcamentoPagamentoFornecedor/' + item._id + '/liberarFinanceiro';
            data   = {};
        } else {
            action = '/financeiroParcela/' + item._id + '/liberarFinanceiro';
            data   = {};
        }
        api({ method: 'put', action: action, token: token, data: data })
            .then(function(res) {
                var at = (res && res.data && res.data.liberado_financeiro_at) || true;
                toast.success('Liberado para Contas Pendentes!');
                if (item._tipo === 'previsao') {
                    recarregarCustoPrevisto();
                    buscar(); // atualiza Contas Pendentes imediatamente
                } else {
                    buscarAdiantamentos();
                }
            })
            .catch(mostrarErroLiberacao)
            .finally(function() {
                setSalvandoLiberacao(function(prev) { return Object.assign({}, prev, { [key]: false }); });
            });
    };

    // ─── Dar baixa num adiantamento creditado (Contas Pendentes → Contas Pagas) ───
    const darBaixaAdiantamento = (a) => {
        // Dia LOCAL: o toISOString() (UTC) virava o dia seguinte depois das 21h (06/10).
        var hoje = dataLocalMaisDias(0);
        var caixaAdtAtualId = String((a.caixa && a.caixa.id) ? a.caixa.id : (a.caixa || ''));
        var opsCaixaAdt = caixas.map(function(c) {
            var isCartao = parseFloat(c.cartaolimite || 0) > 0;
            var icon = isCartao ? '💳' : '🏦';
            var saldo = isCartao ? ' · Saldo: R$ ' + moeda(parseFloat(c.cartaosaldo || 0)) : '';
            var sel = String(c.id) === caixaAdtAtualId ? ' selected' : '';
            return '<option value="' + c.id + '"' + sel + '>' + icon + ' ' + c.nome + saldo + '</option>';
        }).join('');
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Dar baixa</>,
            denyButton: "Cancelar",
            title: "Dar baixa no adiantamento",
            html:
                '<div class="form-group">' +
                '<label>Pagar com:</label>' +
                '<select id="caixaBaixaAdtId" class="form-control">' +
                '<option value="">-- Selecione --</option>' +
                opsCaixaAdt +
                '</select>' +
                '</div>' +
                '<div class="form-group mt-2">' +
                '<label>Data Pagamento:</label>' +
                '<input type="date" id="dataBaixaAdt" class="form-control" value="' + hoje + '" />' +
                '</div>' +
                '<div class="form-group mt-2">' +
                '<label>Valor: <strong>R$ ' + moeda(parseFloat(a.valor || 0)) + '</strong></label>' +
                '</div>',
            callBack: function(result) {
                if (result.isConfirmed) {
                    var dataPagamento = document.getElementById('dataBaixaAdt')
                        ? document.getElementById('dataBaixaAdt').value : hoje;
                    var caixaSelecionado = document.getElementById('caixaBaixaAdtId')
                        ? document.getElementById('caixaBaixaAdtId').value : '';
                    if (!caixaSelecionado) {
                        toast.error('Selecione o cartão ou conta para realizar o pagamento.');
                        return;
                    }
                    api({
                        method: 'put',
                        action: '/financeiroParcela/' + a.id,
                        token: token,
                        data: { situacao: "2", pagamento: dataPagamento, caixa: caixaSelecionado }
                    }).then(function() {
                        toast.success('Adiantamento baixado com sucesso!');
                        buscarAdiantamentos();
                        buscar();
                        buscarCaixas();
                    }).catch(function(err) {
                        var msg = (err.response && err.response.data && (err.response.data.error || err.response.data.message))
                            ? (err.response.data.error || err.response.data.message)
                            : 'Erro ao dar baixa.';
                        toast.error(msg);
                    });
                }
            }
        });
    };

    // ─── Download autenticado de NF (usa /api/arquivo/download/{id}) ────────────
    const baixarArquivoNF = async (arquivoId, nomeArquivo) => {
        if (!arquivoId) { toast.error('Arquivo não encontrado.'); return; }
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + '/arquivo/download/' + arquivoId,
                { headers: { Authorization: 'Bearer ' + token }, responseType: 'blob' }
            );
            var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            var linkEl  = document.createElement('a');
            linkEl.href = blobUrl;
            linkEl.setAttribute('download', nomeArquivo || 'nota_fiscal');
            document.body.appendChild(linkEl);
            linkEl.click();
            linkEl.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            toast.error('Erro ao baixar o arquivo.');
        }
    };

    // ─── Solicitar NF ao fornecedor (seção Aprovados — Aguardando NF) ─────────
    const abrirSolicitarNFUnif = (item) => {
        // Usa o e-mail já normalizado no shape — disponível para previsão e adiantamento
        const emailSalvo = item.fornecedor_email || '';
        const lista = emailSalvo
            ? emailSalvo.split(',').map(function(e) { return e.trim(); }).filter(Boolean)
            : [''];
        setEmailsSolicitarNFUnif(lista);
        setParcelasSolicitarNFUnif(pedidoPadrao(nfParcelasDoItem(item)));
        setSolicitarNFUnifModal(item);
    };

    const enviarSolicitacaoNFUnif = async () => {
        const emails = emailsSolicitarNFUnif.map(function(e) { return e.trim(); }).filter(Boolean);
        if (emails.length === 0) { toast.error('Adicione ao menos um e-mail.'); return; }
        if (!solicitarNFUnifModal) return;
        var tipoItem = solicitarNFUnifModal._tipo;
        var planoNf = nfParcelasDoItem(solicitarNFUnifModal);
        if (planoNf.length && !parcelasSolicitarNFUnif.length) { toast.error('Marque ao menos uma parcela para pedir a nota.'); return; }
        setEnviandoNFSolicitacaoUnif(true);
        try {
            // Ambos os endpoints enviam e-mail imediato ao fornecedor
            // Previsão → OPF solicitarNF (cria SolicitacaoNF com link de upload)
            // Adiantamento → FinanceiroParcela solicitarNF (e-mail direto)
            const action = tipoItem === 'previsao'
                ? '/orcamentoPagamentoFornecedor/' + solicitarNFUnifModal._id + '/solicitarNF'
                : '/financeiroParcela/' + solicitarNFUnifModal._id + '/solicitarNF';
            const res = await api({ method: 'put', action, token,
                data: { emails, parcelas: planoNf.length ? ordenarPeloPlano(planoNf, parcelasSolicitarNFUnif) : undefined } });
            // email_enviado e mensagem podem estar em res.data ou res.data.data
            var topLevel = (res && res.data) ? res.data : {};
            var nested = (topLevel.data && typeof topLevel.data === 'object') ? topLevel.data : {};
            var emailEnviado = (topLevel.email_enviado !== undefined) ? topLevel.email_enviado : nested.email_enviado;
            var msg = topLevel.mensagem || nested.mensagem || (emailEnviado ? 'Solicitação enviada.' : 'Não foi possível enviar o e-mail.');
            if (emailEnviado === false) {
                toast.warning(msg);
            } else {
                toast.success(msg);
            }
            setSolicitarNFUnifModal(null);
            recarregarCustoPrevisto();
            if (tipoItem === 'adiantamento') {
                buscarAdiantamentos();
            }
        } catch (err) {
            const errMsg = (err.response && err.response.data && (err.response.data.mensagem || err.response.data.error))
                ? (err.response.data.mensagem || err.response.data.error)
                : 'Erro ao enviar solicitação.';
            toast.error(errMsg);
        } finally {
            setEnviandoNFSolicitacaoUnif(false);
        }
    };

    // ─── Confirmar pagamento da parcela (modal .fin-pp) ─────────────────────
    const confirmarPagamento = () => {
        if (!pagarModal) return;
        if (salvandoPagamento) return; // duplo clique: a API também trava, mas nem chega lá
        if (!pagarModal.caixa) {
            toast.error('Selecione o cartão ou conta para realizar o pagamento.');
            return;
        }
        const bloqueio = motivoBloqueioPagar(pagarModal);
        if (bloqueio) { toast.error(bloqueio); return; }
        setSalvandoPagamento(true);
        const payload = { situacao: "2", pagamento: pagarModal.dataPagamento || dataMysql(dados.pagamento), caixa: pagarModal.caixa };
        if (pagarModal.novoValor && pagarModal.novoValor.trim() !== '') {
            payload.novo_valor = pagarModal.novoValor;
        }
        if (pagarModal.valorPago && pagarModal.valorPago.trim() !== '') {
            payload.valor_pago = pagarModal.valorPago;
        }
        if (pagarModal.parcela?.pode_deduzir && Array.isArray(pagarModal.deducoes)) {
            payload.deducoes = pagarModal.deducoes
                .filter(function (l) { return l.modo === 'percentual' ? numBr(l.percentual) > 0 : numBr(l.valor) > 0; })
                .map(function (l) { return { tipo: l.tipo, natureza: l.natureza, modo: l.modo || 'valor', percentual: l.percentual || '', descricao: l.descricao || '', valor: l.valor }; });
        }
        api({ method: 'put', action: '/financeiroParcela/' + pagarModal.parcela.id, token: token, data: payload })
            .then(function () {
                setPagarModal(null);
                buscar();
                buscarCaixas();
                toast.success('Parcela paga com sucesso!');
            })
            .catch(function (error) {
                const errorMessage = error.response?.data?.error ?? error.response?.data?.message ?? "Erro desconhecido";
                toast.error('Erro ao pagar parcela: ' + errorMessage);
                // 10/10 (item 23): a conta já saiu de Contas Pendentes (voltou para o Custo Previsto) e a
                // tela estava velha — sem websocket, recarrega para ela sumir.
                if (/Atualize a tela/.test(errorMessage)) { setPagarModal(null); buscar(); }
            })
            .finally(function () { setSalvandoPagamento(false); });
    };

    // ─── Vincular NF internamente (seção Aprovados — Aguardando NF) ──────────
    const abrirVincularNFModal = (item) => {
        setVincularNFFile(null);
        setVincularNFTipoDoc('nf');
        setVincularNFNumero('');
        setVincularNFObs('');
        setParcelasVincularNF(notaPadrao(nfParcelasDoItem(item)));
        setVincularNFModal(item);
    };

    const submeterVincularNF = async () => {
        if (!vincularNFModal || !vincularNFFile) { toast.error('Selecione um arquivo.'); return; }
        if (!vincularNFNumero.trim()) { toast.error('Informe o número do documento fiscal.'); return; }
        const planoNf = nfParcelasDoItem(vincularNFModal);
        if (planoNf.length && !parcelasVincularNF.length) { toast.error('Marque a(s) parcela(s) que esta nota cobre.'); return; }
        setSalvandoVincularNF(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            const formData = new FormData();
            formData.append('arquivo_nf', vincularNFFile);
            formData.append('tipo_documento', vincularNFTipoDoc);
            formData.append('numero_referencia', vincularNFNumero.trim());
            if (vincularNFObs.trim()) { formData.append('observacao', vincularNFObs.trim()); }
            ordenarPeloPlano(planoNf, parcelasVincularNF).forEach(function (id) { formData.append('parcelas[]', id); });
            // Rotas sem prefixo /api/ — igual ao padrão do api service deste projeto
            const urlVincular = vincularNFModal._tipo === 'previsao'
                ? apiUrl + '/orcamentoPagamentoFornecedor/' + vincularNFModal._id + '/vincularNFInterno'
                : apiUrl + '/financeiroParcela/' + vincularNFModal._id + '/vincularNFInterno';
            const resVincular = await axios.post(
                urlVincular,
                formData,
                { headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' } }
            );
            toast.success('Nota fiscal vinculada com sucesso!');
            // Atualização otimista: marcar nota_fiscal_id para que nf_vinculada=true enquanto
            // o refetch não chega. Não tocamos em arquivonotafiscal para evitar usar
            // nota_fiscal_id no lugar de arquivo_id no link de download.
            if (vincularNFModal._tipo !== 'previsao') {
                var _nfId = (resVincular.data && resVincular.data.nota_fiscal_id)
                    ? String(resVincular.data.nota_fiscal_id) : 'vinculado';
                setAdiantamentos(function(prev) {
                    return prev.map(function(a) {
                        if (String(a.id) === String(vincularNFModal._id)) {
                            return Object.assign({}, a, { nota_fiscal_id: _nfId });
                        }
                        return a;
                    });
                });
            }
            setVincularNFModal(null);
            recarregarCustoPrevisto();
            buscarAdiantamentos();
        } catch (err) {
            const msg = (err.response && err.response.data && err.response.data.mensagem)
                ? err.response.data.mensagem
                : 'Erro ao vincular nota fiscal.';
            toast.error(msg);
        } finally {
            setSalvandoVincularNF(false);
        }
    };

    const buscarCaixas = () => {
        setCarregandoCaixas(true);
        api({
            method: 'get',
            action: '/financeiroCaixa',
            token: token,
            params: { empresa: empresa }
        })
            .then(response => { setCaixas(response.data.data || []); })
            .catch(() => {})
            .finally(() => setCarregandoCaixas(false));
        // Saldo REAL do banco = razão (movimentos), não o cartaosaldo estático (que não muda ao pagar).
        api({ method: 'get', action: '/financeiroMovimentoCaixa/saldos', token: token })
            .then(response => { setSaldosLedger(response.data.data || {}); })
            .catch(() => {});
    };

    const abrirModalNFRetroativa = (item) => {
        setItemNFRetroativa(item);
        setArquivosNFRetroativa([]);
        setShowModalNFRetroativa(true);
    };

    const fecharModalNFRetroativa = () => {
        setShowModalNFRetroativa(false);
        setItemNFRetroativa(null);
        setArquivosNFRetroativa([]);
    };

    const enviarNFRetroativa = async () => {
        const eventoId = itemNFRetroativa?.orcamento?.evento?.id;
        const orcamentoId = itemNFRetroativa?.orcamento?.id;
        const fornecedorId = itemNFRetroativa?.fornecedorpagamento?.id || itemNFRetroativa?.fornecedor?.id;

        if (!eventoId || !orcamentoId || !fornecedorId) {
            toast.error('Não foi possível identificar evento, orçamento ou fornecedor para este item');
            return;
        }

        if (arquivosNFRetroativa.length === 0) {
            toast.error('Selecione ao menos um arquivo de nota fiscal');
            return;
        }

        try {
            setEnviandoNFRetroativa(true);
            const formData = new FormData();
            formData.append('evento_id', eventoId);
            formData.append('orcamento_id', orcamentoId);
            formData.append('fornecedor_id', fornecedorId);
            formData.append('item_orcamento_id', itemNFRetroativa?.id);
            arquivosNFRetroativa.forEach((arquivo) => {
                formData.append('arquivo_nf[]', arquivo);
            });

            const response = await axios({
                method: 'post',
                url: process.env.REACT_APP_API_URL + '/admin/nf-retroativa/upload',
                data: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data?.sucesso) {
                toast.success(response.data?.mensagem || 'Nota fiscal enviada com sucesso');
                fecharModalNFRetroativa();
                buscar();
                buscarCustosPrevistos();
            } else {
                toast.error(response.data?.mensagem || 'Erro ao enviar nota fiscal');
            }
        } catch (error) {
            toast.error(error.response?.data?.mensagem || 'Erro ao enviar nota fiscal');
        } finally {
            setEnviandoNFRetroativa(false);
        }
    };

    const alternarTipoDocumentoExportacao = (tipo) => {
        setFiltroExportacaoContasPagas((atual) => {
            const tiposAtuais = atual.tiposDocumento || [];

            if (tipo === 'todas') {
                return {
                    ...atual,
                    tiposDocumento: tiposAtuais.includes('todas') ? [] : ['todas'],
                };
            }

            const tiposSemTodas = tiposAtuais.filter((item) => item !== 'todas');
            const tipoJaSelecionado = tiposSemTodas.includes(tipo);

            return {
                ...atual,
                tiposDocumento: tipoJaSelecionado
                    ? tiposSemTodas.filter((item) => item !== tipo)
                    : [...tiposSemTodas, tipo],
            };
        });
    };

    const abrirModalExportarContasPagas = () => {
        setFiltroExportacaoContasPagas({
            tiposDocumento: ['todas'],
            vinculos: ['eventos'],
            periodo: 'mes_atual',
            dataInicial: null,
            dataFinal: null,
            formato: 'pdf',
        });
        setShowModalExportarContasPagas(true);
    };

    const fecharModalExportarContasPagas = () => {
        if (exportandoContasPagas) return;
        setShowModalExportarContasPagas(false);
    };

    const exportarContasPagasExcel = async () => {
        try {
            setExportandoPlanilhaContabilidade(true);

            const payload = {
                empresa: filtro.empresa,
                tipo: filtro.tipo,
                conta: filtro.conta || undefined,
                grupoTitulo: grupoTitulo || undefined,
                idTitulo: filtro.idTitulo || undefined,
                parcelaabater: parcelaabater || undefined,
                participante: filtro.participante || undefined,
                descricao: filtro.descricao || undefined,
                dataVencimento1: filtro.dataVencimento1 ? dataMysql(filtro.dataVencimento1) : undefined,
                dataVencimento2: filtro.dataVencimento2 ? dataMysql(filtro.dataVencimento2) : undefined,
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/financeiroParcela/exportarContasPagasExcel`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                let mensagemErro = 'Falha ao gerar a planilha de contabilidade.';
                const errorText = await response.text();

                if (errorText) {
                    try {
                        const errorJson = JSON.parse(errorText);
                        mensagemErro = errorJson.message || errorJson.error || mensagemErro;
                    } catch (error) {
                        mensagemErro = errorText;
                    }
                }

                throw new Error(mensagemErro);
            }

            const blob = await response.blob();
            const contentDisposition = response.headers.get('content-disposition') || '';
            const nomeArquivoMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const nomeArquivo = (nomeArquivoMatch?.[1] || 'Contas-Pagas-Classificacao-Fiscal.xlsx').replace(/['"]/g, '');

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error(error.message || 'Erro ao gerar a planilha de contabilidade.');
        } finally {
            setExportandoPlanilhaContabilidade(false);
        }
    };

    const exportarArquivosContasPagas = async () => {
        if ((filtroExportacaoContasPagas.tiposDocumento || []).length === 0) {
            toast.error('Selecione ao menos um tipo de documento');
            return;
        }

        if ((filtroExportacaoContasPagas.vinculos || []).length === 0) {
            toast.error('Selecione ao menos um tipo de vínculo');
            return;
        }

        if (
            filtroExportacaoContasPagas.periodo === 'periodo_selecionado' &&
            !filtroExportacaoContasPagas.dataInicial &&
            !filtroExportacaoContasPagas.dataFinal
        ) {
            toast.error('Informe a data inicial e/ou final do período');
            return;
        }

        try {
            setExportandoContasPagas(true);
            const errosPorVinculo = [];
            let downloadsRealizados = 0;

            for (const vinculo of filtroExportacaoContasPagas.vinculos) {
                const payload = {
                    empresa: filtro.empresa,
                    tipo: filtro.tipo,
                    conta: filtro.conta || undefined,
                    grupoTitulo: grupoTitulo || undefined,
                    idTitulo: filtro.idTitulo || undefined,
                    parcelaabater: parcelaabater || undefined,
                    participante: filtro.participante || undefined,
                    descricao: filtro.descricao || undefined,
                    dataVencimento1: filtro.dataVencimento1 ? dataMysql(filtro.dataVencimento1) : undefined,
                    dataVencimento2: filtro.dataVencimento2 ? dataMysql(filtro.dataVencimento2) : undefined,
                    tipos_documento: filtroExportacaoContasPagas.tiposDocumento,
                    vinculo,
                    periodo: filtroExportacaoContasPagas.periodo,
                    data_pagamento_1: filtroExportacaoContasPagas.dataInicial ? dataMysql(filtroExportacaoContasPagas.dataInicial) : undefined,
                    data_pagamento_2: filtroExportacaoContasPagas.dataFinal ? dataMysql(filtroExportacaoContasPagas.dataFinal) : undefined,
                    formato: filtroExportacaoContasPagas.formato,
                };

                const response = await fetch(`${process.env.REACT_APP_API_URL}/financeiroParcela/exportarArquivosContasPagas`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': filtroExportacaoContasPagas.formato === 'zip' ? 'application/zip' : 'application/pdf',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    let mensagemErro = 'Falha ao exportar documentos.';
                    const errorText = await response.text();

                    if (errorText) {
                        try {
                            const errorJson = JSON.parse(errorText);
                            mensagemErro = errorJson.message || errorJson.error || mensagemErro;
                        } catch (error) {
                            mensagemErro = errorText;
                        }
                    }

                    errosPorVinculo.push({
                        vinculo,
                        mensagem: mensagemErro,
                    });
                    continue;
                }

                const blob = await response.blob();
                const contentDisposition = response.headers.get('content-disposition') || '';
                const nomeArquivoMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                const extensaoPadrao = filtroExportacaoContasPagas.formato === 'zip' ? 'zip' : 'pdf';
                const nomeArquivo = (nomeArquivoMatch?.[1] || `contas-pagas-notas-${vinculo}.${extensaoPadrao}`).replace(/['"]/g, '');

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = nomeArquivo;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                downloadsRealizados++;
            }

            if (downloadsRealizados === 0) {
                throw new Error(errosPorVinculo[0]?.mensagem || 'Erro ao exportar documentos.');
            }

            if (errosPorVinculo.length > 0) {
                const descricoes = errosPorVinculo.map(({ vinculo, mensagem }) => {
                    const nomeVinculo = vinculo === 'eventos' ? 'Parcelas com Evento' : 'Custos Empresa';
                    return `${nomeVinculo}: ${mensagem}`;
                });

                toast.warning(`Alguns arquivos não foram gerados. ${descricoes.join(' | ')}`);
            }

            setShowModalExportarContasPagas(false);
        } catch (error) {
            toast.error(error.message || 'Erro ao exportar documentos.');
        } finally {
            setExportandoContasPagas(false);
        }
    };

    const alternarVinculoExportacao = (vinculo) => {
        setFiltroExportacaoContasPagas((atual) => {
            const vinculosAtuais = atual.vinculos || [];
            const vinculoJaSelecionado = vinculosAtuais.includes(vinculo);

            return {
                ...atual,
                vinculos: vinculoJaSelecionado
                    ? vinculosAtuais.filter((item) => item !== vinculo)
                    : [...vinculosAtuais, vinculo],
            };
        });
    };

    const aprovarParcelas = () => {
        const parcelaIds = tableSelect.selectedRows.map(row => row.id);

        api({
            method: 'post',
            action: '/financeiroParcela/aprovar',
            token: token,
            data: {
                parcelaIds: parcelaIds,
                comentarios: comentarios
            }
        })
            .then(response => {
                const msg = response?.data?.msg || 'Parcelas aprovadas com sucesso!';
                const temErro = typeof msg === 'string' && (msg.includes('Erros:') || msg.startsWith('0 '));
                if (temErro) {
                    toast.warning(msg);
                } else {
                    toast.success(msg);
                }
                setShowModalAprovar(false);
                setComentarios('');
                if (abaAtiva === 'adiantamentos') buscarAdiantamentos();
                else buscar();
            })
            .catch(err => {
                toast.error('Erro ao aprovar parcelas: ' + (err.response?.data?.error ?? 'Erro desconhecido'));
            });
    };

    const reprovarParcelas = () => {
        if (!comentarios.trim()) {
            toast.error('É necessário informar comentários para a reprovação');
            return;
        }

        const parcelaIds = tableSelect.selectedRows.map(row => row.id);

        api({
            method: 'post',
            action: '/financeiroParcela/reprovar',
            token: token,
            data: {
                parcelaIds: parcelaIds,
                comentarios: comentarios
            }
        })
            .then(response => {
                const msg = response?.data?.msg || 'Parcelas reprovadas com sucesso!';
                const temErro = typeof msg === 'string' && (msg.includes('Erros:') || msg.startsWith('0 '));
                if (temErro) {
                    toast.warning(msg);
                } else {
                    toast.success(msg);
                }
                setShowModalReprovar(false);
                setComentarios('');
                if (abaAtiva === 'adiantamentos') buscarAdiantamentos();
                else buscar();
            })
            .catch(err => {
                toast.error('Erro ao reprovar parcelas: ' + (err.response?.data?.error ?? 'Erro desconhecido'));
            });
    };

    // (Treinamento 07/10 — lentidão) Havia aqui um segundo useEffect de "onload"
    // chamando buscar(): o efeito com [filtro.tipo, filtro.evento] mais abaixo já
    // roda na montagem, então a lista inteira de contas era baixada DUAS vezes.

    // onLoadingChange(bool): callback opcional chamado com true ao iniciar upload e false ao terminar
    const handleFileUpload = (acaoApi, dados, callBack, onLoadingChange) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.style.display = 'none';
        input.onchange = (e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (onLoadingChange) onLoadingChange(true);

            const token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('file', file);
            for (const [key, value] of Object.entries(dados)) {
                formData.append(key, value);
            }

            axios.post(
                process.env.REACT_APP_API_URL + '/' + acaoApi,
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                }
            )
                .then((response) => {
                    if (onLoadingChange) onLoadingChange(false);
                    if (callBack) callBack(response.data.data);
                    toast.success('Arquivo enviado com sucesso!');
                })
                .catch((error) => {
                    if (onLoadingChange) onLoadingChange(false);
                    toast.error('Erro ao enviar arquivo: ' + (error.response?.data?.error ?? "Erro desconhecido"));
                });
        };
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    };

    // ── Cartão de pagamento seguro (Contas Pendentes, espécie Cartão de Crédito) ──
    // Financeiro insere os dados → operador recebe e-mail de aviso com link (/pagamentoCartao/{id})
    // → na página, o operador pede o código, revela os dados, paga e anexa o comprovante.
    // O comprovante NÃO dá baixa: a parcela permanece pendente até o Financeiro confirmar pelo botão Pagar.
    const abrirCartaoSeguro = (row) => {
        setLoadingCartao(true);
        api({ method: 'get', action: '/financeiroParcelaCartao/' + row.id + '/contexto', token })
            .then(response => {
                const ctx = response.data;
                if (ctx.cartao) {
                    setCartaoStatusModal({ parcela: row, contexto: ctx });
                } else {
                    abrirInserirDadosCartao(row, ctx);
                }
            })
            .catch(() => toast.error('Erro ao carregar dados do cartão.'))
            .finally(() => setLoadingCartao(false));
    };

    const abrirInserirDadosCartao = (row, ctx) => {
        setFormCartao({ caixa_cartao_id: '', numero: '', titular: '', validade: '', cvv: '', operador_id: '', operador_email: ctx?.responsavel?.email ?? '' });
        // Cartões cadastrados no Caixa — pré-seleciona o primeiro (troca no dropdown; X = manual)
        api({ method: 'get', action: '/financeiroParcelaCartao/cartoesDisponiveis', token })
            .then(response => {
                const lista = response.data?.cartoes ?? [];
                setCartoesDisponiveis(lista);
                if (lista.length > 0) {
                    setFormCartao(f => ({ ...f, caixa_cartao_id: lista[0].id }));
                }
            })
            .catch(() => setCartoesDisponiveis([]));
        setCartaoModal({ parcela: row, contexto: ctx });
    };

    const salvarDadosCartao = () => {
        const parcela = cartaoModal?.parcela;
        if (!parcela) return;
        const usaCartaoCadastrado = !!formCartao.caixa_cartao_id;
        if (!usaCartaoCadastrado && (!formCartao.numero || !formCartao.titular || !formCartao.validade)) {
            toast.warning('Selecione um cartão cadastrado ou preencha os dados manualmente.');
            return;
        }
        if (!formCartao.cvv) {
            toast.warning('Informe o CVV do cartão.');
            return;
        }
        if (!formCartao.operador_id && !formCartao.operador_email) {
            toast.warning('Selecione o operador ou informe o e-mail que receberá o código.');
            return;
        }
        setLoadingCartao(true);
        api({
            method: 'post',
            action: '/financeiroParcelaCartao/' + parcela.id + '/inserirDados',
            token,
            data: {
                caixa_cartao_id: formCartao.caixa_cartao_id || null,
                numero: usaCartaoCadastrado ? null : formCartao.numero,
                titular: usaCartaoCadastrado ? null : formCartao.titular,
                validade: usaCartaoCadastrado ? null : formCartao.validade,
                cvv: formCartao.cvv,
                operador_id: formCartao.operador_id || null,
                operador_email: formCartao.operador_email || null,
            },
        })
            .then(response => {
                const avisoEnviado = response.data?.aviso_enviado;
                toast.success(avisoEnviado
                    ? 'Dados armazenados com segurança. O operador recebeu o aviso por e-mail.'
                    : 'Dados armazenados com segurança.');
                setCartaoModal(null);
                setFormCartao({ caixa_cartao_id: '', numero: '', titular: '', validade: '', cvv: '', operador_id: '', operador_email: '' });
                buscar();
            })
            .catch(error => {
                const m = error.response?.data?.mensagem ?? error.response?.data?.message ?? 'Erro ao salvar dados do cartão.';
                toast.error(m);
            })
            .finally(() => setLoadingCartao(false));
    };

    const reenviarAvisoCartao = (parcelaId) => {
        setLoadingCartao(true);
        api({ method: 'post', action: '/financeiroParcelaCartao/' + parcelaId + '/reenviarAviso', token, data: {} })
            .then(() => toast.success('Aviso reenviado ao e-mail do operador.'))
            .catch(error => {
                const m = error.response?.data?.mensagem ?? 'Erro ao reenviar o aviso.';
                toast.error(m);
            })
            .finally(() => setLoadingCartao(false));
    };

    // Banco recusou o cartão: marca como negado e LIBERA o envio de outro
    // (Rafael 2026-08-06: "a plataforma não aceitou o cartão mais"). O vínculo
    // parcela.cartao_id é o que trava o reenvio — negar solta ele. O registro do
    // cartão recusado fica no histórico: quem negou, quando e por quê.
    const negarCartao = (parcelaId, motivo) => {
        setLoadingCartao(true);
        api({ method: 'post', action: '/financeiroParcelaCartao/' + parcelaId + '/negar', token, data: { motivo: motivo || null } })
            .then(r => {
                toast.success(r.data?.mensagem ?? 'Cartão marcado como recusado.');
                setNegarCartaoModal(null);
                buscar(true);
            })
            .catch(error => toast.error(error.response?.data?.mensagem ?? 'Erro ao negar o cartão.'))
            .finally(() => setLoadingCartao(false));
    };

    // ── Tag "dados do cartão enviados ao operador" ───────────────────────────
    // Feedback visual pedido em 2026-08-04: o Financeiro enviava os dados e a
    // listagem não dava nenhum sinal — só existia a ação no menu. Mostra QUANDO,
    // POR QUEM e PARA QUEM (no title), além de reenvios e comprovante recebido.
    // `enviado_em`/`enviado_por` são colunas novas: registro antigo cai no created_at.
    const tagCartaoEnviado = (row) => {
        const c = row.cartao;
        if (!c) return null;
        const quando = c.enviado_em || c.created_at;
        const dataFmt = quando ? moment(quando).format('DD/MM/YYYY HH:mm') : null;
        const partes = [];
        if (dataFmt) partes.push('Enviado em ' + dataFmt);
        if (c.enviado_por) partes.push('por ' + c.enviado_por);
        if (c.operador_email) partes.push('para ' + c.operador_email);
        if (c.reenvios > 0) {
            partes.push('Reenviado ' + c.reenvios + (c.reenvios === 1 ? ' vez' : ' vezes')
                + (c.reenviado_em ? ' — último em ' + moment(c.reenviado_em).format('DD/MM/YYYY HH:mm') : ''));
        }
        return (
            <div className="mt-1" style={{ lineHeight: 1.4 }}>
                <span className="fin-pp__minitag is-info" title={partes.join(' · ')} style={{ cursor: 'help' }}>
                    💳 Cartão enviado{dataFmt ? ' · ' + moment(quando).format('DD/MM HH:mm') : ''}
                </span>
                {c.enviado_por && (
                    <div className="fin-pp__cell-muted" style={{ fontSize: '0.66rem' }}>por {c.enviado_por}</div>
                )}
                {c.reenvios > 0 && (
                    <div className="fin-pp__cell-muted" style={{ fontSize: '0.66rem' }}>
                        {c.reenvios} reenvio{c.reenvios === 1 ? '' : 's'}
                    </div>
                )}
                {c.arquivo_comprovante_id && (
                    <span className="fin-pp__minitag is-ok" style={{ marginTop: 2 }}>✓ Comprovante recebido</span>
                )}
            </div>
        );
    };

    // ── Composição do adiantamento na parcela ────────────────────────────────
    // "Bruto − Adiantamento = A pagar", visível em TODOS os estados da parcela
    // (Pendentes e Pagas) — sem isto, a Katia via 7.220 pagos em Contas Pagas e
    // não sabia dos 700 que saíram do adiantamento (Rafael 2026-08-04).
    // O líquido só é calculado quando o fornecedor tem 1 parcela; com N parcelas
    // o valor (que é POR FORNECEDOR) apareceria abatido N vezes.
    const tagAdiantamentoParcela = (row) => {
        const ad = row.adiantamento_fornecedor;
        if (!ad || !(ad.valor > 0)) return null;
        const pago = (row.situacao === '2' || row.situacao === 2);
        // D-0095: o adiantamento vem POR PARCELA (o Eventos escolheu no Efetivo). Conta sem parte não
        // mostra nada; fornecedor ainda "sem parcela" (legado) mostra o total, sem conta.
        const parte = parteAdiantamentoDaConta(ad);
        const semParcela = !!ad.sem_parcela || (ad.valor_parcela === undefined && parte === null);
        if (parte === null && !semParcela) return null;
        const liquido = parte !== null ? Math.max(0, (parseFloat(row.valor) || 0) - parte) : null;
        const eventoId = row.titulo?.evento?.id || null;
        // Sem `nowrap`: a coluna VALOR é estreita e o texto passava POR BAIXO do
        // botão de ações da linha. Deixa quebrar dentro da própria célula.
        return (
            <div className="mt-1" style={{ fontSize: '0.66rem', lineHeight: 1.4, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <div style={{ color: '#0369a1' }}>
                    {parte !== null
                        ? <>🟠 Adiantamento − {moeda(parte)} nesta parcela</>
                        : <>🟠 Adiantamento {moeda(ad.valor)} do fornecedor (sem parcela)</>}
                </div>
                {parte !== null && !pago && (
                    <div style={{ color: '#059669', fontWeight: 700 }}>A pagar: {moeda(liquido)}</div>
                )}
                {parte !== null && !pago && liquido <= 0 && (
                    <div style={{ color: '#a85b07', fontWeight: 600 }}>Coberta · em aberto até a baixa</div>
                )}
                <Link to={'/financeiroSaldoAdiantamento' + (eventoId ? '?evento=' + eventoId : '')}
                    style={{ fontSize: '0.64rem' }} onClick={(e) => e.stopPropagation()}
                    title="Ver extrato do adiantamento deste evento">
                    ver extrato
                </Link>
            </div>
        );
    };

    // ── Documentos da parcela (1:N) ──────────────────────────────────────────
    // A coluna Arquivos mostrava um FormButton por tipo, e cada um baixava o
    // arquivo ÚNICO legado (financeiroparcela.arquivonotafiscal etc.). Desde o
    // PLANO-documentos-multiplos a parcela pode ter VÁRIOS documentos do mesmo
    // tipo — que ficavam invisíveis aqui. Agora um botão só abre o modal com a
    // lista real, vinda de /financeiroParcela/{id}/arquivos.
    const TIPOS_DOC = [
        { key: 'notafiscal', rotulo: 'Nota Fiscal', icone: <FaFileAlt size={13} /> },
        { key: 'boleto', rotulo: 'Boleto', icone: <FaFileInvoice size={13} /> },
        { key: 'comprovantepagamento', rotulo: 'Comprovante', icone: <FaFileInvoiceDollar size={13} /> },
        { key: 'reciboadiantamento', rotulo: 'Recibo', icone: <FaFileAlt size={13} /> },
    ];

    const temAlgumDocumento = (row) => !!(
        (row.arquivoboleto && row.arquivoboleto.id)
        || (row.arquivocomprovantepagamento && row.arquivocomprovantepagamento.id)
        || (row.arquivonotafiscal && row.arquivonotafiscal.id)
        || (row.arquivoreciboadiantamento && row.arquivoreciboadiantamento.id)
    );

    const abrirModalArquivos = (row) => {
        setModalArquivos({ row: row, carregando: true, docs: null });
        api({ method: 'get', action: '/financeiroParcela/' + row.id + '/arquivos', token: localStorage.getItem('token') })
            .then((response) => setModalArquivos({ row: row, carregando: false, docs: response.data?.data ?? null }))
            .catch(() => setModalArquivos({ row: row, carregando: false, docs: null }));
    };

    // Invoice do fornecedor pago no exterior (01/10): vem do plano (Previsão Inter) e vale como NF e dados de pagamento.
    const invoicesDaParcela = (row) => (Array.isArray(row && row.invoices) ? row.invoices : []);

    const celulaArquivos = (row) => {
        const invoices = invoicesDaParcela(row);
        if (!temAlgumDocumento(row) && invoices.length === 0) return <span className="fin-pp__cell-muted">—</span>;
        return (
            <div className="d-flex flex-wrap gap-1">
                {invoices.map((inv) => (
                    <button key={inv.id} type="button" className="fin-pp__btn fin-pp__btn--sm"
                        title={'Invoice anexada pelo Eventos: ' + inv.nome} aria-label={'Baixar invoice ' + inv.nome}
                        onClick={() => baixarArquivoNF(inv.arquivo_id, inv.nome)}>
                        <FaFileInvoice size={14} /> Invoice
                    </button>
                ))}
                {temAlgumDocumento(row) && (
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                        title="Ver documentos da parcela" aria-label="Ver documentos da parcela"
                        onClick={() => abrirModalArquivos(row)}>
                        <FaFileAlt size={14} /> Ver
                    </button>
                )}
                {/* Conferência automática da NF (item 21) — só aviso */}
                <NfValidacaoPill validacao={row.nf_validacao} />
            </div>
        );
    };

    // D-0097: clique na linha do adiantamento abre a tela de detalhe (menos em botão/link da linha).
    const abrirDetalheAdiantamento = (e, id) => {
        if (e && cliqueEmControle(e.target)) return;
        history.push(rotaDetalheAdiantamento(id));
    };
    // D-0097: idem para a previsão (plano/OPF) do Custo Previsto — Planos de Pagamento e Aprovados.
    const abrirDetalhePrevisao = (e, id) => {
        if (e && cliqueEmControle(e.target)) return;
        history.push(rotaDetalhePrevisao(id));
    };

    const renderActionDropdown = (row) => {
        const actions = [];

        // D-0097: o ⋮ também leva à tela de detalhe (a mesma do clique na linha).
        actions.push({
            type: 'action',
            label: 'Detalhes',
            icon: <FaSearch size={14} />,
            description: 'Abre a tela da conta: dados, como pagar, rastreio e documentos',
            onClick: () => history.push('/financeiroParcelaDetalhe/' + row.id)
        });

        // Parcela paga → "Voltar para Pendentes" (estorna pagamento, restaura caixa, situacao 2→1).
        // Parcela não paga → mantém "Alterar" desabilitado (fluxo passa pelo Custo Previsto).
        if (row.situacao === '2' || row.situacao === 2) {
            actions.push({
                type: 'action',
                label: 'Voltar para Pendentes',
                icon: <FaSync size={14} />,
                onClick: () => {
                    Alert({
                        icon: 'warning',
                        confirmButton: <><FaSync size={18} /> Voltar para Pendentes</>,
                        denyButton: 'Cancelar',
                        title: 'Voltar para Contas Pendentes',
                        html: 'A parcela voltará para <strong>Contas Pendentes</strong>: o pagamento será estornado e o saldo do caixa restaurado.',
                        callBack: (result) => {
                            if (!result.isConfirmed) return;
                            if (estornandoRef.current[row.id]) return; // duplo clique: a API também trava
                            estornandoRef.current[row.id] = true;
                            api({
                                method: 'put',
                                action: '/financeiroParcela/estornar/' + row.id,
                                token: token,
                                data: {}
                            })
                                .then(function () {
                                    buscar();
                                    buscarCaixas();
                                    toast.success('Parcela retornada para Contas Pendentes.');
                                })
                                .catch(function (error) {
                                    const m = error.response?.data?.error ?? error.response?.data?.message ?? 'Erro desconhecido';
                                    toast.error('Erro ao voltar para pendentes: ' + m);
                                })
                                .finally(function () { delete estornandoRef.current[row.id]; });
                        }
                    });
                }
            });
        } else {
            actions.push({
                type: 'action',
                label: 'Alterar',
                icon: <FaPen size={14} />,
                disabled: true,
                onClick: () => {}
            });
        }

        // Pagar (em aberto; se vinculado a orçamento, exige NF; se não vinculado, não exige)
        const temVinculoOrcamento = (row.titulo?.orcamento_item?.length ?? 0) > 0;
        const temNotaFiscal = temVinculoOrcamento ? row.titulo.orcamento_item.some(item => !!item.arquivonotafiscal) : false;
        const parcelaTemNotaFiscal = !!(row?.arquivonotafiscal?.id || row?.arquivonotafiscal);
        const diretoContasPendentes = ehDiretoContasPendentesParcela(row);
        const situacaoAberta = (row.situacao === "1" || row.situacao === 1);
        const isUrgente = row.pagamentourgente === true || row.pagamentourgente === 1 || row.pagamentourgente === '1';
        const isAprovada = row.dataAprovacaoDiretor;
        const isReprovada = row.dataReprovacaoDiretor;

        const liberadoFinanceiro = !!row.liberado_financeiro_at;
        // Permite pagar se: aberto E (liberado pelo financeiro OU tipo direto Hospedagem/A&B)
        if (situacaoAberta && (liberadoFinanceiro || diretoContasPendentes)) {
            actions.push({
                type: 'action',
                label: 'Pagar',
                icon: <FaThumbsUp size={14} />,
                onClick: () => {
                    const parcela = row;
                    
                    // Validação: Parcelas urgentes só podem ser pagas se aprovadas pelo diretor
                    if (isUrgente && !isAprovada) {
                        Alert({
                            icon: "warning",
                            confirmButton: "Entendi",
                            title: "Parcela Urgente",
                            html: "Esta parcela é urgente e precisa ser aprovada pelo diretor antes de ser paga."
                        });
                        return;
                    }
                    
                    // Validação: Parcelas reprovadas não podem ser pagas
                    if (isReprovada) {
                        const motivo = parcela.motivoReprovacaoDiretor || row.motivoReprovacaoDiretor;
                        Alert({
                            icon: "error",
                            confirmButton: "Entendi",
                            title: "Parcela Reprovada",
                            html: `Esta parcela foi reprovada pelo diretor e não pode ser paga.${motivo ? `<br/><br/><strong>Motivo:</strong> ${motivo}` : ''}`
                        });
                        return;
                    }

                    var caixaAtualId = String((parcela.caixa && parcela.caixa.id) ? parcela.caixa.id : (parcela.caixa || ''));
                    // Adiantamento atribuído a ESTA parcela no Efetivo (D-0095): o que sai do
                    // banco é o LÍQUIDO — pré-preenche para a Katia não pagar o bruto
                    // por esquecimento. Editável, como qualquer novo valor. Coberta 100%
                    // vem 0,00 e só fica paga quando o Financeiro confirmar aqui.
                    var parteAd = parteAdiantamentoDaConta(parcela.adiantamento_fornecedor);
                    // Sem separador de milhar: o backend agora aceita os dois formatos,
                    // mas o campo é texto livre e valor cru não deixa margem a erro.
                    var novoValorLiquido = parteAd !== null
                        ? Math.max(0, (parseFloat(parcela.valor) || 0) - parteAd).toFixed(2).replace('.', ',')
                        : '';
                    // Deduções: reabre as já lançadas; sem nenhuma, pré-carrega as
                    // retenções calculadas na NF do fornecedor (o Financeiro só acrescenta
                    // desconto/BV/juros). Só chega preenchido para quem pode deduzir.
                    var reabreDeducoes = !!(parcela.deducoes && parcela.deducoes.length);
                    var linhasDeducao = parcela.pode_deduzir
                        ? (reabreDeducoes ? parcela.deducoes : (parcela.retencoes_nf || []))
                            .map(function (d) {
                                return {
                                    tipo: d.tipo, natureza: d.natureza || 'deducao', descricao: d.descricao || '',
                                    modo: d.modo === 'percentual' ? 'percentual' : 'valor',
                                    percentual: d.percentual !== null && d.percentual !== undefined ? String(d.percentual).replace('.', ',') : '',
                                    valor: fmtBr(d.valor),
                                };
                            })
                        : [];
                    var basePago = novoValorLiquido !== '' ? novoValorLiquido : parcela.valor;
                    // Parcela (quase) coberta pelo adiantamento: as retenções são da NF inteira e, sobre
                    // um novo valor pequeno, "zeram a nota" e travariam o Pagar — só pré-carrega se couber.
                    if (!reabreDeducoes && parteAd !== null && linhasDeducao.length > 0 && saldoDeducoes(basePago, linhasDeducao) <= 0) {
                        linhasDeducao = [];
                    }
                    setPagarModal({
                        parcela: parcela,
                        caixa: caixaAtualId,
                        dataPagamento: dataMysql(dados.pagamento),
                        novoValor: novoValorLiquido,
                        deducoes: linhasDeducao,
                        valorPago: linhasDeducao.length > 0 ? fmtBr(calcularPagoDeducoes(basePago, linhasDeducao)) : '',
                        valorPagoEditado: false,
                    });
                }
            });
        }

        // Cartão de pagamento seguro — parcelas pendentes com espécie Cartão de Crédito (id 3)
        const especieIdRow = String(row.especie?.id ?? row.especie ?? '');
        // D-0116: cartão físico já foi pago na loja pelo operador — não há cartão a enviar (API recusa com 422).
        if (situacaoAberta && (liberadoFinanceiro || diretoContasPendentes) && especieIdRow === '3' && !ehCartaoFisico(row.efetivo_forma)) {
            actions.push({
                type: 'action',
                label: 'Cartão — pagamento seguro',
                icon: <FaCreditCard size={14} />,
                description: row.cartao_id
                    ? 'Dados armazenados — enviar código, ver dados ou anexar comprovante'
                    : 'Inserir dados do cartão para o operador do evento pagar o fornecedor',
                onClick: () => abrirCartaoSeguro(row)
            });
        }

        // Estornar — desabilitado temporariamente
        actions.push({
            type: 'action',
            label: 'Estornar',
            icon: <FaThumbsDown size={14} />,
            disabled: true,
            onClick: () => {}
        });

        // "Travar para pagamento" (Rafael 07/10): o Financeiro avisa que vai pagar; o Eventos para de mexer.
        if (PERFIS_TRAVAR_PAGAMENTO.includes(perfil) && parcelaPodeTravar(row)) {
            actions.push({
                type: 'action',
                label: 'Travar para pagamento',
                icon: <FaLock size={14} />,
                description: 'Avisa os responsáveis do evento por e-mail; o Eventos não altera mais esta parcela',
                onClick: () => setTravarModal({ titulo: row.descricao, parcelas: [row] })
            });
        }

        // Excluir = Voltar para "Aprovados pelo Financeiro" (reverte a liberação).
        // Só aparece para itens que estão em Contas Pendentes por liberação e podem de fato
        // voltar (OPF / adiantamento não-creditado). Creditado / Hospedagem-A&B não aparecem.
        const podeExcluir = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'].includes(perfil);
        if (podeExcluir && (row.situacao === "1") && parcelaPodeVoltarParaAprovados(row)) {
            actions.push({
                type: 'action',
                // Era "Excluir" — ninguém achava a ação que a trava de adiantamento
                // manda usar ("peça ao Financeiro para Voltar para Custo Previsto").
                label: 'Voltar para Custo Previsto',
                icon: <ImCancelCircle size={14} />,
                description: row.liberado_financeiro_at
                    ? 'Devolve a parcela para Aprovados pelo Financeiro — precisará ser liberada de novo'
                    : 'Conta sem Previsão de Pagamento: vai para Cancelado e o valor entra no Custo Previsto para aprovação',
                onClick: () => setReverterModal(row)
            });
        }

        // Upload de comprovante de pagamento
        actions.push({
            type: 'upload',
            label: 'Comprovante',
            icon: <FaUpload size={16} />,
            acaoApi: "financeiroParcelaArquivo/" + row.id,
            dados: { tipoArquivo: "comprovantepagamento", modulo: "financeiro", pasta: "comprovantepagamento" },
            callBack: () => { buscar(); }
        });

        if (actions.length === 0) return null;

        return (
            <button
                className="fin-pp__rowbtn"
                type="button"
                title="Ações"
                onClick={(e) => {
                    e.stopPropagation();
                    setActionsModalData({ parcela: row, actions: actions });
                    setShowActionsModal(true);
                }}
            >
                <FaEllipsisV size={14} />
            </button>
        );
    };

    useEffect(() => { //onload
        buscar();
        buscarCaixas();
    },
        // eslint-disable-next-line
        [filtro.tipo, filtro.evento]);

    useEffect(() => {
        if (abaVinculo === 'custosEmpresa' && abaAtiva === 'custoPrevisto') {
            setAbaAtiva('pendentes');
        }
    }, [abaVinculo, abaAtiva]);

    useEffect(() => {
        if (abaAtiva === 'custoPrevisto' && abaVinculo === 'eventos') {
            // Só a sub-aba visível é buscada — e toda vez que se troca de aba,
            // não só na primeira. Sem realtime, a lista guardada envelhece; quem
            // volta para a aba tem de ver o estado de agora.
            recarregarCustoPrevisto();
            buscarCustosPrevistos();
            if (subAbaCusto !== 'aprovados') buscarAdiantamentos();
        }
        if (abaAtiva === 'adiantamentos') {
            buscarAdiantamentos();
        }
        // Contas Pendentes e Contas Pagas precisam de adiantamentos
        if (abaAtiva === 'pendentes' || abaAtiva === 'pagas') {
            buscarAdiantamentos();
        }
        // eslint-disable-next-line
    }, [abaAtiva, abaVinculo, subAbaCusto]);

    // Ao trocar de aba, limpa seleção/ações para evitar aplicar ações em itens "escondidos"
    useEffect(() => {
        setTableSelect([]);
        setTableActions([]);
        // eslint-disable-next-line
    }, [abaAtiva, abaVinculo]);

    useEffect(() => { //onload
        if (tableSelect.selectedCount > 0) {
            const actions = [];

            // Botões de aprovação/reprovação para diretor (vêm primeiro)
            if (perfil && ['diretor','admin'].includes(perfil.trim().toLowerCase()) && tableSelect.selectedRows.length > 0) {
                actions.push(
                    <IconButton
                        key="aprovar"
                        small={true}
                        icon={<FaCheck size={20} />}
                        onClick={() => setShowModalAprovar(true)}
                        color="success"
                    >Aprovar ({tableSelect.selectedRows.length})</IconButton>
                );
                actions.push(
                    <IconButton
                        key="reprovar"
                        small={true}
                        icon={<ImCancelCircle size={20} />}
                        onClick={() => setShowModalReprovar(true)}
                        color="danger"
                    >Reprovar ({tableSelect.selectedRows.length})</IconButton>
                );
            }

            // Botão de alterar conta e favorecido
            actions.push(
                <IconButton
                    key="alterar"
                    small={true}
                    to={{
                        pathname: "/financeiro/alterarContaFornecedor",
                        state: {
                            idParcelas: tableSelect.selectedRows.map((parcela) => { return parcela.id; }),
                        }
                    }} icon={<FaEdit size={20} />}
                    color="primary">Alterar Conta e Favorecido</IconButton>
            );

            setTableActions(actions);
        } else {
            setTableActions([]);
        }
    },
        // eslint-disable-next-line
        [tableSelect]);

    const getEventoParcela = (row) => {
        return (
            row?.titulo?.venda?.[0]?.evento ||
            row?.titulo?.orcamento_item?.[0]?.orcamento?.evento ||
            row?.titulo?.evento ||
            null
        );
    };

    const getCentroCustoParcela = (row) => {
        const evento = getEventoParcela(row);
        return evento?.codigo ?? evento?.id ?? "";
    };

    const renderEventoReferencia = (row) => {
        const referenciaVendas = row.titulo?.venda?.length > 0 ?
            <div>
                {row.titulo.venda.map((venda, index) => (
                    <div key={index}>
                        <Link
                            title="Faturas relacionadas"
                            to={{
                                pathname: "/compra",
                                state: {
                                    grupoTitulo: row.titulo.grupo,
                                }
                            }}>
                            Compra{venda.codigo ? ": " + venda.codigo : ""}
                        </Link>
                    </div>
                ))}
            </div> : null;

        const textoReferenciaOrcamentos = row.titulo?.orcamento_item?.map((item) => {
            let texto = item.orcamento?.codigo ? item.orcamento.codigo : "Orçamento";
            if (item.orcamento?.evento?.nome) {
                texto += ` - ${item.orcamento.evento.nome}`;
            }
            return texto;
        }).join(",") || "";

        const referenciaOrcamentos = textoReferenciaOrcamentos ? <div>
            <Link
                title="Orçamentos relacionados"
                to={{
                    pathname: "/cadastroOrcamento/" + (row.titulo.orcamento_item?.[0]?.orcamento?.id || ''),
                    state: {
                        grupoTitulo: row.titulo.grupo,
                    },
                    search: row.titulo.orcamento_item?.length === 1 ? `?itemId=${row.titulo.orcamento_item[0].id}` : ''
                }}>
                {textoReferenciaOrcamentos}
            </Link>
        </div> : null;

        return <div>
            {referenciaVendas}
            {referenciaOrcamentos}
            <p title="Usuário que registrou">{row.operador?.nome}</p>
        </div>;
    };

    const temVinculoEvento = (row) => !!getEventoParcela(row);

    const parcelaPodeIrContasPendentes = (parcela) => {
        // Aprovação explícita pelo financeiro (via "Liberar para pgto")
        // OU tipo direto Hospedagem/A&B (não passa pelo fluxo de NF)
        // Legado sem OPF e sem liberação explícita NÃO entra em Contas Pendentes
        const liberadoFinanceiro = !!parcela.liberado_financeiro_at;
        const diretoContasPendentes = ehDiretoContasPendentesParcela(parcela);

        // Adiantamento creditado → vai direto para Contas Pendentes mesmo sem liberado_financeiro_at
        // Cobre registros históricos (antes do auto-set do backend) e novos saves.
        const titulo = parcela && parcela.titulo && typeof parcela.titulo === 'object'
            ? parcela.titulo : null;
        const descricao = (titulo && titulo.descricao) ? String(titulo.descricao) : '';
        const ehAdiantamentoCreditado = descricao.indexOf('Adiantamento') === 0
            && parcela.status_pagamento === 'creditado';

        return liberadoFinanceiro || diretoContasPendentes || ehAdiantamentoCreditado;
    };

    // Separar "com evento" x "sem evento" (custos empresa).
    // Parcelas já liberadas para pagamento (OPF) aparecem sempre, independente do vínculo com evento.
    const parcelasFiltradasVinculo = parcelas.filter((p) => {
        if (parcelaPodeIrContasPendentes(p)) return true;
        return abaVinculo === 'eventos' ? temVinculoEvento(p) : !temVinculoEvento(p);
    });

    // Filtrar parcelas por situação (após aplicar filtro de vínculo)
    const parcelasPendentes = parcelasFiltradasVinculo.filter(p => (p.situacao === "1" || p.situacao === 1) && parcelaPodeIrContasPendentes(p));
    const parcelasPagas = parcelasFiltradasVinculo.filter(p => p.situacao === "2");

    // Próximo vencimento das parcelas de um plano de previsão (Kátia, 04/09).
    // O Custo Previsto só mostrava a "Data Previsão" do fornecedor; o vencimento
    // real de cada parcela ficava escondido na coluna Parcelas, e era por ele que
    // o Financeiro precisava priorizar. Pega a próxima data a vencer; se todas já
    // passaram, devolve a mais recente (o atraso é o que importa ali).
    const proximoVencimentoDoPlano = (plano) => {
        const datas = ((plano && plano.parcelas) || [])
            .map(p => p.data_pagamento)
            .filter(Boolean)
            .sort();
        if (datas.length === 0) return null;
        const hojeStr = moment().startOf('day').format('YYYY-MM-DD');
        const futura = datas.find(d => d >= hojeStr);
        return { data: futura || datas[datas.length - 1], vencida: !futura, total: datas.length };
    };

    // Filtrar parcelas que vencem hoje
    const hoje = moment().format('YYYY-MM-DD');
    const parcelasVencemHoje = parcelasPendentes.filter(p =>
        p.vencimento && moment(p.vencimento).format('YYYY-MM-DD') === hoje
    );

    // Dados para exibir na tabela baseado na aba ativa
    const dadosParaExibir = abaAtiva === 'pendentes' ? parcelasPendentes : parcelasPagas;
    const totalCustosPrevistos = custosPrevistos.reduce((total, item) => total + getValorOrcadoItem(item), 0);

    // Filtro temporal por vencimento (chips) — aplica só em Contas Pendentes (a pagar)
    const passaFiltroVencimento = (p) => {
        if (filtroVencimento === 'tudo') return true;
        if (!p.vencimento) return false;
        const v = moment(p.vencimento).startOf('day');
        const hoje = moment().startOf('day');
        if (filtroVencimento === 'vencidas') return v.isBefore(hoje);
        if (filtroVencimento === 'hoje')     return v.isSame(hoje);
        if (filtroVencimento === 'semana')   return v.isSameOrAfter(hoje) && v.isSameOrBefore(moment().endOf('isoWeek'));
        if (filtroVencimento === '7dias')    return v.isSameOrAfter(hoje) && v.isSameOrBefore(moment().startOf('day').add(7, 'days'));
        if (filtroVencimento === '30dias')   return v.isSameOrAfter(hoje) && v.isSameOrBefore(moment().startOf('day').add(30, 'days'));
        if (filtroVencimento === '60dias')   return v.isSameOrAfter(hoje) && v.isSameOrBefore(moment().startOf('day').add(60, 'days'));
        if (filtroVencimento === 'mais60')   return v.isAfter(moment().startOf('day').add(60, 'days'));
        return true;
    };
    const dadosPendentesParaExibir = (abaAtiva === 'pendentes')
        ? dadosParaExibir.filter(passaFiltroVencimento)
        : dadosParaExibir;

    // Agrupa as parcelas (Contas Pendentes/Pagas) por evento → fornecedor → parcelas
    const gruposContasPendentes = (function () {
        const grupos = {};
        (dadosPendentesParaExibir || []).forEach((p) => {
            const ev = getEventoParcela(p);
            const evId = (ev && ev.id) ? String(ev.id) : '__sem_evento__';
            const evNome = (ev && ev.nome) ? ev.nome : '(sem evento)';
            // O cliente vem pendurado no evento — mesma origem que o Custo Previsto usa
            // para agrupar. Guardar aqui é o que permite filtrar por cliente logo abaixo.
            const cli = (ev && ev.cliente) ? ev.cliente : null;
            const cliId = cli && cli.id ? String(cli.id) : '__sem_cliente__';
            const cliNome = cli ? (cli.nomefantasia || cli.nome || 'Sem cliente') : 'Sem cliente';
            if (!grupos[evId]) grupos[evId] = { evento_id: evId, evento_nome: evNome, cliente_id: cliId, cliente_nome: cliNome, total: 0, fornecedores: {} };
            const fId = (p.participante && p.participante.id) ? String(p.participante.id) : '__sem_forn__';
            const fNome = (p.participante && (p.participante.nomefantasia || p.participante.nome || p.participante.contato)) || '(sem fornecedor)';
            if (!grupos[evId].fornecedores[fId]) grupos[evId].fornecedores[fId] = { forn_id: fId, forn_nome: fNome, total: 0, parcelas: [] };
            grupos[evId].fornecedores[fId].parcelas.push(p);
            grupos[evId].fornecedores[fId].total += parseFloat(p.valor) || 0;
            grupos[evId].total += parseFloat(p.valor) || 0;
        });
        return Object.values(grupos).map((ev) => Object.assign({}, ev, {
            fornecedores: Object.values(ev.fornecedores).map((fn) => Object.assign({}, fn, { origem: somarOrigens(fn.parcelas.map(origemDaParcela)), natureza: naturezaDaLista(fn.parcelas) })),
            origem: somarOrigens(Object.values(ev.fornecedores).reduce((l, fn) => l.concat(fn.parcelas.map(origemDaParcela)), [])),
        }));
    })();
    // Acordeão de Contas Pendentes: aberto por padrão (prefixo 'cp_' não colide com Custo Previsto)
    const cpAberto = (evId) => eventosAbertos['cp_' + evId] === true;
    // Clientes presentes na aba, para alimentar o select (sem repetir, em ordem)
    const clientesContasPendentes = (function () {
        const vistos = {};
        gruposContasPendentes.forEach(function (ev) {
            if (!vistos[ev.cliente_id]) vistos[ev.cliente_id] = { value: ev.cliente_id, label: ev.cliente_nome };
        });
        return Object.values(vistos).sort(function (a, b) { return a.label.localeCompare(b.label); });
    })();
    // Três filtros somados: deep-link do Painel Financeiro, cliente e busca por nome.
    const gruposContasPendentesView = (function () {
        let lista = gruposContasPendentes;
        if (eventoFiltroPendentes) {
            lista = lista.filter(function (ev) { return String(ev.evento_id) === String(eventoFiltroPendentes); });
        }
        if (filtroClientePagar) {
            lista = lista.filter(function (ev) { return String(ev.cliente_id) === String(filtroClientePagar); });
        }
        const termo = (buscaEventoPagar || '').trim().toLowerCase();
        if (termo) {
            lista = lista.filter(function (ev) {
                return (ev.evento_nome || '').toLowerCase().indexOf(termo) !== -1
                    || (ev.cliente_nome || '').toLowerCase().indexOf(termo) !== -1;
            });
        }
        return lista;
    })();

    // ── Overview financeiro ────────────────────────────────────────────────────
    // Cards de resumo refletem o que REALMENTE está em Contas Pendentes (liberado),
    // não todas as parcelas abertas — senão "Total a Pagar" não bate com a lista.
    const todasPendentes = parcelas.filter(p =>
        (p.situacao === "1" || p.situacao === 1) && parcelaPodeIrContasPendentes(p)
    );
    const totalPendenteGeral = todasPendentes.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0);
    const em7Dias = moment().add(7, 'days').format('YYYY-MM-DD');
    const parcelasVencendo7Dias = todasPendentes.filter(p =>
        p.vencimento && moment(p.vencimento).format('YYYY-MM-DD') <= em7Dias
    );
    const totalVencendo7Dias = parcelasVencendo7Dias.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0);
    // Total já pago (parcelas baixadas, situacao=2) — card global do período
    const parcelasPagasCards = parcelas.filter(p => (p.situacao === "2" || p.situacao === 2));
    const totalPago = parcelasPagasCards.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0);
    // Item 15: parte estrangeira dos cards (por moeda, total em R$).
    const origemPendenteGeral = somarOrigens(todasPendentes.map(origemDaParcela));
    const origemVencendo7Dias = somarOrigens(parcelasVencendo7Dias.map(origemDaParcela));
    const origemPago = somarOrigens(parcelasPagasCards.map(origemDaParcela));
    // Cards COM NF / AGUARDANDO NF: agrega 3 fontes do novo fluxo financeiro
    // Fonte 1 — parcelas liberadas para Contas Pendentes
    const todasPendentesNovoFluxo = parcelas.filter(p =>
        (p.situacao === "1" || p.situacao === 1) && parcelaPodeIrContasPendentes(p)
    );
    const parcelasComNF = todasPendentesNovoFluxo.filter(p =>
        p.arquivonotafiscal?.id ||
        p.titulo?.orcamento_item?.some(item => !!item.arquivonotafiscal)
    );
    const parcelasSemNFPendentes = todasPendentesNovoFluxo.filter(p =>
        !p.arquivonotafiscal?.id &&
        !p.titulo?.orcamento_item?.some(item => !!item.arquivonotafiscal)
    );
    // Fonte 2 — adiantamentos aprovados pelo diretor ainda em Custo Previsto (não creditados/liberados)
    const adiantAprovadosCards = adiantamentos.filter(function(a) {
        return !!a.dataAprovacaoDiretor && !a.liberado_financeiro_at && a.status_pagamento !== 'creditado';
    });
    // Fonte 3 — OPFs aprovados pelo financeiro ainda não liberados para pagamento
    const planosAprovadosCards = planosPrevistos.filter(function(p) {
        return p.status === 'aprovado' && !p.liberado_financeiro_at;
    });
    // Totais agregados para os cards
    const qtComNF = parcelasComNF.length
        + adiantAprovadosCards.filter(function(a) { return !!(a.nota_fiscal_id || a.arquivonotafiscal); }).length
        + planosAprovadosCards.filter(function(p) { return !!p.nf_vinculada; }).length;
    const qtSemNF = parcelasSemNFPendentes.length
        + adiantAprovadosCards.filter(function(a) { return !(a.nota_fiscal_id || a.arquivonotafiscal); }).length
        + planosAprovadosCards.filter(function(p) { return !p.nf_vinculada; }).length;
    // Separa caixas em bancos (sem limite de cartão) e cartões (com limite > 0)
    const ehCartao = (c) => parseFloat(c.cartaolimite) > 0;
    const caixasBanco = caixas.filter(c => !ehCartao(c));
    const caixasCartao = caixas.filter(c => ehCartao(c));
    // ──────────────────────────────────────────────────────────────────────────

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Parcelas a Pagar</h1>
                        <p className="fin-pp__subtitle">
                            {abaAtiva === 'pagas'
                                ? 'Contas pagas agrupadas por evento e fornecedor'
                                : abaAtiva === 'custoPrevisto'
                                    ? 'Custo previsto agrupado por evento e fornecedor'
                                    : 'Contas pendentes agrupadas por evento e fornecedor'}
                        </p>
                    </div>
                    <div className="fin-pp__actions">
                        <button
                            type="button"
                            className="fin-pp__btn"
                            onClick={abrirModalExportarContasPagas}
                            disabled={exportandoContasPagas}
                        >
                            <FaFileAlt size={16} /> Exportar contas pagas
                        </button>
                        <button
                            type="button"
                            className="fin-pp__btn"
                            onClick={exportarContasPagasExcel}
                            disabled={exportandoPlanilhaContabilidade}
                        >
                            <FaFileInvoice size={16} /> {exportandoPlanilhaContabilidade ? 'Gerando planilha...' : 'Gerar planilha contabilidade'}
                        </button>
                        <Link
                            to={{ pathname: "/financeiroParcelaRelatorio", state: { tipo: 1 } }}
                            className="fin-pp__btn"
                        >
                            <FaFileAlt size={16} /> Relatório
                        </Link>
                        <Link to="/cadastroParcelaPagar" className="fin-pp__btn fin-pp__btn--primary">
                            <FaPlus size={16} /> Nova despesa
                        </Link>
                    </div>
                </div>

                {/* ── KPIs ──────────────────────────────────────────────────── */}
                {abaAtiva !== 'custoPrevisto' && abaAtiva !== 'cancelado' && (
                <section className="fin-pp__kpis">
                    <div className="fin-pp__kpi">
                        <div className="fin-pp__kpi-top">
                            <span className="fin-pp__kpi-label">Total a pagar</span>
                            <span className="fin-pp__kpi-ic"><FaFileInvoiceDollar size={16} /></span>
                        </div>
                        <div className="fin-pp__kpi-value">{moeda(totalPendenteGeral)}</div>
                        <OrigemMoeda origem={origemPendenteGeral} />
                        <div className="fin-pp__kpi-sub">{todasPendentes.length} parcelas no período</div>
                    </div>
                    <div className="fin-pp__kpi">
                        <div className="fin-pp__kpi-top">
                            <span className="fin-pp__kpi-label">Vencem em 7 dias</span>
                            <span className="fin-pp__pill is-danger">Urgente</span>
                        </div>
                        <div className="fin-pp__kpi-value is-danger">{moeda(totalVencendo7Dias)}</div>
                        <OrigemMoeda origem={origemVencendo7Dias} />
                        <div className="fin-pp__kpi-sub">{parcelasVencendo7Dias.length} parcelas vencendo</div>
                    </div>
                    <div className="fin-pp__kpi">
                        <div className="fin-pp__kpi-top">
                            <span className="fin-pp__kpi-label">Com nota fiscal</span>
                            <span className="fin-pp__kpi-ic is-ok"><FaCheck size={16} /></span>
                        </div>
                        <div className="fin-pp__kpi-value">{qtComNF}</div>
                        <div className="fin-pp__kpi-sub">prontas para pagar</div>
                    </div>
                    <div className="fin-pp__kpi">
                        <div className="fin-pp__kpi-top">
                            <span className="fin-pp__kpi-label">Aguardando NF</span>
                            <span className="fin-pp__pill is-warn">Pendente</span>
                        </div>
                        <div className="fin-pp__kpi-value is-warn">{qtSemNF}</div>
                        <div className="fin-pp__kpi-sub">sem nota fiscal</div>
                    </div>
                    <div className="fin-pp__kpi">
                        <div className="fin-pp__kpi-top">
                            <span className="fin-pp__kpi-label">Total pago</span>
                            <span className="fin-pp__kpi-ic is-ok"><FaCheck size={16} /></span>
                        </div>
                        <div className="fin-pp__kpi-value is-ok">{moeda(totalPago)}</div>
                        <OrigemMoeda origem={origemPago} />
                        <div className="fin-pp__kpi-sub">{parcelasPagasCards.length} parcelas pagas</div>
                    </div>
                </section>
                )}

                {/* ── Saldos ────────────────────────────────────────────────── */}
                {(caixasBanco.length > 0 || caixasCartao.length > 0) && (
                    <section className="fin-pp__saldos">
                        <span className="fin-pp__saldos-label">Saldos</span>
                        <div className="fin-pp__saldos-list">
                            {caixasBanco.map(c => {
                                // Banco: saldo REAL vem do razão (movimentos), não do cartaosaldo estático.
                                const saldoBanco = parseFloat(saldosLedger[String(c.id)] ?? 0);
                                const negativo = saldoBanco < 0;
                                return (
                                    <div key={c.id} className={`fin-pp__saldo${negativo ? ' is-danger' : ''}`}>
                                        <FaUniversity size={15} color={negativo ? '#c1232b' : '#586478'} />
                                        <div>
                                            <div className="fin-pp__saldo-name">{c.nome}</div>
                                            <div className="fin-pp__saldo-value" style={{ color: negativo ? '#c1232b' : (saldoBanco > 0 ? '#15803d' : '#586478') }}>
                                                {moeda(saldoBanco)}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            {caixasCartao.map(c => {
                                const limite = parseFloat(c.cartaolimite) || 0;
                                const saldo = parseFloat(c.cartaosaldo) || 0;
                                const pct = limite > 0 ? Math.round((saldo / limite) * 100) : 0;
                                const negativo = saldo < 0;
                                const cor = pct >= 50 ? '#15803d' : pct >= 20 ? '#a85b07' : '#c1232b';
                                return (
                                    <div key={c.id} className={`fin-pp__saldo${negativo ? ' is-danger' : ''}`}>
                                        <FaCreditCard size={15} color={negativo ? '#c1232b' : '#586478'} />
                                        <div>
                                            <div className="fin-pp__saldo-name">
                                                {c.nome}{c.diaCorteCartao ? <> · <span className="fin-pp__saldo-corte">corte {c.diaCorteCartao}</span></> : null}
                                            </div>
                                            <div className="fin-pp__saldo-value" style={{ color: negativo ? '#c1232b' : cor }}>
                                                {moeda(saldo)} <span className="fin-pp__saldo-lim">/ lim {moeda(limite)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <button className="fin-pp__btn" style={{ flex: 'none' }}
                            onClick={buscarCaixas} disabled={carregandoCaixas} title="Atualizar saldos">
                            <FaSync size={13} className={carregandoCaixas ? 'fa-spin' : ''} /> {carregandoCaixas ? '...' : 'Atualizar'}
                        </button>
                    </section>
                )}
                {/* ──────────────────────────────────────────────────────────── */}

                {/* ── Busca compacta ─────────────────────────────────────────── */}
                <form className="mb-2 mt-3" onSubmit={(e) => {
                    e.preventDefault();
                    if (abaAtiva === 'custoPrevisto') { buscarCustosPrevistos(); return; }
                    filtro.idTitulo = null;
                    buscar();
                }}>
                    <div className="d-flex gap-2 align-items-center">
                        <div className="fin-pp__search-field">
                            {abaAtiva === 'custoPrevisto' ? (
                                <ReactSelect
                                    placeholder="Buscar por evento..."
                                    value={{ value: filtroCustoPrevisto.evento, label: filtroCustoPrevisto.nomeEvento }}
                                    onChange={e => setFiltroCustoPrevisto({ ...filtroCustoPrevisto, evento: e?.value || null, nomeEvento: e?.label || '', orcamento: null, nomeOrcamento: '' })}
                                    loadOptions={(input) => api({ method: 'get', action: '/evento', token: token, params: { nome: input, situacaoRegistro: "ativo" } })
                                        .then(r => (r.data.data || []).map(reg => ({ value: reg.id, label: `${reg.codigo ? reg.codigo + ' - ' : ''}${reg.nome || ''}` })))}
                                />
                            ) : (
                                <>
                                    <FaSearch className="fin-pp__search-ic" size={16} />
                                    <input
                                        autoFocus
                                        type="text"
                                        className="fin-pp__input"
                                        placeholder="Buscar por descrição, favorecido ou orçamento…"
                                        onChange={e => setFiltro({ ...filtro, descricao: e.target.value })}
                                    />
                                </>
                            )}
                        </div>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall">
                            <FaSearch size={14} /> Buscar
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--tall" onClick={() => setMostrarFiltros(true)}>
                            <FaFilter size={14} /> Filtros
                            {(filtro.participante || filtro.conta || filtro.dataVencimento1 || filtro.dataVencimento2 ||
                              filtroCustoPrevisto.orcamento || filtroCustoPrevisto.dataPrevisao1) && (
                                <span className="badge bg-primary ms-1" style={{ fontSize: 9, verticalAlign: 'middle' }}>●</span>
                            )}
                        </button>
                    </div>
                </form>

                {/* ── Modal de Filtros Avançados ──────────────────────────────── */}
                <div
                    className={`modal fade ${mostrarFiltros ? 'show d-block' : ''} fin-pp fin-pp__modalbg`}
                    tabIndex="-1"
                    style={{ display: mostrarFiltros ? 'block' : 'none' }}
                    onClick={(e) => { if (e.target === e.currentTarget) setMostrarFiltros(false); }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal fin-pp__modal--flow">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFilter size={17} /></span>
                                <h3 className="fin-pp__modal-title">Filtros avançados
                                    <span className="fin-pp__modal-sub">Refine os resultados desta visão</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setMostrarFiltros(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: 460 }}>
                                <div className="fin-pp__filters" style={{ alignItems: 'stretch' }}>
                                    {abaAtiva === 'custoPrevisto' ? (
                                        <>
                                            <div className="fin-pp__field" style={{ flex: '1 1 100%' }}>
                                                <label className="fin-pp__label">Orçamento do Evento</label>
                                                {/* Lentidão (treinamento 07/10): sem evento escolhido este select
                                                    baixava TODOS os orçamentos (~5 s) ao abrir a aba e de novo a
                                                    cada tecla. Agora só pré-carrega com evento escolhido e guarda
                                                    a lista por evento enquanto a tela estiver aberta. */}
                                                <React.Fragment key={'orcfiltro_' + (filtroCustoPrevisto.evento || '')}>
                                                <ReactSelect
                                                    value={{ value: filtroCustoPrevisto.orcamento, label: filtroCustoPrevisto.nomeOrcamento }}
                                                    onChange={e => setFiltroCustoPrevisto({ ...filtroCustoPrevisto, orcamento: e?.value || null, nomeOrcamento: e?.label || '' })}
                                                    defaultOptions={!!filtroCustoPrevisto.evento}
                                                    loadOptions={(input) => orcamentosDoFiltro(filtroCustoPrevisto.evento)
                                                        .then(lista => lista.filter(reg => !input || (reg.codigo || '').toString().toLowerCase().includes(input.toLowerCase()))
                                                            .map(reg => ({ value: reg.id, label: `Orçamento ${reg.codigo}${reg.evento?.nome ? ` - ${reg.evento.nome}` : ''}` })))}
                                                />
                                                </React.Fragment>
                                            </div>
                                            <div className="fin-pp__field">
                                                <Data label="Data de Previsão" value={filtroCustoPrevisto.dataPrevisao1} onChange={(date) => setFiltroCustoPrevisto({ ...filtroCustoPrevisto, dataPrevisao1: date })} />
                                            </div>
                                            <div className="fin-pp__field">
                                                <Data label="até a Data de Previsão" value={filtroCustoPrevisto.dataPrevisao2} onChange={(date) => setFiltroCustoPrevisto({ ...filtroCustoPrevisto, dataPrevisao2: date })} />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="fin-pp__field">
                                                <Data label="Data Vencimento" value={filtro.dataVencimento1} onChange={date => setFiltro({ ...filtro, dataVencimento1: date })} />
                                            </div>
                                            <div className="fin-pp__field">
                                                <Data label="até a Data Vencimento" value={filtro.dataVencimento2} onChange={date => setFiltro({ ...filtro, dataVencimento2: date })} />
                                            </div>
                                            <div className="fin-pp__field" style={{ flex: '1 1 100%' }}>
                                                <label className="fin-pp__label">Favorecido</label>
                                                <ReactSelect
                                                    value={{ value: filtro.participante, label: filtro.nomeParticipante }}
                                                    onChange={e => setFiltro({ ...filtro, participante: e.value, nomeParticipante: e.label })}
                                                    // Sem defaultOptions o select baixava TODOS os participantes
                                                    // ativos (~22 MB) ao abrir a tela. Busca só quando digita.
                                                    defaultOptions={false}
                                                    loadOptions={(input) => api({ method: 'get', action: '/participante', token: token, params: { nome: input, situacaoRegistro: "ativo" } })
                                                        .then(r => r.data.data.map(reg => ({
                                                            value: reg.id,
                                                            label: `${reg.codigo} - ${reg.nome}${reg.cnpj ? ` (${reg.cnpj})` : ''}`
                                                        })))}
                                                />
                                            </div>
                                            <div className="fin-pp__field" style={{ flex: '1 1 100%' }}>
                                                <label className="fin-pp__label">Plano de Contas</label>
                                                <ReactSelect
                                                    value={{ value: filtro.conta, label: filtro.nomeConta }}
                                                    onChange={e => setFiltro({ ...filtro, conta: e.value, nomeConta: e.label })}
                                                    loadOptions={(input) => api({ method: 'get', action: '/financeiroPlanoConta', token: token, params: { nome: input, tipo: "1", situacaoRegistro: "ativo" } })
                                                        .then(r => r.data.data.map(reg => ({ value: reg.id, label: `${reg.caminho} - ${reg.nome}` })))}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button
                                    type="button"
                                    className="fin-pp__btn"
                                    onClick={() => {
                                        setFiltro(f => ({ tipo: f.tipo, empresa: f.empresa }));
                                        setFiltroCustoPrevisto({ evento: null, nomeEvento: '', orcamento: null, nomeOrcamento: '', dataPrevisao1: null, dataPrevisao2: null });
                                        setMostrarFiltros(false);
                                    }}
                                >
                                    Limpar filtros
                                </button>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    onClick={() => {
                                        setMostrarFiltros(false);
                                        if (abaAtiva === 'custoPrevisto') buscarCustosPrevistos();
                                        else { filtro.idTitulo = null; buscar(); }
                                    }}
                                >
                                    <FaSearch size={14} /> Aplicar filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ──────────────────────────────────────────────────────────── */}

                {/* ── Abas ───────────────────────────────────────────────────── */}
                <div className="fin-pp__tabs mb-3">
                    {[
                        { key: 'pendentes',     label: 'Contas Pendentes' },
                        { key: 'pagas',         label: 'Contas Pagas'     },
                        { key: 'custoPrevisto', label: 'Custo Previsto'   },
                        { key: 'cancelado',     label: 'Cancelado'        },
                    ].map(t => {
                        const ativa = abaAtiva === t.key;
                        return (
                            <button key={t.key} type="button"
                                onClick={() => {
                                    setAbaAtiva(t.key);
                                    // carrega sob demanda — a aba é consulta à parte
                                    if (t.key === 'cancelado') buscarCanceladas();
                                }}
                                className={`fin-pp__tab${ativa ? ' is-active' : ''}`}>
                                {t.label}
                            </button>
                        );
                    })}
                </div>

                {/* Vencem hoje — antes era um bloco à parte que repetia as mesmas
                    linhas da listagem, em outro visual e sem as tags (comprovante
                    recebido, trava, orçamento alterado). Treinamento 07/10: "não pode
                    duplicar na tela, precisa funcionar igual a listagem normal".
                    Agora é só o aviso; o botão aplica o filtro "Vence hoje" na
                    própria listagem de Contas Pendentes. */}
                {abaAtiva === 'pendentes' && parcelasVencemHoje.length > 0 && (
                    <div className="fin-pp__banner is-warn" style={{ alignItems: 'center' }}>
                        <FaClock className="fin-pp__banner-ic" size={15} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <strong>{parcelasVencemHoje.length} conta{parcelasVencemHoje.length !== 1 ? 's vencem' : ' vence'} hoje</strong>
                            {' '}({moment().format('DD/MM/YYYY')}) · R$ {moeda(parcelasVencemHoje.reduce((s, p) => s + (parseFloat(p.valor) || 0), 0))}
                        </div>
                        {filtroVencimento === 'hoje' && abaContas === 'previsoes' ? (
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                onClick={() => setFiltroVencimento('tudo')}>
                                Mostrar todas
                            </button>
                        ) : (
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                onClick={() => { setAbaContas('previsoes'); setFiltroVencimento('hoje'); }}>
                                Ver só as de hoje
                            </button>
                        )}
                    </div>
                )}

                {/* ── Aba Cancelado ────────────────────────────────────────────
                    Parcela cancelada não some: fica aqui, riscada, com o porquê.
                    Origem distingue cancelamento automático (mudança no orçamento
                    /efetivo) de exclusão manual — pedido do Rafael 2026-08-02. */}
                {abaAtiva === 'cancelado' && (
                    <div className="fin-pp__region">
                        {carregandoCanceladas ? (
                            <div className="fin-pp__empty">Carregando…</div>
                        ) : parcelasCanceladas.length === 0 ? (
                            <div className="fin-pp__empty">Nenhuma conta cancelada.</div>
                        ) : (() => {
                            // Mesmo shell do Custo Previsto: cliente → evento → linhas.
                            // Lista plana virava bagunça com volume (Rafael 2026-08-02).
                            const porCliente = parcelasCanceladas.reduce((acc, p) => {
                                const ev  = p.titulo?.evento || null;
                                const cli = ev?.cliente || null;
                                const cKey = cli?.id || '__sem_cliente__';
                                if (!acc[cKey]) {
                                    acc[cKey] = {
                                        cliente_id: cli?.id || null,
                                        cliente_nome: cli?.nomefantasia || cli?.nome || 'Sem cliente',
                                        eventos: {}, total: 0, qt: 0,
                                    };
                                }
                                const eKey = ev?.id || '__sem_evento__';
                                if (!acc[cKey].eventos[eKey]) {
                                    acc[cKey].eventos[eKey] = {
                                        evento_id: eKey,
                                        evento_nome: ev?.nome || '(sem evento)',
                                        parcelas: [], total: 0,
                                    };
                                }
                                const v = parseFloat(p.valor || 0);
                                acc[cKey].eventos[eKey].parcelas.push(p);
                                acc[cKey].eventos[eKey].total += v;
                                acc[cKey].total += v;
                                acc[cKey].qt += 1;
                                return acc;
                            }, {});
                            const clientesOrdenados = Object.values(porCliente).sort((a, b) => b.total - a.total);
                            const clientesOrdenadosView = filtrarClientesPorFiltro(clientesOrdenados);

                            return (
                                <div className="fin-pp__groups" style={{ padding: 14 }}>
                                    {(clientesOrdenados.length > 0 || temFiltroAtivoNaAba()) && renderFiltroClienteEvento(opcoesClientesDe(clientesOrdenados))}
                                    {clientesOrdenadosView.length === 0 && (
                                        <div className="fin-pp__empty">Nenhum cliente/evento bate com o filtro.</div>
                                    )}
                                    {clientesOrdenadosView.map(cli => (
                                        <div key={cli.cliente_id || '__sem_cliente__'} className="fin-pp__cligrp" style={{ marginBottom: 14 }}>
                                            {/* ── Faixa do cliente ── */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--fin-acw)', border: '1px solid var(--fin-acb)', borderRadius: 8, marginBottom: 10 }}>
                                                <span style={{ display: 'inline-flex', width: 30, height: 30, borderRadius: 8, alignItems: 'center', justifyContent: 'center', background: '#fff', color: 'var(--fin-ac)', flex: 'none' }}><FaUniversity size={15} /></span>
                                                <span style={{ fontWeight: 700, color: 'var(--fin-tx)', fontSize: 15 }}>{cli.cliente_nome}</span>
                                                <span className="fin-pp__grp-badge">
                                                    {Object.keys(cli.eventos).length} evento{Object.keys(cli.eventos).length !== 1 ? 's' : ''} · {cli.qt} cancelada{cli.qt !== 1 ? 's' : ''}
                                                </span>
                                                <span style={{ marginLeft: 'auto', fontWeight: 700, color: '#6c757d', textDecoration: 'line-through' }}>
                                                    Total: R$ {moeda(cli.total)}
                                                </span>
                                            </div>

                                            {Object.values(cli.eventos).map(grupo => {
                                                const chaveAcc  = 'canc_' + grupo.evento_id;
                                                const estaAberto = eventosAbertos[chaveAcc] !== undefined ? eventosAbertos[chaveAcc] : true;
                                                return (
                                                    <div key={chaveAcc} className="fin-pp__grp">
                                                        <div className="fin-pp__grp-head"
                                                            onClick={() => toggleEventoAberto(chaveAcc, estaAberto)}>
                                                            <span className={'fin-pp__grp-caret' + (estaAberto ? ' is-open' : '')}>▶</span>
                                                            <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>
                                                            <span className="fin-pp__grp-name">{grupo.evento_nome}</span>
                                                            <span className="fin-pp__grp-badge">
                                                                {grupo.parcelas.length} cancelada{grupo.parcelas.length !== 1 ? 's' : ''}
                                                            </span>
                                                            <span className="fin-pp__grp-total" style={{ color: '#6c757d' }}>
                                                                Total: <strong style={{ textDecoration: 'line-through' }}>R$ {moeda(grupo.total)}</strong>
                                                            </span>
                                                        </div>
                                                        {estaAberto && (
                                                            <div>
                                                                <table className="fin-pp__tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: 160 }}>Origem</th>
                                                                            <th>Descrição / motivo</th>
                                                                            <th style={{ width: 150 }}>Cancelado em</th>
                                                                            <th className="text-end" style={{ width: 130 }}>Valor</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {grupo.parcelas.map(p => {
                                                                            const auto = (p.cancelamento_origem || '').indexOf('automatico') === 0;
                                                                            const rotulo = p.cancelamento_origem === 'automatico_cliente' ? 'Automático · cliente paga'
                                                                                : p.cancelamento_origem === 'automatico_valor' ? 'Automático · valor alterado'
                                                                                : p.cancelamento_origem === 'devolvida_custo_previsto' ? 'Devolvida ao Custo Previsto'
                                                                                : 'Manual';
                                                                            const quem = p.RemovidoPorParticipante?.nome || p.removido_por_participante?.nome || null;
                                                                            return (
                                                                                <tr key={'canc_' + p.id}>
                                                                                    <td>
                                                                                        <span className={'fin-pp__minitag ' + (auto ? 'is-warn' : 'is-info')}>{rotulo}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div style={{ textDecoration: 'line-through', color: '#6c757d' }}>
                                                                                            {p.descricao || '—'}
                                                                                        </div>
                                                                                        {p.motivo_remocao && (
                                                                                            <div className="text-muted" style={{ fontSize: '0.72rem', marginTop: 2 }}>
                                                                                                {p.motivo_remocao}
                                                                                            </div>
                                                                                        )}
                                                                                        {quem && (
                                                                                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>por {quem}</div>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="fin-pp__cell-muted">
                                                                                        {p.removido_em ? moment(p.removido_em).format('DD/MM/YYYY HH:mm') : '—'}
                                                                                    </td>
                                                                                    <td className="text-end" style={{ textDecoration: 'line-through', color: '#6c757d' }}>
                                                                                        R$ {moeda(parseFloat(p.valor || 0))}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                )}

                {/* ── Cards de resumo do Custo Previsto ── */}
                {abaAtiva === 'custoPrevisto' && abaVinculo === 'eventos' && (() => {
                    // Os KPIs descrevem o fluxo INTEIRO e ficam acima das abas: vêm do
                    // `resumo` que o servidor devolve sem filtro. Se seguissem o
                    // recorte, um período estreito mostraria "Aguardando análise: 0" e
                    // faria parecer que não há nada a revisar.
                    const qtAguardando  = resumoCusto.aguardando;
                    const qtAprovados   = resumoCusto.aprovados;
                    const qtReprovados  = resumoCusto.reprovados;
                    const qtParcial     = resumoCusto.parcial;
                    const cards = [
                        { label: 'Aguardando análise',     valor: qtAguardando, tone: 'is-info',   sub: 'previsões a revisar' },
                        { label: 'Aprovados',              valor: qtAprovados,  tone: 'is-ok',     sub: 'liberados pelo financeiro' },
                        { label: 'Reprovados',             valor: qtReprovados, tone: 'is-danger', sub: 'devolvidos ao operador' },
                        { label: 'Aprovados parcialmente', valor: qtParcial,    tone: 'is-warn',   sub: 'parte dos itens liberados' },
                    ];
                    return (
                        <section className="fin-pp__kpis" style={{ marginBottom: 14 }}>
                            {cards.map(c => (
                                <div key={c.label} className="fin-pp__kpi">
                                    <div className="fin-pp__kpi-top">
                                        <span className="fin-pp__kpi-label">{c.label}</span>
                                    </div>
                                    <div className={'fin-pp__kpi-value ' + c.tone}>{c.valor}</div>
                                    <div className="fin-pp__kpi-sub">{c.sub}</div>
                                </div>
                            ))}
                        </section>
                    );
                })()}

                {/* ── Sub-abas do Custo Previsto: Planos | Aprovados ── */}
                {abaAtiva === 'custoPrevisto' && abaVinculo === 'eventos' && (
                    <div className="fin-pp__seg" style={{ marginBottom: 14 }}>
                        {[
                            { key: 'planos', label: 'Planos de Pagamento', count: resumoCusto.aguardando },
                            { key: 'aprovados', label: 'Aprovados pelo Financeiro', count: resumoCusto.aprovados },
                        ].map((tab) => (
                            <button key={tab.key} type="button"
                                onClick={() => setSubAbaCusto(tab.key)}
                                className={'fin-pp__seg-btn' + (subAbaCusto === tab.key ? ' is-active' : '')}>
                                {tab.label}
                                <span className="fin-pp__seg-count">{tab.count}</span>
                            </button>
                        ))}
                    </div>
                )}

                {/* Tabela de Custo Previsto */}
                {/* ── Planos de Pagamento aguardando aprovação (novo fluxo) ── */}
                {abaAtiva === 'custoPrevisto' && abaVinculo === 'eventos' && subAbaCusto === 'planos' && (
                    <section style={{ marginTop: 22 }}>
                        <div className="mb-4">
                            <div>
                                <div className="fin-pp__region">
                                    <div className="fin-pp__cphead">
                                        <span className="fin-pp__cphead-ic"><FaCalendarAlt size={18} /></span>
                                        <div style={{ minWidth: 0 }}>
                                            <h2 className="fin-pp__cphead-title">Planos de Pagamento — Aguardando Aprovação</h2>
                                            <p className="fin-pp__cphead-sub">Previsões enviadas pelos operadores aguardando aprovação do financeiro. Aprovados aparecem na seção abaixo.</p>
                                        </div>
                                        <span className="fin-pp__cphead-pill is-warn">
                                            {planosPrevistos.filter(p => p.status === 'enviado' && !p.nf_vinculada).length} aguardando
                                        </span>
                                    </div>
                                    <div className="fin-pp__region-body">
                                        {/* Barra de filtros FORA do bloco condicional: se ficasse lá dentro,
                                            um período sem resultado a levava junto e não sobrava como desfazer. */}
                                        <div style={{ padding: '14px 14px 0' }}>
                                            {renderFiltroClienteEvento(opcoesClientesDe(clientesDosPlanos()))}
                                        </div>
                                        {loadingPlanos ? (
                                            <div className="text-center py-4 text-muted">Carregando planos...</div>
                                        ) : (() => {
                                            // Topo: apenas enviados (aguardando aprovação do financeiro)
                                            // Aprovados migram para a seção "Aguardando NF" abaixo.
                                            // O período é o desta aba — a aba "Aprovados" tem o dela.
                                            // Cliente, busca e período já vieram aplicados do servidor
                                            // (buscarPlanosPrevistos). Aqui só sobra separar por status.
                                            const aguardando  = planosPrevistos.filter(p => p.status === 'enviado');
                                            // Aprovados com NF vinculada → banner "foram para Contas Pendentes"
                                            const comNFaprov  = planosPrevistos.filter(p => p.status === 'aprovado' && p.nf_vinculada);
                                            if (aguardando.length === 0 && comNFaprov.length === 0) {
                                                return (
                                                    <div className="text-center py-4 text-muted">
                                                        {temFiltroAtivoNaAba()
                                                            ? 'Nenhum plano no período ou filtro selecionado.'
                                                            : 'Nenhum plano aguardando aprovação do financeiro.'}
                                                        {temFiltroAtivoNaAba() && (
                                                            <div className="mt-2">
                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={limparFiltrosDaAba}>
                                                                    <FaTimes size={12} /> Limpar filtros
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            }
                                            // Agrupa por CLIENTE → evento (apenas enviados)
                                            const porCliente = aguardando.reduce((acc, plano) => {
                                                const cKey = plano.cliente_id || '__sem_cliente__';
                                                if (!acc[cKey]) acc[cKey] = { cliente_id: plano.cliente_id, cliente_nome: plano.cliente_nome || 'Sem cliente', eventos: {}, total: 0, fornecedores: 0 };
                                                const eKey = plano.evento_id || '__sem_evento__';
                                                if (!acc[cKey].eventos[eKey]) acc[cKey].eventos[eKey] = { evento_id: plano.evento_id, evento_nome: plano.evento_nome || '(sem evento)', planos: [] };
                                                acc[cKey].eventos[eKey].planos.push(plano);
                                                acc[cKey].total += (plano.total || 0);
                                                acc[cKey].fornecedores += 1;
                                                return acc;
                                            }, {});
                                            const clientesOrdenados = Object.values(porCliente).sort((a, b) => b.total - a.total);
                                            return (
                                                <div className="fin-pp__groups" style={{ padding: 14 }}>
                                                    {/* Banner: aprovados com NF vinculada → Contas Pendentes */}
                                                    {comNFaprov.length > 0 && avisoVisivel('planos-migrados') && (
                                                        <div className="fin-pp__banner is-ok">
                                                            <FaCheck className="fin-pp__banner-ic" size={16} />
                                                            <div>
                                                                <strong>{comNFaprov.length}</strong> plano{comNFaprov.length !== 1 ? 's' : ''} aprovado{comNFaprov.length !== 1 ? 's' : ''} com NF vinculada {comNFaprov.length !== 1 ? 'foram migrados' : 'foi migrado'} para <strong>Contas Pendentes</strong>.
                                                            </div>
                                                            {botaoFecharAviso('planos-migrados')}
                                                        </div>
                                                    )}
                                                    {aguardando.length === 0 && (
                                                        <div className="text-center py-4 text-muted">
                                                            {temFiltroAtivoNaAba()
                                                                ? 'Nenhum plano no período ou filtro selecionado.'
                                                                : 'Nenhum plano aguardando aprovação.'}
                                                            {temFiltroAtivoNaAba() && (
                                                                <div className="mt-2">
                                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={limparFiltrosDaAba}>
                                                                        <FaTimes size={12} /> Limpar filtros
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {clientesOrdenados.map(cli => (
                                                    <div key={cli.cliente_id || '__sem_cliente__'} className="fin-pp__cligrp" style={{ marginBottom: 14 }}>
                                                        {/* ── Faixa do cliente ── */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--fin-acw)', border: '1px solid var(--fin-acb)', borderRadius: 8, marginBottom: 10 }}>
                                                            <span style={{ display: 'inline-flex', width: 30, height: 30, borderRadius: 8, alignItems: 'center', justifyContent: 'center', background: '#fff', color: 'var(--fin-ac)', flex: 'none' }}><FaUniversity size={15} /></span>
                                                            <span style={{ fontWeight: 700, color: 'var(--fin-tx)', fontSize: 15 }}>{cli.cliente_nome}</span>
                                                            <span className="fin-pp__grp-badge">{Object.keys(cli.eventos).length} evento{Object.keys(cli.eventos).length !== 1 ? 's' : ''} · {cli.fornecedores} fornecedor{cli.fornecedores !== 1 ? 'es' : ''}</span>
                                                            <span style={{ marginLeft: 'auto', fontWeight: 700, color: 'var(--fin-tx)' }}>Total: R$ {moeda(cli.total)}</span>
                                                        </div>
                                                    {Object.values(cli.eventos).map(grupo => {
                                                        // Soma o ORÇAMENTO ATUAL, não as parcelas (Kátia, 14/08).
                                                        // `p.total` é a soma das parcelas de previsão, que ficam com o
                                                        // valor antigo quando o orçamento muda: o cabeçalho mostrava
                                                        // 24.750 num evento cujo orçamento somava 14.750.
                                                        // Fallback em p.total para linha sem orçamento (fornecedor
                                                        // removido do orçamento, que tem total_atual_orcamento = 0).
                                                        const totalEvento         = grupo.planos.reduce((s, p) => {
                                                            const orcado = totalAtualOrcamentoBrl(p);
                                                            return s + (orcado > 0 ? orcado : (p.total || 0));
                                                        }, 0);
                                                        const origemEvento        = somarOrigens(grupo.planos.map(p => {
                                                            const orcado = totalAtualOrcamentoBrl(p);
                                                            return origemDoPlano(origemOpf[p.id], orcado > 0 ? orcado : (p.total || 0));
                                                        }));
                                                        const aguardando          = grupo.planos.filter(p => p.status === 'enviado').length;
                                                        const reprovados          = grupo.planos.filter(p => p.status === 'reprovado').length;
                                                        // 07/10: orcamento_alterado = complemento de plano que já estava em Contas Pendentes
                                                        const desatualizados      = grupo.planos.filter(p => p.desatualizado || p.orcamento_alterado).length;
                                                        const temAdiantamentoPrev = grupo.planos.some(function(p) { return !!p.evento_adiantamento_previsto; });
                                                        // abre automaticamente se houver itens aguardando ou desatualizados
                                                        const estaAberto  = eventosAbertos[grupo.evento_id] !== undefined
                                                            ? eventosAbertos[grupo.evento_id]
                                                            : (aguardando > 0 || desatualizados > 0);
                                                        return (
                                                            <div key={grupo.evento_id} className="fin-pp__grp">
                                                                {/* ── Cabeçalho clicável (acordeão) ── */}
                                                                <div className="fin-pp__grp-head"
                                                                    onClick={() => toggleEventoAberto(grupo.evento_id, estaAberto)}>
                                                                    <span className={'fin-pp__grp-caret' + (estaAberto ? ' is-open' : '')}>▶</span>
                                                                    <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>
                                                                    <span className="fin-pp__grp-name">{grupo.evento_nome}</span>
                                                                    <span className="fin-pp__grp-badge">{grupo.planos.length} fornecedor{grupo.planos.length !== 1 ? 'es' : ''}</span>
                                                                    {aguardando > 0 && (
                                                                        <span className="fin-pp__pill is-warn">{aguardando} aguardando</span>
                                                                    )}
                                                                    {desatualizados > 0 && (
                                                                        <span className="fin-pp__pill is-warn">⚠ {desatualizados} alterado{desatualizados !== 1 ? 's' : ''}</span>
                                                                    )}
                                                                    {reprovados > 0 && (
                                                                        <span className="fin-pp__pill is-danger">{reprovados} reprovado{reprovados !== 1 ? 's' : ''}</span>
                                                                    )}
                                                                    {temAdiantamentoPrev && (
                                                                        <span className="fin-pp__pill is-info">Adiantamento previsto</span>
                                                                    )}
                                                                    {(() => {
                                                                        const sc = saldosPorEvento[String(grupo.evento_id)];
                                                                        if (!sc) return null;
                                                                        return (
                                                                            <>
                                                                                <span className="fin-pp__pill is-info" title="Total já adiantado para este evento">
                                                                                    Adiantado: R$ {moeda(sc.total_adiantamento || 0)}
                                                                                </span>
                                                                                <span
                                                                                    className={'fin-pp__pill ' + ((sc.saldo || 0) > 0 ? 'is-ok' : 'is-muted')}
                                                                                    title="Saldo disponível na conta do evento">
                                                                                    Disponível: R$ {moeda(sc.saldo || 0)}
                                                                                </span>
                                                                                {/* Pedido de adiantamento que ainda NÃO caiu (Rafael, 10/09):
                                                                                    é o sinal que falta antes de aprovar pagamento ao
                                                                                    fornecedor — tem pedido, este valor, e ainda não entrou. */}
                                                                                {(sc.adiantamento_em_aberto || 0) > 0 && (
                                                                                    <span className="fin-pp__pill is-warn" title="Adiantamento solicitado ao cliente que ainda não foi creditado">
                                                                                        A receber: R$ {moeda(sc.adiantamento_em_aberto)}
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    })()}
                                                                    <span className="fin-pp__grp-total">Total: <strong>R$ {moeda(totalEvento)}</strong><OrigemMoeda origem={origemEvento} inline /></span>
                                                                </div>

                                                                {/* ── Tabela de fornecedores (colapsável) ── */}
                                                                {estaAberto && (
                                                                    <div className="fin-pp__tblwrap">
                                                                        <table className="fin-pp__tbl fin-pp__tbl--wide">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ width: '120px' }}>Status</th>
                                                                                    <th style={{ width: '220px' }}>Fornecedor</th>
                                                                                    <th style={{ width: '160px' }}>Orçamento</th>
                                                                                    <th style={{ width: '110px' }}>Data Previsão</th>
                                                                                    <th style={{ width: '115px' }}>Vencimento</th>
                                                                                    <th className="text-end" style={{ width: '120px' }}>Total</th>
                                                                                    <th style={{ width: '100px' }}>Forma Pgto</th>
                                                                                    <th style={{ width: '80px' }}>Tipo</th>
                                                                                    <th style={{ width: '150px' }}>Parcelas</th>
                                                                                    <th style={{ width: '210px' }}>Ações</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {grupo.planos.map(plano => {
                                                                                    const totalDiferente = (plano.desatualizado || plano.orcamento_alterado) && !plano.fornecedor_removido_orc;
                                                                                    const fornRemovido   = plano.fornecedor_removido_orc;
                                                                                    return (
                                                                                    <tr key={plano.id} title="Ver detalhes" onClick={(e) => abrirDetalhePrevisao(e, plano.id)}
                                                                                         style={ Object.assign({ cursor: 'pointer' }, plano.desatualizado ? { background: '#fffbf0' } : {}) }>
                                                                                        <td>
                                                                                            {plano.status === 'enviado' && (
                                                                                                <span className="fin-pp__pill is-warn">Aguardando</span>
                                                                                            )}
                                                                                            {plano.status === 'aprovado' && (
                                                                                                <span className="fin-pp__pill is-ok">Aprovado</span>
                                                                                            )}
                                                                                            {plano.status === 'reprovado' && (
                                                                                                <span className="fin-pp__pill is-danger">Reprovado</span>
                                                                                            )}
                                                                                            {fornRemovido && (
                                                                                                <div className="mt-1"><span className="fin-pp__minitag is-warn">🗑️ Removido do orç.</span></div>
                                                                                            )}
                                                                                            {totalDiferente && (
                                                                                                <div className="mt-1"><span className="fin-pp__minitag is-warn">⚠ Orç. alterado</span></div>
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            <div className="fin-pp__cell-strong fin-pp__ellipsis" title={nomeFornecedorPlano(plano)}>{nomeFornecedorPlano(plano)}</div>
                                                                                            {planoVindoDeADefinir(plano) && (
                                                                                                <span className="fin-pp__minitag is-info" style={{ marginRight: 4 }}
                                                                                                    title="As parcelas foram lançadas sem fornecedor e passaram para este fornecedor quando ele foi escolhido no orçamento">
                                                                                                    {TAG_VINDO_DE_A_DEFINIR}
                                                                                                </span>
                                                                                            )}
                                                                                            <TagNatureza natureza={plano.natureza} style={{ marginLeft: 0, marginRight: 4 }} />
                                                                                            {plano.visualizado_em && (
                                                                                                <span className="fin-pp__minitag is-ok" style={{ marginRight: 4 }}
                                                                                                    title={'Visualizado por ' + (plano.visualizado_por || '—') + ' em ' + new Date(plano.visualizado_em).toLocaleString('pt-BR')}>
                                                                                                    👁 Visualizado {new Date(plano.visualizado_em).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
                                                                                                </span>
                                                                                            )}
                                                                                            {(plano.invoices || []).map((inv) => (
                                                                                                <button key={inv.id} type="button" className="fin-pp__linkbtn" style={{ marginRight: 6, fontSize: '0.78rem' }}
                                                                                                    title={'Invoice anexada pelo Eventos: ' + inv.nome}
                                                                                                    onClick={() => baixarArquivoNF(inv.arquivo_id, inv.nome)}>📎 Invoice</button>
                                                                                            ))}
                                                                                            {/* Marcado lá na previsão pelo Eventos (Kátia, 14/08): este
                                                                                                fornecedor VAI PRECISAR de adiantamento. É só o aviso —
                                                                                                se vai ser feito e de quanto se resolve no Efetivo.
                                                                                                Este badge é o leitor que faltava: sem ele a marcação
                                                                                                seria write-only, que foi o motivo da UI antiga sair. */}
                                                                                            {(plano.parcelas || []).some(p => p.complemento) && (
                                                                                                <span className="fin-pp__minitag is-warn" style={{ marginRight: 4 }}
                                                                                                    title="O valor subiu no orçamento depois que o fornecedor já estava em Contas Pendentes. As parcelas antigas não mudaram; esta é só a diferença.">
                                                                                                    complemento — orçamento alterado
                                                                                                </span>
                                                                                            )}
                                                                                            {plano.adiantamento_previsto && (
                                                                                                <span className="fin-pp__minitag is-warn" title="O Eventos sinalizou na previsão que este fornecedor vai precisar de adiantamento">
                                                                                                    💰 Precisa de adiantamento
                                                                                                </span>
                                                                                            )}
                                                                                            {plano.fornecedor_cnpj && (
                                                                                                <div className="fin-pp__cell-muted fin-pp__ellipsis">{plano.fornecedor_cnpj}</div>
                                                                                            )}
                                                                                        </td>
                                                                                        {/* Rafael 06/10: nome do orçamento salvo pelo Eventos (código no tooltip). */}
                                                                                        <td className="text-muted" title={nomeOrcamentoDaLinha(plano) + ' (Orç. #' + plano.orcamento_codigo + ')'}><div style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{nomeOrcamentoDaLinha(plano)}</div></td>
                                                                                        {/* Rafael 06/10: data de cada parcela DESTA linha (não a data do plano). */}
                                                                                        <td>
                                                                                            {(() => {
                                                                                                const datas = datasParcelasDaLinha(plano);
                                                                                                if (datas.length === 0) return <span className="text-muted">A definir</span>;
                                                                                                return datas.map(d => (
                                                                                                    <div key={d} style={{ whiteSpace: 'nowrap' }}>{new Date(d + 'T12:00:00').toLocaleDateString('pt-BR')}</div>
                                                                                                ));
                                                                                            })()}
                                                                                        </td>
                                                                                        {/* Vencimento da próxima parcela (Kátia, 04/09) */}
                                                                                        <td>
                                                                                            {(() => {
                                                                                                const venc = proximoVencimentoDoPlano(plano);
                                                                                                if (!venc) return <span className="text-muted" style={{ fontSize: '0.78rem' }}>—</span>;
                                                                                                return (
                                                                                                    <div>
                                                                                                        <span className={'fin-pp__minitag' + (venc.vencida ? ' is-warn' : ' is-ok')}>
                                                                                                            {new Date(venc.data + 'T12:00:00').toLocaleDateString('pt-BR')}
                                                                                                        </span>
                                                                                                        {venc.total > 1 && (
                                                                                                            <div className="text-muted" style={{ fontSize: '0.7rem', marginTop: 2 }}>
                                                                                                                próxima de {venc.total}
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {venc.vencida && (
                                                                                                            <div style={{ fontSize: '0.7rem', marginTop: 2, color: 'var(--fin-wn)' }}>em atraso</div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                );
                                                                                            })()}
                                                                                        </td>
                                                                                        {/* Coluna TOTAL — mostra divergência quando orçamento foi alterado */}
                                                                                        <td className="text-end">
                                                                                            {plano.desatualizado ? (
                                                                                                <div>
                                                                                                    {fornRemovido ? (
                                                                                                        <span className="text-danger fw-semibold" style={{ fontSize: '0.8rem' }}>
                                                                                                            Removido
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <div className="fw-semibold" style={{ color: '#0a5c36' }} title="Total atual no orçamento">
                                                                                                                R$ {moeda(totalAtualOrcamentoBrl(plano))}
                                                                                                                <OrigemMoeda origem={origemDoPlano(origemOpf[plano.id], totalAtualOrcamentoBrl(plano))} />
                                                                                                            </div>
                                                                                                            <div className="text-muted text-decoration-line-through" style={{ fontSize: '0.75rem' }} title="Total da previsão enviada">
                                                                                                                R$ {moeda(plano.total)}
                                                                                                            </div>
                                                                                                            {plano.origem_valor && (
                                                                                                                <span style={{
                                                                                                                    background: plano.origem_valor === 'Fechamento' ? '#d1e7dd' : plano.origem_valor === 'Negociado' ? '#fff3cd' : '#cfe2ff',
                                                                                                                    color:      plano.origem_valor === 'Fechamento' ? '#0f5132' : plano.origem_valor === 'Negociado' ? '#664d03' : '#084298',
                                                                                                                    borderRadius: '4px', padding: '1px 5px',
                                                                                                                    fontSize: '0.6rem', fontWeight: 600,
                                                                                                                    display: 'inline-block', marginTop: '2px',
                                                                                                                }}>
                                                                                                                    {plano.origem_valor}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <>
                                                                                                    {/* Sem parcela, o "total das parcelas" seria R$ 0,00 — mostra o
                                                                                                        orçado atual, que é o que o Financeiro avalia para aprovar */}
                                                                                                    <span className="fw-semibold">R$ {moeda((plano.parcelas && plano.parcelas.length > 0) ? plano.total : totalAtualOrcamentoBrl(plano))}</span>
                                                                                                    <OrigemMoeda origem={origemDoPlano(origemOpf[plano.id], (plano.parcelas && plano.parcelas.length > 0) ? plano.total : totalAtualOrcamentoBrl(plano))} />
                                                                                                    {plano.origem_valor && (
                                                                                                        <div>
                                                                                                            <span style={{
                                                                                                                background: plano.origem_valor === 'Fechamento' ? '#d1e7dd' : plano.origem_valor === 'Negociado' ? '#fff3cd' : '#cfe2ff',
                                                                                                                color:      plano.origem_valor === 'Fechamento' ? '#0f5132' : plano.origem_valor === 'Negociado' ? '#664d03' : '#084298',
                                                                                                                borderRadius: '4px',
                                                                                                                padding: '1px 5px',
                                                                                                                fontSize: '0.6rem',
                                                                                                                fontWeight: 600,
                                                                                                                display: 'inline-block',
                                                                                                                marginTop: '2px',
                                                                                                            }}>
                                                                                                                {plano.origem_valor}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                        </td>
                                                                                        {/* Forma Pgto — formas únicas das parcelas */}
                                                                                        <td>
                                                                                            <div className="d-flex flex-wrap gap-1">
                                                                                                {[...new Set((plano.parcelas || []).map(p => p.forma).filter(Boolean))].map(f => (
                                                                                                    <span key={f} className="fin-pp__minitag is-info">{labelFormaPgto(f)}</span>
                                                                                                ))}
                                                                                                {!(plano.parcelas || []).some(p => p.forma) && <span className="text-muted" style={{ fontSize: '0.78rem' }}>—</span>}
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* Tipo — tipo_documento do OPF (NF/ND/Recibo) */}
                                                                                        <td>
                                                                                            {plano.tipo_documento ? (
                                                                                                <span className={'fin-pp__minitag' + (plano.tipo_documento === 'nf' ? ' is-ok' : plano.tipo_documento === 'nd' ? ' is-warn' : '')}>
                                                                                                    {plano.tipo_documento.toUpperCase()}
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span className="text-muted" style={{ fontSize: '0.78rem' }}>—</span>
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {(plano.parcelas && plano.parcelas.length > 0) ? (
                                                                                                <div>
                                                                                                    {plano.parcelas.map(function(p, i) {
                                                                                                        var dadosPg = resumoDadosPagamento(p.dados_pagamento);
                                                                                                        return (
                                                                                                            // Valor em cima, forma/data embaixo: em uma linha só a
                                                                                                            // coluna estourava a largura e a tabela cortava o texto.
                                                                                                            <div key={i} style={{ fontSize: '0.72rem', lineHeight: 1.5, marginBottom: 4 }}>
                                                                                                                <div><strong>{moeda(p.valor)}</strong></div>
                                                                                                                {/* D-0095: adiantamento que o Eventos atribuiu a esta parcela no Efetivo */}
                                                                                                                {p.valor_adiantamento_parcela > 0 && (
                                                                                                                    <div style={{ color: '#0369a1' }}>
                                                                                                                        🟠 Adiant. − {moeda(p.valor_adiantamento_parcela)} · A pagar {moeda(p.a_pagar)}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                                <PagamentoLegadoParcela info={p.pagamento_legado} onAtualizado={() => recarregarCustoPrevisto()} />
                                                                                                                {(p.forma || p.data_pagamento) ? (
                                                                                                                    <div className="text-muted">
                                                                                                                        {p.forma ? labelFormaPgto(p.forma) : null}
                                                                                                                        {(p.forma && p.data_pagamento) ? ' · ' : null}
                                                                                                                        {p.data_pagamento ? new Date(p.data_pagamento + 'T12:00:00').toLocaleDateString('pt-BR') : null}
                                                                                                                    </div>
                                                                                                                ) : null}
                                                                                                                {dadosPg ? <div style={{ color: '#586478' }}>{dadosPg}</div> : null}
                                                                                                            </div>
                                                                                                        );
                                                                                                    })}
                                                                                                </div>
                                                                                            ) : (
                                                                                                /* Plano enviado sem parcela montada: aparece mesmo assim
                                                                                                   (Rafael 11/09) — o Financeiro vê a previsão do evento e
                                                                                                   aprova/recusa; sem parcela e sem dados, quem segura é o
                                                                                                   Liberar p/ pgto na saída. */
                                                                                                <span className="fin-pp__minitag is-warn">Sem parcelas</span>
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {fornRemovido ? (
                                                                                                // Fornecedor removido do orçamento — bloqueia ação
                                                                                                <div style={{ fontSize: '0.78rem', color: '#7a5000', maxWidth: 180 }}>
                                                                                                    🗑️ Fornecedor removido do orçamento — exclua esta previsão
                                                                                                </div>
                                                                                            ) : (
                                                                                                // Seção topo mostra apenas enviados → sempre exibe Aprovar/Reprovar
                                                                                                <div>
                                                                                                    {plano.desatualizado && (() => {
                                                                                                        // O aviso sozinho era decorativo: dava para aprovar
                                                                                                        // 20.000 num orçamento de 10.000 (Kátia, 14/08).
                                                                                                        // Agora o backend barra, e aqui fica a saída — senão
                                                                                                        // o operador ficaria travado, tendo que refazer as
                                                                                                        // parcelas na mão.
                                                                                                        const orcado = totalAtualOrcamentoBrl(plano);
                                                                                                        const emParcelas = parseFloat(plano.total) || 0;
                                                                                                        const passou = orcado > 0 && emParcelas > orcado + 0.01;
                                                                                                        return (
                                                                                                            <div style={{ fontSize: '0.72rem', color: '#7a5000', marginBottom: 4, maxWidth: 175 }}>
                                                                                                                ⚠️ {passou ? 'Parcelas acima do orçamento' : 'Valores divergem do orçamento'}
                                                                                                                <div style={{ fontSize: '0.7rem', opacity: 0.9 }}>
                                                                                                                    parcelas R$ {moeda(emParcelas)} · orçado R$ {moeda(orcado)}
                                                                                                                </div>
                                                                                                                {passou && (
                                                                                                                    <button type="button"
                                                                                                                        className="fin-pp__btn fin-pp__btn--sm"
                                                                                                                        style={{ marginTop: 4, fontSize: '0.7rem' }}
                                                                                                                        disabled={!!ajustando[plano.id]}
                                                                                                                        onClick={() => ajustarParcelas(plano)}>
                                                                                                                        {ajustando[plano.id] ? 'Ajustando...' : 'Ajustar ao orçamento'}
                                                                                                                    </button>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        );
                                                                                                    })()}
                                                                                                    {/* Só ícone: com o rótulo os dois botões estouravam a
                                                                                                        coluna e a tabela cortava o texto. O title mantém o
                                                                                                        significado no hover e para leitor de tela. */}
                                                                                                    {/* Só ícone: com o rótulo os dois botões estouravam a
                                                                                                        coluna e a tabela cortava o texto. Quadrado de 40px
                                                                                                        para o alvo de clique continuar confortável sem o
                                                                                                        texto. O title mantém o significado no hover e para
                                                                                                        leitor de tela. */}
                                                                                                    <div className="d-flex gap-2">
                                                                                                        {plano.natureza === 'internacional' && plano.status === 'enviado' && !plano.visualizado_em && (
                                                                                                            <button type="button" className="fin-pp__btn"
                                                                                                                title="Visualizado — avisa o Eventos que o Financeiro viu esta Previsão" aria-label="Marcar como visualizado"
                                                                                                                disabled={!!marcandoVisualizado[plano.id]}
                                                                                                                style={{ width: 40, height: 40, padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                                                                onClick={() => marcarVisualizado(plano)}>
                                                                                                                <FaEye size={17} />
                                                                                                            </button>
                                                                                                        )}
                                                                                                        <button type="button" className="fin-pp__btn fin-pp__btn--ok"
                                                                                                            title="Aprovar" aria-label="Aprovar"
                                                                                                            style={{ width: 40, height: 40, padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                                                            onClick={() => abrirAprovarPlano(plano)}>
                                                                                                            <FaCheck size={17} />
                                                                                                        </button>
                                                                                                        <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost"
                                                                                                            title="Reprovar" aria-label="Reprovar"
                                                                                                            style={{ width: 40, height: 40, padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                                                            onClick={() => { setPlanoReprovarModal(plano); setMotivoReprovacaoPlano(''); }}>
                                                                                                            <FaTimes size={17} />
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                    </div>
                                                    ))}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {/* ── Aprovados — Aguardando NF do Fornecedor (adiantamentos + previsões) ── */}
                {abaAtiva === 'custoPrevisto' && abaVinculo === 'eventos' && subAbaCusto === 'aprovados' && (() => {
                    // Aprovados pelo diretor mas ainda NÃO liberados para pagamento
                    // Creditados saem daqui e vão para Contas Pendentes automaticamente
                    const adiantAprovados = adiantamentos.filter(a => !!a.dataAprovacaoDiretor && !a.liberado_financeiro_at && a.status_pagamento !== 'creditado');
                    // Lista PRÓPRIA desta aba, já filtrada no servidor pelo filtro dela.
                    const aprovadosOPF = aprovadosPrevistos.filter(p => p.status === 'aprovado' && !p.liberado_financeiro_at);
                    // A parcela de adiantamento não traz o cliente; a lista de planos
                    // traz evento → cliente, o que cobre os eventos que também têm
                    // previsão. Sem plano no evento, o adiantamento fica "Sem cliente".
                    const clientePorEvento = {};
                    aprovadosPrevistos.forEach(function (p) {
                        if (p.evento_id && p.cliente_id) {
                            clientePorEvento[String(p.evento_id)] = { id: p.cliente_id, nome: p.cliente_nome || 'Sem cliente' };
                        }
                    });
                    const clienteDoEvento = function (evId) { return clientePorEvento[String(evId)] || {}; };
                    // Normaliza adiantamentos e OPFs em shape comum
                    const itens = [
                        ...adiantAprovados.map(a => ({
                            _key:          'adt_' + a.id,
                            _id:           a.id,
                            _tipo:         'adiantamento',
                            nf_vinculada:  !!(a.nota_fiscal_id || a.arquivonotafiscal),
                            nf_solicitada_em: null,
                            nf_arquivo_id:   (a.arquivonotafiscal && typeof a.arquivonotafiscal === 'object')
                                ? String(a.arquivonotafiscal.id)
                                : null,
                            nf_arquivo_nome: (a.arquivonotafiscal && typeof a.arquivonotafiscal === 'object')
                                ? (a.arquivonotafiscal.nome || 'nota_fiscal')
                                : null,
                            fornecedor_email: (function() {
                                // Laravel serializa 'orcamentoItem' como 'orcamento_item' (snake_case) no JSON
                                var itens = (a.titulo && (a.titulo.orcamento_item || a.titulo.orcamentoItem || a.titulo.OrcamentoItem)) || [];
                                for (var _i = 0; _i < itens.length; _i++) {
                                    var fp = itens[_i].fornecedorpagamento || itens[_i].Fornecedorpagamento;
                                    if (fp && typeof fp === 'object' && fp.email) return fp.email;
                                    var f = itens[_i].fornecedor || itens[_i].Fornecedor;
                                    if (f && typeof f === 'object' && f.email) return f.email;
                                }
                                return (a.Participante && a.Participante.email) || (a.participante && a.participante.email) || '';
                            })(),
                            evento_id:   (a.titulo && a.titulo.evento && a.titulo.evento.id)   ? a.titulo.evento.id   : '__sem_evento__',
                            evento_nome: (a.titulo && a.titulo.evento && a.titulo.evento.nome) ? a.titulo.evento.nome : '(sem evento)',
                            cliente_id:   clienteDoEvento((a.titulo && a.titulo.evento && a.titulo.evento.id) || '').id || null,
                            cliente_nome: clienteDoEvento((a.titulo && a.titulo.evento && a.titulo.evento.id) || '').nome || 'Sem cliente',
                            fornecedor: (function() {
                                // Laravel serializa 'orcamentoItem' como 'orcamento_item' (snake_case) no JSON
                                var itens = (a.titulo && (a.titulo.orcamento_item || a.titulo.orcamentoItem || a.titulo.OrcamentoItem)) || [];
                                for (var _i = 0; _i < itens.length; _i++) {
                                    var fp = itens[_i].fornecedorpagamento || itens[_i].Fornecedorpagamento;
                                    if (fp && typeof fp === 'object' && fp.id !== 'cliente' && fp.id !== 'agencia') {
                                        var nomeFP = fp.nomefantasia || fp.nome;
                                        if (nomeFP) return nomeFP;
                                    }
                                    var f = itens[_i].fornecedor || itens[_i].Fornecedor;
                                    if (f && typeof f === 'object') {
                                        var nomeF = f.nomefantasia || f.nome;
                                        if (nomeF) return nomeF;
                                    }
                                }
                                // Nenhum fornecedor encontrado nos itens — não mostrar o cliente como fornecedor
                                return '—';
                            })(),
                            referencia:       a.descricao || '—',
                            natureza:         a.natureza || null,
                            data:             a.vencimento,
                            formas:           [],
                            tipo_doc:         null,
                            total:            parseFloat(a.valor || 0),
                            parcelas_qt:      1,
                            pagamento_legado: a.pagamento_legado || null,
                            status_pagamento:         a.status_pagamento || null,
                            status_pagamento_obs:     a.status_pagamento_obs || null,
                            liberado_financeiro_at:   a.liberado_financeiro_at || null,
                            _parcelaId:               a.id,
                            // OrcamentoId para link de renegociação (via titulo.orcamento_item[].orcamento)
                            _orcamentoId: (function() {
                                var ois = (a.titulo && (a.titulo.orcamento_item || a.titulo.orcamentoItem)) || [];
                                for (var _oi = 0; _oi < ois.length; _oi++) {
                                    var orc = ois[_oi].orcamento;
                                    if (orc) { return typeof orc === 'object' ? orc.id : orc; }
                                }
                                return null;
                            })(),
                            // Recibo de adiantamento — id do arquivo para download
                            recibo_arquivo_id: (function() {
                                var r = a.arquivoreciboadiantamento;
                                if (!r) return null;
                                if (typeof r === 'object') return r.id ? String(r.id) : null;
                                return String(r);
                            })(),
                            recibo_nome: (function() {
                                var r = a.arquivoreciboadiantamento;
                                return (r && typeof r === 'object' && r.nome) ? r.nome : 'recibo_adiantamento';
                            })(),
                        })),
                        ...aprovadosOPF.map(p => ({
                            _key:             'opf_' + p.id,
                            _id:              p.id,
                            _tipo:            'previsao',
                            nf_vinculada:     p.nf_vinculada || false,
                            nf_solicitada_em: p.nf_solicitada_em || null,
                            nf_arquivo_id:         p.nf_arquivo_id || null,
                            nf_arquivo_nome:       p.nf_arquivo_nome || null,
                            nf_valor_adiantamento: p.nf_valor_adiantamento || null,
                            nf_valor_liquido:      p.nf_valor_liquido || null,
                            usar_adiantamento:     p.usar_adiantamento || 'nao',
                            valor_adiantamento:    p.valor_adiantamento || 0,
                            adiantamento_ja_abatido: !!p.adiantamento_ja_abatido,
                            nfs:                   p.nfs || [],
                            nfs_orcamento:         p.nfs_orcamento || [],
                            nfs_canceladas:        p.nfs_canceladas || [],
                            // D-0099: a NF de cada parcela do plano (ou "NF pendente")
                            nf_por_parcela:        !!p.nf_por_parcela,
                            nf_parcelas:           p.nf_parcelas || [],
                            fornecedor_email: p.email_fornecedor_nf || p.fornecedor_email || '',
                            evento_id:   p.evento_id   || '__sem_evento__',
                            evento_nome: p.evento_nome || '(sem evento)',
                            cliente_id:   p.cliente_id || null,
                            cliente_nome: p.cliente_nome || 'Sem cliente',
                            fornecedor:  nomeFornecedorPlano(p),
                            // Sem fornecedor (30/09): aprova, mas não libera para pgto.
                            a_definir:           p.a_definir === true,
                            fornecedor_definido: planoVindoDeADefinir(p),
                            // D-0127: marcado "não vai para Contas a Pagar" na Previsão — não libera para pgto.
                            vai_contas_pagar:    vaiParaContasPagar(p),
                            natureza:    p.natureza || null,
                            cambio_banco: p.cambio_banco || null,
                            referencia:  nomeOrcamentoDaLinha(p),
                            referencia_codigo: 'Orç. #' + p.orcamento_codigo,
                            data:        p.data_previsao_pagamento,
                            // Rafael 06/10: a coluna Data mostra cada parcela DESTA linha com a forma de pagamento.
                            datas:       parcelasDataFormaDaLinha(p),
                            formas:      [...new Set((p.parcelas || []).map(x => x.forma).filter(Boolean))],
                            tipo_doc:    p.tipo_documento,
                            total:       p.total || 0,
                            parcelas_qt:            (p.parcelas && p.parcelas.length) || 0,
                            parcelas:               p.parcelas || [],
                            liberado_financeiro_at: p.liberado_financeiro_at || null,
                            // Tem como ser pago? Vem do mesmo cálculo que o gate da
                            // liberação usa — undefined (API antiga) não bloqueia nada.
                            pagavel:                p.pagavel,
                            // D-0130: false = aprovado sem conta viva no Financeiro (undefined = API antiga, não bloqueia).
                            tem_conta_viva:         p.tem_conta_viva,
                            // D-0131: sem conta viva, o que impede a conta de nascer no clique (null = nasce).
                            conta_pendente_motivo:  p.conta_pendente_motivo,
                            pendencias_pagamento:   p.pendencias_pagamento || [],
                            // D-0097: por que não volta para Planos de Pagamento (null = pode; ausente = API antiga).
                            motivo_nao_volta:       p.motivo_nao_volta,
                        })),
                    ];
                    // Sem NADA aprovado a seção não existe — e aí não há filtro que
                    // resolva. Quando some por causa do filtro, a barra continua na
                    // tela (senão o operador fica sem como desfazer).
                    if (itens.length === 0) return null;
                    // Previsões e adiantamentos já vêm filtrados do servidor, cada um
                    // no seu endpoint, com o mesmo filtro desta aba. Nada de recorte
                    // aqui: sem realtime, filtrar na tela é filtrar a lista que
                    // chegou (Rafael, 10/09).
                    const itensNoFiltro = itens;
                    const opcoesClientesAprovados = opcoesClientesDe(Object.values(itens.reduce(function (acc, i) {
                        var k = i.cliente_id || '__sem_cliente__';
                        if (!acc[k]) acc[k] = { cliente_id: i.cliente_id, cliente_nome: i.cliente_nome || 'Sem cliente' };
                        return acc;
                    }, {})));
                    // ── Filtra por sub-aba (Previsões / Adiantamentos) ──
                    const itensFiltrados = itensNoFiltro.filter(function(i) {
                        return abaAprovados === 'adiantamentos' ? i._tipo === 'adiantamento' : i._tipo === 'previsao';
                    });
                    const porEvento = itensFiltrados.reduce((acc, item) => {
                        const key = item.evento_id;
                        if (!acc[key]) acc[key] = { evento_id: item.evento_id, evento_nome: item.evento_nome, itens: [] };
                        acc[key].itens.push(item);
                        return acc;
                    }, {});
                    const totalGeral = itensFiltrados.reduce((s, item) => s + item.total, 0);
                    const qtPrevisoes    = itensNoFiltro.filter(function(i) { return i._tipo === 'previsao'; }).length;
                    const qtAdiantamentos = itensNoFiltro.filter(function(i) { return i._tipo === 'adiantamento'; }).length;
                    return (
                        <section style={{ marginTop: 28 }}>
                            <div className="mb-4">
                                <div>
                                    <div className="fin-pp__region">
                                        <div className="fin-pp__cphead">
                                            <span className="fin-pp__cphead-ic is-ok"><FaFileAlt size={18} /></span>
                                            <div style={{ minWidth: 0 }}>
                                                <h2 className="fin-pp__cphead-title">Aprovados pelo Financeiro — Situação NF</h2>
                                                <p className="fin-pp__cphead-sub">Planos e adiantamentos aprovados. Itens sem NF aguardam envio do documento fiscal pelo fornecedor.</p>
                                            </div>
                                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                                {(() => {
                                                    const semNF = itensFiltrados.filter(function(i) { return !i.nf_vinculada; }).length;
                                                    const comNF = itensFiltrados.filter(function(i) { return i.nf_vinculada; }).length;
                                                    return (
                                                        <>
                                                            {semNF > 0 && <span className="fin-pp__pill is-warn">{semNF} sem NF</span>}
                                                            {comNF > 0 && <span className="fin-pp__pill is-ok">{comNF} com NF</span>}
                                                        </>
                                                    );
                                                })()}
                                                <span className="fin-pp__grp-total">Total: <strong>R$ {moeda(totalGeral)}</strong></span>
                                            </div>
                                        </div>
                                        {/* ── Sub-abas Previsões / Adiantamentos ── */}
                                        <div className="fin-pp__seg" style={{ marginBottom: 14 }}>
                                            {[
                                                { key: 'previsoes',    label: 'Previsões',    count: qtPrevisoes },
                                                { key: 'adiantamentos', label: 'Adiantamentos', count: qtAdiantamentos },
                                            ].map(function(tab) {
                                                var ativa = abaAprovados === tab.key;
                                                return (
                                                    <button key={tab.key} type="button"
                                                        onClick={() => setAbaAprovados(tab.key)}
                                                        className={'fin-pp__seg-btn' + (ativa ? ' is-active' : '')}>
                                                        {tab.label}
                                                        <span className="fin-pp__seg-count">{tab.count}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        <div className="fin-pp__region-body">
                                            {/* Barra de filtros própria desta aba — fora do bloco
                                                condicional para não sumir junto com a lista vazia. */}
                                            <div style={{ padding: '14px 14px 0' }}>
                                                {renderFiltroClienteEvento(opcoesClientesAprovados)}
                                            </div>
                                            {itensFiltrados.length === 0 ? (
                                                <div className="text-center py-4 text-muted">
                                                    {temFiltroAtivoNaAba()
                                                        ? 'Nenhum item no período ou filtro selecionado.'
                                                        : 'Nenhum item nesta aba.'}
                                                    {temFiltroAtivoNaAba() && (
                                                        <div className="mt-2">
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={limparFiltrosDaAba}>
                                                                <FaTimes size={12} /> Limpar filtros
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                            <>
                                            {itensFiltrados.some(function(i) { return !i.nf_vinculada; }) && avisoVisivel('itens-sem-nf') && (
                                                <div className="fin-pp__banner is-warn" style={{ margin: '14px 14px 0' }}>
                                                    <FaFileInvoice className="fin-pp__banner-ic" size={16} />
                                                    <span>Itens sem NF. Use <strong>Solicitar ao fornecedor</strong> para enviar link de upload, ou <strong>Vincular NF</strong> para registrar o documento internamente.</span>
                                                    {botaoFecharAviso('itens-sem-nf')}
                                                </div>
                                            )}
                                            <div className="fin-pp__groups" style={{ padding: 14 }}>
                                                {Object.values(porEvento).map(grupo => {
                                                    const totalEvento = grupo.itens.reduce((s, item) => s + item.total, 0);
                                                    const origemEvento = somarOrigens(grupo.itens.map(item => item._tipo === 'previsao' ? origemDoPlano(origemOpf[item._id], item.total) : null));
                                                    const estaAberto  = eventosAbertos['unif_' + grupo.evento_id] !== undefined
                                                        ? eventosAbertos['unif_' + grupo.evento_id] : true;
                                                    return (
                                                        <div key={grupo.evento_id} className="fin-pp__grp">
                                                            <div className="fin-pp__grp-head"
                                                                onClick={() => toggleEventoAberto('unif_' + grupo.evento_id, estaAberto)}>
                                                                {/* Esquerda: nome do evento + contagem */}
                                                                <div className="d-flex align-items-center gap-2" style={{ minWidth: 0, flex: 1 }}>
                                                                    <span className={'fin-pp__grp-caret' + (estaAberto ? ' is-open' : '')} style={{ flexShrink: 0 }}>▶</span>
                                                                    <span className="fin-pp__grp-ic" style={{ flexShrink: 0 }}><FaCalendarAlt size={15} /></span>
                                                                    <span className="fin-pp__grp-name text-truncate">{grupo.evento_nome}</span>
                                                                    <span className="fin-pp__grp-badge" style={{ flexShrink: 0 }}>{grupo.itens.length} {grupo.itens.length !== 1 ? 'itens' : 'item'}</span>
                                                                    {(function () {
                                                                        // Todas as NFs do(s) orçamento(s) do evento, deduplicadas
                                                                        // (cada linha repete a lista do seu orçamento). É a visão
                                                                        // completa — a pill de cada linha mostra só as do fornecedor.
                                                                        var vistos = {}; var todas = []; var canceladasEv = [];
                                                                        grupo.itens.forEach(function (i) {
                                                                            (i.nfs_orcamento || []).forEach(function (nf) {
                                                                                if (vistos[nf.nota_fiscal_id]) return;
                                                                                vistos[nf.nota_fiscal_id] = true; todas.push(nf);
                                                                            });
                                                                            (i.nfs_canceladas || []).forEach(function (nfc) {
                                                                                if (vistos['c' + nfc.id]) return;
                                                                                vistos['c' + nfc.id] = true; canceladasEv.push(nfc);
                                                                            });
                                                                        });
                                                                        if (todas.length === 0) return null;
                                                                        return (
                                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                                                style={{ flexShrink: 0, fontSize: '0.72rem', padding: '2px 8px' }}
                                                                                title="Ver todas as notas fiscais do evento"
                                                                                onClick={function (e) {
                                                                                    e.stopPropagation();
                                                                                    setModalNFs({ item: { fornecedor: grupo.evento_nome, referencia: 'todas as NFs do evento', nfs: todas, nfs_canceladas: canceladasEv } });
                                                                                }}>
                                                                                📄 Ver NFs ({todas.length})
                                                                            </button>
                                                                        );
                                                                    })()}
                                                                </div>
                                                                {/* Direita: Status Pgto + Total */}
                                                                <div className="d-flex align-items-center gap-3" style={{ flexShrink: 0 }}>
                                                                    {abaAprovados === 'adiantamentos' && (function() {
                                                                        var itemRef = grupo.itens.find(function(i) { return i._tipo === 'adiantamento'; });
                                                                        if (!itemRef) return null;
                                                                        var sp      = itemRef.status_pagamento;
                                                                        return (
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                {/* Botão "Definir status" ocultado — a decisão de crédito agora é feita em Contas a Receber → "Informar Crédito" */}
                                                                                {/* Renegociar = equipe do evento (Rafael, 28/09); o Financeiro só informa o crédito. */}
                                                                                {sp === 'nao_creditado' && podeRenegociarAdiantamento(perfil) && (
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={function(e) {
                                                                                            e.stopPropagation();
                                                                                            // Busca orcamentoId via API (não confia na relação do estado, que pode não vir carregada)
                                                                                            api({ method: 'get', action: '/financeiroParcela/itensAdiantamento/' + itemRef._parcelaId, token: token })
                                                                                                .then(function(resp) {
                                                                                                    var itensAdt = (resp.data && resp.data.data && resp.data.data.itens) || [];
                                                                                                    var orcId = itensAdt.length > 0 ? itensAdt[0].orcamentoId : null;
                                                                                                    if (!orcId) { toast.error('Não foi possível identificar o orçamento deste adiantamento.'); return; }
                                                                                                    var eventoParam = filtro.evento ? '&evento=' + filtro.evento : '';
                                                                                                    history.push('/solicitarAdiantamento/' + orcId + '?renegociar=' + itemRef._parcelaId + eventoParam);
                                                                                                })
                                                                                                .catch(function() { toast.error('Erro ao buscar dados do adiantamento.'); });
                                                                                        }}
                                                                                        style={{
                                                                                            background: '#fff3cd', color: '#856404',
                                                                                            border: '1px solid #ffc107',
                                                                                            borderRadius: 20, padding: '3px 12px',
                                                                                            fontSize: '0.72rem', fontWeight: 600,
                                                                                            cursor: 'pointer', whiteSpace: 'nowrap',
                                                                                        }}
                                                                                        title="Renegociar adiantamento com fornecedor"
                                                                                    >
                                                                                        🔄 Renegociar
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                    <span className="fin-pp__grp-total" style={{ whiteSpace: 'nowrap' }}>Total: <strong>R$ {moeda(totalEvento)}</strong><OrigemMoeda origem={origemEvento} inline /></span>
                                                                </div>
                                                            </div>
                                                            {estaAberto && (
                                                                <div className="fin-pp__tblwrap">
                                                                    {/* minWidth: em tela estreita a tabela rola na horizontal em vez de sobrepor as colunas (06/10). */}
                                                                    <table className="fin-pp__tbl" style={{ minWidth: 1180 }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{ width: '110px' }}>Tipo</th>
                                                                                <th>Fornecedor</th>
                                                                                <th style={{ width: '170px' }}>Referência</th>
                                                                                <th style={{ width: '170px' }}>Data</th>
                                                                                <th className="text-end" style={{ width: '130px' }}>Total</th>
                                                                                <th style={{ width: '150px' }}>Situação NF</th>
                                                                                <th className="text-end" style={{ width: '220px' }}>Ações</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {grupo.itens.map(item => (
                                                                                <tr key={item._key}
                                                                                    style={{ cursor: 'pointer' }} title="Ver detalhes"
                                                                                    onClick={(e) => (item._tipo === 'adiantamento' ? abrirDetalheAdiantamento(e, item._id) : abrirDetalhePrevisao(e, item._id))}>
                                                                                    <td>
                                                                                        {item._tipo === 'adiantamento' ? (
                                                                                            <span className="fin-pp__minitag is-warn">Adiantamento</span>
                                                                                        ) : (
                                                                                            <span className="fin-pp__minitag is-info">Previsão</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td><div className="fin-pp__cell-strong fin-pp__ellipsis" title={item.fornecedor}>{item.fornecedor}</div>{item.fornecedor_definido && (
                                                                                        <span className="fin-pp__minitag is-info" style={{ marginRight: 4 }}
                                                                                            title="As parcelas foram lançadas sem fornecedor e passaram para este fornecedor quando ele foi escolhido no orçamento">
                                                                                            {TAG_VINDO_DE_A_DEFINIR}
                                                                                        </span>
                                                                                    )}<TagNatureza natureza={item.natureza} style={{ marginLeft: 0 }} />{item.cambio_banco && (
                                                                                        <span className="fin-pp__minitag is-info" style={{ marginLeft: 4 }}
                                                                                            title={'Cotação do banco ' + formatarCambio(item.cambio_banco.cotacao) + ' · IOF R$ ' + moeda(item.cambio_banco.iof_brl) + ' · IR R$ ' + moeda(item.cambio_banco.ir_brl) + ' · taxa R$ ' + moeda(item.cambio_banco.taxa_brl) + (item.cambio_banco.por ? ' · por ' + item.cambio_banco.por : '')}>
                                                                                            Cotação {formatarCambio(item.cambio_banco.cotacao)}
                                                                                        </span>)}</td>
                                                                                    <td className="text-muted small" title={item.referencia_codigo ? item.referencia + ' (' + item.referencia_codigo + ')' : undefined}>
                                                                                        <div>{item.referencia}</div>
                                                                                        <PagamentoLegadoParcela info={item.pagamento_legado} onAtualizado={() => recarregarCustoPrevisto()} />
                                                                                        {(item.parcelas || []).map((parc, idx) => (
                                                                                            <div key={parc.id} data-legado-parcela-aprovada>
                                                                                                <span>Parcela {idx + 1} · R$ {moeda(parc.valor)}</span>
                                                                                                {ehCartaoFisico(parc.forma) && (valorReal(parc.dados_pagamento) > 0 ? (
                                                                                                    <span className={'fin-pp__minitag ms-1 ' + (acimaDaEstimativa(valorReal(parc.dados_pagamento), parc.valor) ? 'is-warn' : 'is-ok')}
                                                                                                        title="Cartão físico: valor real informado no Efetivo">
                                                                                                        💳 Real R$ {moeda(valorReal(parc.dados_pagamento))}
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span className="fin-pp__minitag is-warn ms-1" title={MSG_AGUARDANDO_COMPRAS}>💳 Estimativa · aguardando compras</span>
                                                                                                ))}
                                                                                                <PagamentoLegadoParcela info={parc.pagamento_legado} onAtualizado={() => recarregarCustoPrevisto()} />
                                                                                            </div>
                                                                                        ))}
                                                                                    </td>
                                                                                    <td className="text-muted small">
                                                                                        {Array.isArray(item.datas)
                                                                                            ? (item.datas.length === 0 ? '—' : item.datas.map((d, i) => (
                                                                                                <div key={d.data + '-' + i}>
                                                                                                    <span style={{ whiteSpace: 'nowrap' }}>{new Date(d.data + 'T12:00:00').toLocaleDateString('pt-BR')}</span>
                                                                                                    {d.forma ? <span className="text-muted"> · {labelFormaPgto(d.forma)}</span> : null}
                                                                                                </div>
                                                                                            )))
                                                                                            : (item.data ? new Date(item.data + 'T00:00:00').toLocaleDateString('pt-BR') : '—')}
                                                                                    </td>
                                                                                    <td className="fin-pp__cell-num"><ValorComOrigem valor={item.total} origem={item._tipo === 'previsao' ? origemDoPlano(origemOpf[item._id], item.total) : null} /></td>
                                                                                    {/* Situação NF */}
                                                                                    <td>
                                                                                        {item.nf_vinculada ? (
                                                                                            // O fornecedor pode emitir mais de uma NF por orçamento —
                                                                                            // com lista, o botão abre o modal com TODAS. Sem a lista
                                                                                            // (payload antigo), cai no download direto da última.
                                                                                            (item.nfs && item.nfs.length > 0) ? (
                                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
                                                                                                    <button type="button" className="fin-pp__pill is-ok" style={{ border: 'none', cursor: 'pointer' }}
                                                                                                        title="Ver notas fiscais deste item"
                                                                                                        onClick={() => setModalNFs({ item: item })}>
                                                                                                        📄 {item.nfs.length > 1 ? item.nfs.length + ' NFs' : 'Ver NF'}
                                                                                                    </button>
                                                                                                    {(item.nfs_canceladas || []).length > 0 && (
                                                                                                        <span className="fin-pp__minitag" style={{ background: 'var(--fin-dgb)', color: 'var(--fin-dg)' }}
                                                                                                            title={(item.nfs_canceladas.some(function (c) { return c.nf_ativa; }) ? 'A nota cancelada ainda está ativa no sistema — conferir no Efetivo. ' : '') + 'Comprovante enviado pelo fornecedor'}>
                                                                                                            + {item.nfs_canceladas.length} NF cancelada{item.nfs_canceladas.length > 1 ? 's' : ''}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    {/* Conferência automática da NF (item 21) — só aviso */}
                                                                                                    <NfValidacaoPill validacao={piorValidacao(item.nfs)} />
                                                                                                </div>
                                                                                            ) : item.nf_arquivo_id ? (
                                                                                                <button type="button" className="fin-pp__pill is-ok" style={{ border: 'none', cursor: 'pointer' }}
                                                                                                    onClick={() => baixarArquivoNF(item.nf_arquivo_id, item.nf_arquivo_nome)}>
                                                                                                    ⬇ Baixar NF
                                                                                                </button>
                                                                                            ) : (
                                                                                                <span className="fin-pp__pill is-ok">NF Vinculada</span>
                                                                                            )
                                                                                        ) : item.nf_solicitada_em ? (
                                                                                            <div>
                                                                                                <span className="fin-pp__pill is-info">Aguardando NF</span>
                                                                                                <small className="d-block text-muted mt-1" style={{ fontSize: '0.67rem' }}>
                                                                                                    {(function() {
                                                                                                        var d = new Date(item.nf_solicitada_em);
                                                                                                        return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                                                                                                    })()}
                                                                                                </small>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <span className="fin-pp__pill is-warn">Sem NF</span>
                                                                                        )}
                                                                                        {/* D-0099: a NF de cada parcela (ou "NF pendente") */}
                                                                                        {nfParcelasDoItem(item).length > 1 && (
                                                                                            <div data-nf-por-parcela style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 3, marginTop: 6 }}>
                                                                                                {nfParcelasDoItem(item).map(function (p) {
                                                                                                    var s = situacaoNfParcela(p);
                                                                                                    return (
                                                                                                        <span key={p.id} className={'fin-pp__minitag ' + s.tom} style={{ whiteSpace: 'nowrap' }}
                                                                                                            title={'Parcela ' + p.numero + ' de ' + p.total + ' · R$ ' + moeda(p.valor)}>
                                                                                                            {p.numero}/{p.total} · {s.texto}
                                                                                                        </span>
                                                                                                    );
                                                                                                })}
                                                                                            </div>
                                                                                        )}
                                                                                        {/* Composição visível SEMPRE que o adiantamento foi marcado no
                                                                                            Efetivo — antes só aparecia depois da NF vinculada, e o
                                                                                            Financeiro aprovava sem saber do abatimento. */}
                                                                                        {(() => {
                                                                                            // Fonte do adiantamento = SEMPRE o OPF (valor por fornecedor,
                                                                                            // confiável). Não usar nf_valor_* aqui: eram preenchidos pelo
                                                                                            // mapa por ORÇAMENTO e traziam o líquido de outro fornecedor.
                                                                                            // E se o adiantamento já foi abatido numa parcela paga, ele não
                                                                                            // se aplica a este plano — é tranche nova do orçamento.
                                                                                            if (item.adiantamento_ja_abatido) return null;
                                                                                            const vlAdt = (item.usar_adiantamento === 'sim' && item.valor_adiantamento > 0)
                                                                                                ? item.valor_adiantamento : 0;
                                                                                            if (!vlAdt) return null;
                                                                                            const liquido = Math.max(0, (item.total || 0) - vlAdt);
                                                                                            return (
                                                                                                <div className="mt-1 px-1 py-1 rounded" style={{ background: '#f0f9ff', fontSize: '0.63rem', color: '#0369a1', lineHeight: 1.4 }}>
                                                                                                    <div>🟠 Adiantamento: <strong>− {moeda(vlAdt)}</strong></div>
                                                                                                    <div style={{ color: '#059669', fontWeight: 700 }}>A pagar: {moeda(liquido)}</div>
                                                                                                </div>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                    {/* Ações */}
                                                                                    <td>
                                                                                        <div className="d-flex align-items-center justify-content-end gap-2">
                                                                                            <button type="button" className="fin-pp__rowbtn" title="Mais ações"
                                                                                                onClick={() => {
                                                                                                    var acoes = [
                                                                                                        { type: 'action', icon: <FaFileInvoice size={16} />, label: item.nf_vinculada ? 'Solicitar Nova NF' : 'Solicitar ao fornecedor', description: 'Envia um link para o fornecedor anexar a nota fiscal', onClick: () => abrirSolicitarNFUnif(item) },
                                                                                                        { type: 'action', icon: <FaFileAlt size={16} />, label: 'Vincular NF', description: 'Registra o documento fiscal internamente', onClick: () => abrirVincularNFModal(item) },
                                                                                                    ];
                                                                                                    if (item._tipo === 'adiantamento') {
                                                                                                        acoes.unshift({ type: 'action', icon: <FaSearch size={16} />, label: 'Detalhes', description: 'Abre a tela do adiantamento com os itens solicitados', onClick: () => history.push(rotaDetalheAdiantamento(item._id)) });
                                                                                                    }
                                                                                                    if (item._tipo === 'previsao') {
                                                                                                        acoes.unshift({ type: 'action', icon: <FaSearch size={16} />, label: 'Detalhes', description: 'Abre a tela da previsão: parcelas, itens, NFs e histórico', onClick: () => history.push(rotaDetalhePrevisao(item._id)) });
                                                                                                        var naoVolta = motivoNaoVolta(item);
                                                                                                        acoes.push({ type: 'action', icon: <FaSync size={16} />, label: 'Voltar para Planos de Pagamento',
                                                                                                            description: naoVolta || 'Desfaz a aprovação e devolve ao operador do evento (ex.: NF errada). Motivo obrigatório.',
                                                                                                            disabled: !!naoVolta,
                                                                                                            onClick: () => setVoltaPlanosModal(item) });
                                                                                                    }
                                                                                                    setActionsModalData({ parcela: { descricao: item.fornecedor, valor: item.total }, actions: acoes });
                                                                                                    setShowActionsModal(true);
                                                                                                }}>
                                                                                                <FaEllipsisV size={14} />
                                                                                            </button>
                                                                                            {(function() {
                                                                                                var ehFinanceiro = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'].includes(perfil);
                                                                                                if (!ehFinanceiro) return null;
                                                                                                var acaoLib = acaoLiberacaoAprovado(item);
                                                                                                var carregando = !!salvandoLiberacao[item._key];
                                                                                                if (acaoLib === 'liberado') {
                                                                                                    return <span className="fin-pp__pill is-ok">Liberado para pgto</span>;
                                                                                                }
                                                                                                // D-0127: marcado "não vai para Contas a Pagar" — a API recusa a
                                                                                                // liberação (422); no lugar do botão, a pill com o motivo.
                                                                                                if (acaoLib === 'nao_vai') {
                                                                                                    return (
                                                                                                        <span className="fin-pp__pill is-muted" title={MSG_LIBERAR_NAO_VAI_CONTAS_PAGAR} style={{ cursor: 'help' }}
                                                                                                            data-nao-vai-contas-pagar>
                                                                                                            Não vai para Contas a Pagar
                                                                                                        </span>
                                                                                                    );
                                                                                                }
                                                                                                // D-0116: estimativa do cartão físico aprovada, operador ainda nas compras
                                                                                                // (fornecedor, cartão, valor real ou NF faltando). A API recusa (422).
                                                                                                if ((acaoLib === 'a_definir' || acaoLib === 'dados_pendentes') && aguardandoCompras(item.parcelas)) {
                                                                                                    var pendCf = Array.isArray(item.pendencias_pagamento) ? item.pendencias_pagamento : [];
                                                                                                    return (
                                                                                                        <button type="button" className="fin-pp__pill is-warn" data-cartao-fisico-aguardando
                                                                                                            style={{ border: 'none', cursor: 'pointer' }}
                                                                                                            title={MSG_AGUARDANDO_COMPRAS}
                                                                                                            onClick={function() { mostrarPendenciasPagamento(MSG_AGUARDANDO_COMPRAS, pendCf.length ? pendCf : [MSG_LIBERAR_SEM_FORNECEDOR]); }}>
                                                                                                            Aguardando compras (cartão físico)
                                                                                                        </button>
                                                                                                    );
                                                                                                }
                                                                                                // Sem fornecedor (Rafael, 30/09): o Financeiro aprova, mas não
                                                                                                // libera — a API recusa com 422 (camada 2). Quando o Eventos
                                                                                                // escolher o fornecedor no orçamento, o plano passa para ele.
                                                                                                if (acaoLib === 'a_definir') {
                                                                                                    return (
                                                                                                        <span className="fin-pp__pill is-warn" title={MSG_LIBERAR_SEM_FORNECEDOR} style={{ cursor: 'help' }}>
                                                                                                            Fornecedor a definir
                                                                                                        </span>
                                                                                                    );
                                                                                                }
                                                                                                // Sem parcela não há o que liberar: a API recusa (422) e o botão
                                                                                                // não pode nem aparecer — camada 1 da regra "sem parcela não vai
                                                                                                // a Contas Pendentes".
                                                                                                if (acaoLib === 'sem_parcelas') {
                                                                                                    var pendSemParcela = Array.isArray(item.pendencias_pagamento) ? item.pendencias_pagamento : [];
                                                                                                    return (
                                                                                                        <button type="button" className="fin-pp__pill is-warn"
                                                                                                            style={{ border: 'none', cursor: 'pointer' }}
                                                                                                            title="Plano aprovado sem parcelas — não pode ir a pagamento"
                                                                                                            onClick={function() { mostrarPendenciasPagamento(MSG_SEM_PARCELAS, pendSemParcela); }}>
                                                                                                            Sem parcelas — não vai a pgto
                                                                                                        </button>
                                                                                                    );
                                                                                                }
                                                                                                // D-0130/D-0131: aprovado sem conta viva que NÃO nasce sozinha (a API diz o porquê) — no
                                                                                                // lugar do botão, a pill com o motivo. Sem motivo, o "Aprovar para pgto" cria a conta e libera.
                                                                                                if (acaoLib === 'sem_titulo') {
                                                                                                    return (
                                                                                                        <span className="fin-pp__pill is-warn" title={item.conta_pendente_motivo || MSG_LIBERAR_SEM_TITULO} style={{ cursor: 'help' }}
                                                                                                            data-sem-conta-financeiro>
                                                                                                            Sem conta no Financeiro
                                                                                                        </span>
                                                                                                    );
                                                                                                }
                                                                                                // Sem dados de pagamento a liberação seria recusada (422). Em vez
                                                                                                // de oferecer um botão que erra, mostra a pendência — e clicar
                                                                                                // abre a lista do que o operador do evento precisa preencher.
                                                                                                if (acaoLib === 'dados_pendentes') {
                                                                                                    var pendItem = Array.isArray(item.pendencias_pagamento) ? item.pendencias_pagamento : [];
                                                                                                    return (
                                                                                                        <button type="button" className="fin-pp__pill is-warn"
                                                                                                            style={{ border: 'none', cursor: 'pointer' }}
                                                                                                            title="Ver o que falta preencher"
                                                                                                            onClick={function() { mostrarPendenciasPagamento(MSG_SEM_DADOS_PGTO, pendItem); }}>
                                                                                                            Dados de pgto pendentes
                                                                                                        </button>
                                                                                                    );
                                                                                                }
                                                                                                // Conferência da NF (item 21): aviso ACIMA do botão, sem desabilitar —
                                                                                                // há casos em que a NF não é necessária para pagar (Rafael, 09/10).
                                                                                                var valNF = piorValidacao(item.nfs);
                                                                                                // D-0128: só apólices (forma Apólice) — o aviso fala de apólice, não de NF.
                                                                                                var docNF = (item.nfs || []).length && (item.nfs || []).every(function (n) { return n.tipo === 'apolice'; }) ? 'Apólice' : 'NF';
                                                                                                // D-0116: valor real do cartão físico acima da estimativa — só aviso (Rafael 26/10).
                                                                                                var acimaCf = parcelasAcimaDaEstimativa(item.parcelas);
                                                                                                return (
                                                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                                                                                                        {acimaCf.length > 0 && (
                                                                                                            <span style={{ fontSize: 11.5, lineHeight: 1.25, maxWidth: 190, textAlign: 'right', color: 'var(--fin-wn)' }}
                                                                                                                data-cartao-fisico-acima>
                                                                                                                ⚠ Cartão físico acima da estimativa (+ R$ {moeda(acimaCf.reduce(function(t, p) { return t + valorReal(p.dados_pagamento) - (parseFloat(p.valor) || 0); }, 0))}) — confira antes de aprovar
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {valNF && (
                                                                                                            <span style={{ fontSize: 11.5, lineHeight: 1.25, maxWidth: 190, textAlign: 'right',
                                                                                                                color: valNF.status === 'divergente' ? 'var(--fin-wn)' : 'var(--fin-mt)' }}
                                                                                                                title={valNF.mensagem}>
                                                                                                                {valNF.status === 'divergente' ? '⚠ ' + docNF + ' divergente — revise antes de aprovar'
                                                                                                                    : valNF.status === 'nao_verificado' ? docNF + ' não analisada automaticamente — confira'
                                                                                                                    : docNF + ' conferida — revise antes de aprovar'}
                                                                                                            </span>
                                                                                                        )}
                                                                                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--ok" disabled={carregando}
                                                                                                            onClick={function() { liberarFinanceiro(item); }}>
                                                                                                            <FaCheck size={13} /> {carregando ? '...' : 'Aprovar para pgto'}
                                                                                                        </button>
                                                                                                    </div>
                                                                                                );
                                                                                            })()}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    );
                })()}

                {/* ── Adiantamentos: aba movida para Contas a Receber (PainelAdiantamentos) ── */}

                {/* Tabela principal */}
                {abaAtiva !== 'custoPrevisto' && abaAtiva !== 'adiantamentos' && abaAtiva !== 'cancelado' && (
                    <section className="section">
                        <div className="row mb-4">
                            <div className="col-sm-12">
                                <div className="fin-pp__region">
                                    <div className="fin-pp__region-head">
                                        {/* Sub-abas: Previsões / Adiantamentos */}
                                        {(() => {
                                            var qtPrevisoes = dadosPendentesParaExibir.length;
                                            var qtAdiantamentosAba = abaAtiva === 'pendentes'
                                                ? adiantamentos.filter(function(a) {
                                                    return !!a.dataAprovacaoDiretor
                                                        && (a.status_pagamento === 'creditado' || !!a.liberado_financeiro_at)
                                                        && a.situacao !== '2' && a.situacao !== 2;
                                                  }).length
                                                : adiantamentos.filter(function(a) {
                                                    return a.situacao === '2' || a.situacao === 2;
                                                  }).length;
                                            return (
                                                <div className="fin-pp__seg">
                                                    {[
                                                        { key: 'previsoes',     label: 'Previsões',     count: qtPrevisoes },
                                                        { key: 'adiantamentos', label: 'Adiantamentos', count: qtAdiantamentosAba },
                                                    ].map(function(tab) {
                                                        var ativa = abaContas === tab.key;
                                                        return (
                                                            <button key={tab.key} type="button"
                                                                onClick={() => setAbaContas(tab.key)}
                                                                className={'fin-pp__seg-btn' + (ativa ? ' is-active' : '')}>
                                                                {tab.label}
                                                                <span className="fin-pp__seg-count">{tab.count}</span>
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                    <div className="fin-pp__region-body">
                                        {eventoFiltroPendentes && (
                                            <div className="fin-pp__notice">
                                                <span className="fin-pp__notice-tag">
                                                    <FaFilter size={11} />
                                                    Mostrando apenas: {eventoFiltroNome || 'evento selecionado'}
                                                </span>
                                                <button type="button" className="fin-pp__btn" onClick={limparFiltroEvento}>
                                                    <FaTimes size={12} /> Limpar filtro
                                                </button>
                                            </div>
                                        )}
                                        {/* Mesma barra das demais abas — antes esta era uma cópia
                                            à parte, que filtrava cliente/busca a cada tecla enquanto
                                            a data esperava o botão. Agora tudo aplica no "Buscar". */}
                                        {(abaAtiva === 'pendentes' || abaAtiva === 'pagas') &&
                                            renderFiltroClienteEvento(clientesContasPendentes)}
                                        {abaAtiva === 'pendentes' && abaContas === 'previsoes' && (
                                            <div className="fin-pp__chips">
                                                <span className="fin-pp__chips-label"><FaFilter size={11} className="me-1" />Vencimento</span>
                                                {[
                                                    { key: 'tudo',     label: 'Tudo' },
                                                    { key: 'vencidas', label: 'Vencidas' },
                                                    { key: 'hoje',     label: 'Vence hoje' },
                                                    { key: 'semana',   label: 'Esta semana' },
                                                    { key: '7dias',    label: 'Próx. 7 dias' },
                                                    { key: '30dias',   label: 'Próx. 30 dias' },
                                                    { key: '60dias',   label: 'Próx. 60 dias' },
                                                    { key: 'mais60',   label: '+60 dias' },
                                                ].map(function (c) {
                                                    var ativo = filtroVencimento === c.key;
                                                    return (
                                                        <button key={c.key} type="button"
                                                            className={'fin-pp__chip' + (ativo ? ' is-active' : '')}
                                                            onClick={function () { setFiltroVencimento(c.key); }}>
                                                            {c.label}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                        {abaContas === 'previsoes' ? (
                                        <div className="fin-pp__groups">
                                            {gruposContasPendentesView.length === 0 ? (
                                                <div className="fin-pp__empty">{eventoFiltroPendentes ? 'Este evento não tem contas pendentes.' : (filtroVencimento !== 'tudo' ? 'Nenhuma conta vencendo nesse período.' : 'Nenhum registro')}</div>
                                            ) : gruposContasPendentesView.map(function (ev) {
                                              var aberto = cpAberto(ev.evento_id);
                                              return (
                                                <div key={'cpev_' + ev.evento_id} className="fin-pp__grp">
                                                    <div className="fin-pp__grp-head"
                                                        onClick={function () { toggleEventoAberto('cp_' + ev.evento_id, aberto); }}>
                                                        <span className={'fin-pp__grp-caret' + (aberto ? ' is-open' : '')}>▶</span>
                                                        <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>
                                                        <span className="fin-pp__grp-name">{ev.evento_nome}</span>
                                                        <span className="fin-pp__grp-badge">{ev.fornecedores.length} fornecedor{ev.fornecedores.length !== 1 ? 'es' : ''}</span>
                                                        <span className="fin-pp__grp-total">Total: <strong>R$ {moeda(ev.total)}</strong><OrigemMoeda origem={ev.origem} inline /></span>
                                                    </div>
                                                    {aberto && (
                                                        <div>
                                                            <table className="fin-pp__tbl">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '120px' }}>Status</th>
                                                                        <th>Descrição</th>
                                                                        <th style={{ width: '200px' }}>Plano de Contas</th>
                                                                        <th style={{ width: '120px' }}>Vencimento</th>
                                                                        <th style={{ width: '110px' }}>Arquivos</th>
                                                                        <th className="text-end" style={{ width: '165px' }}>Valor</th>
                                                                        <th style={{ width: '90px' }}>Ações</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ev.fornecedores.map(function (fn) {
                                                                        return (
                                                                            <React.Fragment key={'cpfn_' + fn.forn_id}>
                                                                                <tr className="fin-pp__tbl-sub">
                                                                                    <td colSpan={7}>
                                                                                        <span className="fin-pp__sub-name"><FaUniversity size={13} /> {fn.forn_nome}</span>
                                                                                        <TagNatureza natureza={fn.natureza} />
                                                                                        <span className="fin-pp__sub-badge">{fn.parcelas.length} parcela{fn.parcelas.length !== 1 ? 's' : ''}</span>
                                                                                        <span className="fin-pp__sub-total">R$ {moeda(fn.total)}</span>
                                                                                        <OrigemMoeda origem={fn.origem} inline />
                                                                                        {(function () {
                                                                                            // Rafael 07/10: trava todas as parcelas abertas do fornecedor de uma vez.
                                                                                            if (!PERFIS_TRAVAR_PAGAMENTO.includes(perfil)) return null;
                                                                                            var elegiveis = fn.parcelas.filter(parcelaPodeTravar);
                                                                                            if (elegiveis.length === 0) {
                                                                                                var travadas = fn.parcelas.filter(function (r) { return (r.situacao === '1' || r.situacao === 1) && r.travado_pagamento_em; }).length;
                                                                                                return travadas > 0 ? <span className="fin-pp__minitag is-info" style={{ marginLeft: 8 }}>🔒 Travado para pagamento</span> : null;
                                                                                            }
                                                                                            return (
                                                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ marginLeft: 8 }}
                                                                                                    data-travar-fornecedor
                                                                                                    title="Avisa os responsáveis do evento por e-mail; o Eventos não altera mais estas parcelas"
                                                                                                    onClick={function () { setTravarModal({ titulo: fn.forn_nome, parcelas: elegiveis }); }}>
                                                                                                    <FaLock size={11} /> Travar para pagamento{elegiveis.length > 1 ? ' (' + elegiveis.length + ')' : ''}
                                                                                                </button>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>
                                                                                {fn.parcelas.map(function (row) {
                                                                                    var isAberto = (row.situacao === '1' || row.situacao === 1);
                                                                                    var isUrgente = (row.pagamentourgente === true || row.pagamentourgente === 1 || row.pagamentourgente === '1');
                                                                                    var irParaDetalhe = function () { history.push('/financeiroParcelaDetalhe/' + row.id); };
                                                                                    var pararPropagacao = function (e) { e.stopPropagation(); };
                                                                                    return (
                                                                                        <tr key={row.id} style={{ cursor: 'pointer' }} onClick={irParaDetalhe} title="Ver detalhes">
                                                                                            <td>
                                                                                                {isAberto
                                                                                                    ? <span className="fin-pp__pill is-warn">Aberto</span>
                                                                                                    : <span className="fin-pp__pill is-ok">Pago</span>}
                                                                                                {isAberto && row.travado_pagamento_em && (
                                                                                                    <div className="mt-1">
                                                                                                        <span className="fin-pp__minitag is-info"
                                                                                                            title={'Travada para pagamento' + (row.travado_pagamento_por ? ' por ' + row.travado_pagamento_por : '') + ' em ' + moment(row.travado_pagamento_em).format('DD/MM/YYYY HH:mm') + ' — o Eventos não altera mais. Para destravar: Voltar para Custo Previsto.'}>
                                                                                                            🔒 Travada
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )}
                                                                                                {row.alerta_orcamento_em && (
                                                                                                    // 07/10: prova — orçamento reduziu/removeu o fornecedor depois da trava ou do pagamento
                                                                                                    <div className="mt-1">
                                                                                                        <span className="fin-pp__minitag" data-alerta-orcamento
                                                                                                            style={{ background: '#fdecec', color: 'var(--fin-dg)', border: '1px solid #f5c2c7', fontWeight: 600 }}
                                                                                                            title={(row.alerta_orcamento_texto || 'Orçamento alterado') + ' — por ' + (row.alerta_orcamento_por || '—') + ' em ' + moment(row.alerta_orcamento_em).format('DD/MM/YYYY HH:mm') + '. Clique para ver o histórico.'}>
                                                                                                            ⚠ {String(row.alerta_orcamento_texto || '').indexOf('REMOVIDO') >= 0 ? 'Removido do orçamento' : 'Valor reduzido no orçamento'}
                                                                                                        </span>
                                                                                                        <div style={{ fontSize: '0.66rem', color: 'var(--fin-dg)', marginTop: 2 }}>
                                                                                                            {moment(row.alerta_orcamento_em).format('DD/MM HH:mm')}{row.alerta_orcamento_por ? ' · ' + row.alerta_orcamento_por : ''}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                                {isUrgente && (
                                                                                                    <div className="fin-pp__urgente">⚠ Urgente</div>
                                                                                                )}
                                                                                                {tagCartaoEnviado(row)}
                                                                                                {ehCartaoFisico(row.efetivo_forma) && String(row.situacao) === '1' && (
                                                                                                    <div className="fin-pp__minitag is-info" title={MSG_SO_BAIXA} data-cartao-fisico-so-baixa>💳 Pago no cartão físico · só dar baixa</div>
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="fin-pp__cell-strong">
                                                                                                {row.descricao}
                                                                                                <PagamentoLegadoParcela info={row.pagamento_legado} onAtualizado={() => buscar()} />
                                                                                                <PagamentoLegadoContextual previsoes={row.pagamentos_legados_do_plano} />
                                                                                                {(function () {
                                                                                                    var dadosPg = row.efetivo_dados_pagamento;
                                                                                                    var dpg = resumoDadosPagamento(dadosPg);
                                                                                                    var fpg = row.efetivo_forma ? labelFormaPgto(row.efetivo_forma) : '';
                                                                                                    var urlPg = urlDePagamento(dadosPg);
                                                                                                    var linhaBoleto = (dadosPg && dadosPg.linha_digitavel) ? String(dadosPg.linha_digitavel) : '';
                                                                                                    if (!dpg && !fpg && !urlPg) return null;
                                                                                                    return (
                                                                                                        <div style={{ fontSize: '0.72rem', color: '#586478', fontWeight: 400, marginTop: 2 }} title="Como pagar (preenchido no Efetivo)">
                                                                                                            💳 {fpg}{fpg && dpg ? ' · ' : ''}{dpg}
                                                                                                            {linhaBoleto && (
                                                                                                                <button type="button" className="fin-pp__pill" title="Copiar a linha digitável"
                                                                                                                    style={{ border: 'none', cursor: 'pointer', marginLeft: 6, padding: '1px 7px', fontSize: '0.68rem' }}
                                                                                                                    onClick={function (e) { pararPropagacao(e); copiarParaAreaDeTransferencia(linhaBoleto, 'Linha digitável copiada.'); }}>
                                                                                                                    copiar linha
                                                                                                                </button>
                                                                                                            )}
                                                                                                            {urlPg && (
                                                                                                                <a href={urlPg} target="_blank" rel="noopener noreferrer"
                                                                                                                    onClick={pararPropagacao} style={{ marginLeft: 6, fontWeight: 600 }}>
                                                                                                                    abrir link de pagamento ↗
                                                                                                                </a>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    );
                                                                                                })()}
                                                                                            </td>
                                                                                            <td className="fin-pp__cell-muted">{row.conta ? (row.conta.caminho + ' - ' + row.conta.nome) : ''}</td>
                                                                                            <td>
                                                                                                {(function () {
                                                                                                    if (!row.vencimento) return <span className="fin-pp__venc is-empty">—</span>;
                                                                                                    var d = moment(row.vencimento);
                                                                                                    if (!d.isValid()) return <span className="fin-pp__venc-tag is-invalid">⚠ Data inválida</span>;
                                                                                                    var hoje = moment().startOf('day');
                                                                                                    if (isAberto && d.isBefore(hoje)) return <span className="fin-pp__venc-tag is-overdue">⚠ Vencida · {d.format('DD/MM/YYYY')}</span>;
                                                                                                    if (isAberto && d.isSame(hoje)) return <span className="fin-pp__venc-tag is-today">Vence hoje</span>;
                                                                                                    return <span className="fin-pp__venc">{d.format('DD/MM/YYYY')}</span>;
                                                                                                })()}
                                                                                            </td>
                                                                                            <td onClick={pararPropagacao}>{celulaArquivos(row)}</td>
                                                                                            <td className={'fin-pp__cell-num' + (parseFloat(row.valor) ? '' : ' is-zero')}>
                                                                                                <ValorComOrigem valor={row.valor} origem={origemDaParcela(row)} semPrefixo />
                                                                                                {/* Valor real pago quando difere da nota (Megui/Kátia, 04/09):
                                                                                                    é a diferença que a Kátia precisa justificar no fechamento. */}
                                                                                                {row.valor_pago !== null && row.valor_pago !== undefined
                                                                                                    && Math.round(parseFloat(row.valor_pago) * 100) !== Math.round(parseFloat(row.valor || 0) * 100) && (
                                                                                                    <div
                                                                                                        style={{ fontSize: '0.7rem', marginTop: 2, color: parseFloat(row.valor_pago) < parseFloat(row.valor || 0) ? 'var(--fin-ok)' : 'var(--fin-wn)' }}
                                                                                                        title="Valor que realmente saiu do caixa">
                                                                                                        pago R$ {moeda(row.valor_pago)}
                                                                                                    </div>
                                                                                                )}
                                                                                                {(row.deducoes || []).length > 0 && (
                                                                                                    <div style={{ fontSize: '0.68rem', color: '#6b7280' }}
                                                                                                        title={row.deducoes.map(function (d) { return rotuloDeducao(d.tipo) + (d.descricao ? ' (' + d.descricao + ')' : '') + (d.modo === 'percentual' && d.percentual ? ' ' + String(d.percentual).replace('.', ',') + '%' : '') + (d.natureza === 'acrescimo' ? ' +' : ' −') + moeda(d.valor); }).join('\n')}>
                                                                                                        {row.deducoes.length} {row.deducoes.length === 1 ? 'dedução/acréscimo' : 'deduções/acréscimos'}
                                                                                                    </div>
                                                                                                )}
                                                                                                {tagAdiantamentoParcela(row)}
                                                                                            </td>
                                                                                            <td onClick={pararPropagacao}>{renderActionDropdown(row)}</td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                              );
                                            })}
                                        </div>
                                    ) : (
                                        /* Sub-aba Adiantamentos */
                                        (() => {
                                            var adiantLista = abaAtiva === 'pendentes'
                                                ? adiantamentos.filter(function(a) {
                                                    return !!a.dataAprovacaoDiretor
                                                        && (a.status_pagamento === 'creditado' || !!a.liberado_financeiro_at)
                                                        && a.situacao !== '2' && a.situacao !== 2;
                                                  })
                                                : adiantamentos.filter(function(a) {
                                                    return a.situacao === '2' || a.situacao === 2;
                                                  });
                                            if (adiantLista.length === 0) {
                                                return <div className="text-center py-4 text-muted">Nenhum adiantamento nesta aba.</div>;
                                            }
                                            var gruposAdt = (function () {
                                                var g = {};
                                                adiantLista.forEach(function (a) {
                                                    var ev = (a.titulo && a.titulo.evento) ? a.titulo.evento : null;
                                                    var evId = (ev && ev.id) ? String(ev.id) : '__sem_evento__';
                                                    var evNome = (ev && ev.nome) ? ev.nome : '(sem evento)';
                                                    var fNome = '—';
                                                    var _itens = (a.titulo && (a.titulo.orcamento_item || a.titulo.orcamentoItem)) || [];
                                                    for (var _i = 0; _i < _itens.length; _i++) {
                                                        var _fp = _itens[_i].fornecedorpagamento;
                                                        if (_fp && typeof _fp === 'object' && (_fp.nomefantasia || _fp.nome)) { fNome = _fp.nomefantasia || _fp.nome; break; }
                                                        var _f = _itens[_i].fornecedor;
                                                        if (_f && typeof _f === 'object' && (_f.nomefantasia || _f.nome)) { fNome = _f.nomefantasia || _f.nome; break; }
                                                    }
                                                    if (!g[evId]) g[evId] = { evento_id: evId, evento_nome: evNome, total: 0, fornecedores: {} };
                                                    if (!g[evId].fornecedores[fNome]) g[evId].fornecedores[fNome] = { forn_nome: fNome, total: 0, itens: [] };
                                                    g[evId].fornecedores[fNome].itens.push(a);
                                                    g[evId].fornecedores[fNome].total += parseFloat(a.valor || 0);
                                                    g[evId].total += parseFloat(a.valor || 0);
                                                });
                                                return Object.values(g).map(function (ev) { return Object.assign({}, ev, { fornecedores: Object.values(ev.fornecedores).map(function (fn) { return Object.assign({}, fn, { natureza: naturezaDaLista(fn.itens) }); }) }); });
                                            })();
                                            var gruposAdtView = eventoFiltroPendentes
                                                ? gruposAdt.filter(function (ev) { return String(ev.evento_id) === String(eventoFiltroPendentes); })
                                                : gruposAdt;
                                            if (gruposAdtView.length === 0) {
                                                return <div className="text-center py-4 text-muted">Este evento não tem adiantamentos nesta aba.</div>;
                                            }
                                            return (
                                                <div className="fin-pp__groups">
                                                    {gruposAdtView.map(function (ev) {
                                                      var aberto = eventosAbertos['cpa_' + ev.evento_id] === true;
                                                      return (
                                                        <div key={'cpaev_' + ev.evento_id} className="fin-pp__grp">
                                                            <div className="fin-pp__grp-head"
                                                                onClick={function () { toggleEventoAberto('cpa_' + ev.evento_id, aberto); }}>
                                                                <span className={'fin-pp__grp-caret' + (aberto ? ' is-open' : '')}>▶</span>
                                                                <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>
                                                                <span className="fin-pp__grp-name">{ev.evento_nome}</span>
                                                                <span className="fin-pp__grp-badge">{ev.fornecedores.length} fornecedor{ev.fornecedores.length !== 1 ? 'es' : ''}</span>
                                                                <span className="fin-pp__grp-total">Total: <strong>R$ {moeda(ev.total)}</strong></span>
                                                            </div>
                                                            {aberto && (
                                                                <div>
                                                                    <table className="fin-pp__tbl">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{ width: '110px' }}>Ações</th>
                                                                                <th>Referência</th>
                                                                                {abaAtiva === 'pagas' && <th style={{ width: '130px' }}>Data Pgto</th>}
                                                                                <th className="text-end" style={{ width: '150px' }}>Valor</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {ev.fornecedores.map(function (fn) {
                                                                                return (
                                                                                    <React.Fragment key={'cpafn_' + ev.evento_id + '_' + fn.forn_nome}>
                                                                                        <tr className="fin-pp__tbl-sub">
                                                                                            <td colSpan={abaAtiva === 'pagas' ? 4 : 3}>
                                                                                                <span className="fin-pp__sub-name"><FaUniversity size={13} /> {fn.forn_nome}</span>
                                                                                                <TagNatureza natureza={fn.natureza} />
                                                                                                <span className="fin-pp__sub-badge">{fn.itens.length} adiantamento{fn.itens.length !== 1 ? 's' : ''}</span>
                                                                                                <span className="fin-pp__sub-total">R$ {moeda(fn.total)}</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        {fn.itens.map(function (a) {
                                                                                            var dataPgto = a.pagamento ? new Date(a.pagamento + 'T12:00:00').toLocaleDateString('pt-BR') : '—';
                                                                                            return (
                                                                                                <tr key={a.id} style={{ cursor: 'pointer' }} title="Ver detalhes" onClick={function (e) { abrirDetalheAdiantamento(e, a.id); }}>
                                                                                                    <td>
                                                                                                        <button type="button" className="fin-pp__rowbtn" title="Ações"
                                                                                                            onClick={function (e) {
                                                                                                                e.stopPropagation();
                                                                                                                var temComp = !!(a.arquivocomprovantepagamento && a.arquivocomprovantepagamento.id);
                                                                                                                var acoes = [];
                                                                                                                acoes.push({ type: 'action', icon: <FaSearch size={16} />, label: 'Detalhes', description: 'Abre a tela do adiantamento com os itens solicitados', onClick: function () { history.push(rotaDetalheAdiantamento(a.id)); } });
                                                                                                                if (abaAtiva === 'pendentes') {
                                                                                                                    acoes.push({ type: 'action', icon: <FaSync size={16} />, label: 'Dar baixa', description: 'Registra a baixa do adiantamento', onClick: function () { darBaixaAdiantamento(a); } });
                                                                                                                }
                                                                                                                acoes.push({
                                                                                                                    type: 'upload',
                                                                                                                    icon: <FaUpload size={16} />,
                                                                                                                    // Treinamento 07/10 item 10: o Financeiro não recebe "comprovante" de adiantamento
                                                                                                                    // (confere o crédito no extrato) — o nome confundia. Mesmo arquivo (comprovantepagamento).
                                                                                                                    label: temComp ? 'Substituir documento' : 'Anexar documento',
                                                                                                                    description: 'Extrato do banco ou outro arquivo de conferência',
                                                                                                                    acaoApi: 'financeiroParcelaArquivo/' + a.id,
                                                                                                                    dados: { tipoArquivo: 'comprovantepagamento', modulo: 'financeiro', pasta: 'comprovantepagamento' },
                                                                                                                    callBack: function () { buscarAdiantamentos(); }
                                                                                                                });
                                                                                                                if (temComp) {
                                                                                                                    acoes.push({ type: 'custom', element: (
                                                                                                                        <FormButton method="get" title="Ver documento" action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + a.id} icon={<FaFileInvoiceDollar size={16} />} color="light" data={{ token: localStorage.getItem('token'), tipoArquivo: 'comprovantepagamento' }} />
                                                                                                                    ) });
                                                                                                                }
                                                                                                                setActionsModalData({ parcela: a, actions: acoes });
                                                                                                                setShowActionsModal(true);
                                                                                                            }}>
                                                                                                            <FaEllipsisV size={14} />
                                                                                                        </button>
                                                                                                    </td>
                                                                                                    <td className="text-muted small">
                                                                                                        {a.descricao || '—'}
                                                                                                        <PagamentoLegadoParcela info={a.pagamento_legado} onAtualizado={() => buscarAdiantamentos()} />
                                                                                                        {/* A NF do adiantamento não aparecia aqui — só na tela de
                                                                                                            solicitação. Aceita objeto OU id solto: dependendo do
                                                                                                            eager load a API devolve arquivonotafiscal das duas formas. */}
                                                                                                        {(function () {
                                                                                                            var nfId = (a.arquivonotafiscal && typeof a.arquivonotafiscal === 'object')
                                                                                                                ? a.arquivonotafiscal.id
                                                                                                                : (a.arquivonotafiscal || null);
                                                                                                            if (!nfId && !a.nota_fiscal_id) return null;
                                                                                                            return (
                                                                                                                <div style={{ fontSize: '0.72rem', color: '#0f5132' }}>
                                                                                                                    {nfId ? (
                                                                                                                        <a href="#nf" title="Baixar a nota fiscal"
                                                                                                                            style={{ color: '#0f5132', textDecoration: 'underline' }}
                                                                                                                            onClick={function (e) { e.preventDefault(); window.open(process.env.REACT_APP_API_URL + '/arquivo/download/' + nfId, '_blank'); }}>
                                                                                                                            🧾 NF recebida — baixar
                                                                                                                        </a>
                                                                                                                    ) : (
                                                                                                                        <span title="Nota fiscal registrada.">🧾 NF recebida</span>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            );
                                                                                                        })()}
                                                                                                    </td>
                                                                                                    {abaAtiva === 'pagas' && <td className="text-muted small">{dataPgto}</td>}
                                                                                                    <td className="text-end" style={{ paddingRight: '1.5rem' }}><span className="fw-semibold">R$ {moeda(parseFloat(a.valor || 0))}</span></td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}
                                                                                    </React.Fragment>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}
                                                        </div>
                                                      );
                                                    })}
                                                </div>
                                            );
                                        })()
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {showModalExportarContasPagas && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }} onClick={fecharModalExportarContasPagas}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaFileAlt size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Exportar contas pagas</h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={fecharModalExportarContasPagas} disabled={exportandoContasPagas}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="mb-4">
                                            <label className="form-label fw-bold">Tipos de documento</label>
                                            <div className="d-flex flex-column gap-2">
                                                {[
                                                    { value: 'nd', label: 'ND' },
                                                    { value: 'nf', label: 'NF' },
                                                    { value: 'outros', label: 'Outros formatos' },
                                                    { value: 'todas', label: 'Todas' },
                                                ].map((opcao) => (
                                                    <div className="form-check" key={opcao.value}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`exportar-contas-${opcao.value}`}
                                                            checked={(filtroExportacaoContasPagas.tiposDocumento || []).includes(opcao.value)}
                                                            onChange={() => alternarTipoDocumentoExportacao(opcao.value)}
                                                            disabled={exportandoContasPagas}
                                                        />
                                                        <label className="form-check-label" htmlFor={`exportar-contas-${opcao.value}`}>
                                                            {opcao.label}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            <label className="form-label fw-bold">Período</label>
                                            <div className="d-flex flex-column gap-2">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="exportar-contas-periodo-mes"
                                                        checked={filtroExportacaoContasPagas.periodo === 'mes_atual'}
                                                        onChange={() => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, periodo: 'mes_atual' })}
                                                        disabled={exportandoContasPagas}
                                                    />
                                                    <label className="form-check-label" htmlFor="exportar-contas-periodo-mes">
                                                        Somente deste mês
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="exportar-contas-periodo-todo"
                                                        checked={filtroExportacaoContasPagas.periodo === 'todo_periodo'}
                                                        onChange={() => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, periodo: 'todo_periodo' })}
                                                        disabled={exportandoContasPagas}
                                                    />
                                                    <label className="form-check-label" htmlFor="exportar-contas-periodo-todo">
                                                        Todo o período
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="exportar-contas-periodo-selecionado"
                                                        checked={filtroExportacaoContasPagas.periodo === 'periodo_selecionado'}
                                                        onChange={() => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, periodo: 'periodo_selecionado' })}
                                                        disabled={exportandoContasPagas}
                                                    />
                                                    <label className="form-check-label" htmlFor="exportar-contas-periodo-selecionado">
                                                        Selecionar período
                                                    </label>
                                                </div>
                                                {filtroExportacaoContasPagas.periodo === 'periodo_selecionado' && (
                                                    <div className="row g-2 mt-1">
                                                        <div className="col-sm-6">
                                                            <label className="form-label">Data inicial</label>
                                                            <Data
                                                                value={filtroExportacaoContasPagas.dataInicial}
                                                                onChange={(date) => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, dataInicial: date })}
                                                                disabled={exportandoContasPagas}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <label className="form-label">Data final</label>
                                                            <Data
                                                                value={filtroExportacaoContasPagas.dataFinal}
                                                                onChange={(date) => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, dataFinal: date })}
                                                                disabled={exportandoContasPagas}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            <label className="form-label fw-bold">Origem</label>
                                            <div className="d-flex flex-column gap-2">
                                                {[
                                                    { value: 'eventos', label: 'Parcelas com Evento' },
                                                    { value: 'custosEmpresa', label: 'Custos Empresa' },
                                                ].map((opcao) => (
                                                    <div className="form-check" key={opcao.value}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`exportar-contas-vinculo-${opcao.value}`}
                                                            checked={(filtroExportacaoContasPagas.vinculos || []).includes(opcao.value)}
                                                            onChange={() => alternarVinculoExportacao(opcao.value)}
                                                            disabled={exportandoContasPagas}
                                                        />
                                                        <label className="form-check-label" htmlFor={`exportar-contas-vinculo-${opcao.value}`}>
                                                            {opcao.label}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div>
                                            <label className="form-label fw-bold">Formato de saída</label>
                                            <div className="d-flex flex-column gap-2">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="exportar-contas-formato-pdf"
                                                        checked={filtroExportacaoContasPagas.formato === 'pdf'}
                                                        onChange={() => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, formato: 'pdf' })}
                                                        disabled={exportandoContasPagas}
                                                    />
                                                    <label className="form-check-label" htmlFor="exportar-contas-formato-pdf">
                                                        PDF consolidado
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="exportar-contas-formato-zip"
                                                        checked={filtroExportacaoContasPagas.formato === 'zip'}
                                                        onChange={() => setFiltroExportacaoContasPagas({ ...filtroExportacaoContasPagas, formato: 'zip' })}
                                                        disabled={exportandoContasPagas}
                                                    />
                                                    <label className="form-check-label" htmlFor="exportar-contas-formato-zip">
                                                        ZIP com os arquivos
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fin-pp__modal-foot">
                                        <button type="button" className="fin-pp__btn" onClick={fecharModalExportarContasPagas} disabled={exportandoContasPagas}>
                                            Cancelar
                                        </button>
                                        <button
                                            type="button"
                                            className="fin-pp__btn fin-pp__btn--primary"
                                            onClick={exportarArquivosContasPagas}
                                            disabled={
                                                exportandoContasPagas ||
                                                (filtroExportacaoContasPagas.tiposDocumento || []).length === 0 ||
                                                (filtroExportacaoContasPagas.vinculos || []).length === 0
                                            }
                                        >
                                            {exportandoContasPagas ? 'Gerando arquivo...' : 'Baixar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Modal de Ações */}
                {showActionsModal && (
                    <div className="fin-pp fin-pp__sheet-backdrop" onClick={() => setShowActionsModal(false)}>
                        <div className="fin-pp__sheet" onClick={(e) => e.stopPropagation()}>
                            <div className="fin-pp__sheet-head">
                                <span className="fin-pp__sheet-head-ic"><FaEllipsisV size={17} /></span>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <h3 className="fin-pp__sheet-title">Ações</h3>
                                    {actionsModalData.parcela && (
                                        <p className="fin-pp__sheet-sub">
                                            {actionsModalData.parcela.descricao || 'Lançamento'}
                                            {actionsModalData.parcela.valor != null ? ' · R$ ' + moeda(actionsModalData.parcela.valor) : ''}
                                        </p>
                                    )}
                                </div>
                                <button type="button" className="fin-pp__sheet-close" title="Fechar" onClick={() => setShowActionsModal(false)}>
                                    <FaTimes size={16} />
                                </button>
                            </div>
                            <div className="fin-pp__sheet-body">
                                {actionsModalData.actions.map((action, index) => {
                                    if (action.type === 'custom') {
                                        return <div key={index} className="fin-pp__sheet-item" style={{ cursor: 'default' }}>{action.element}</div>;
                                    }
                                    const icCls = action.disabled ? ' is-muted' : (action.type === 'upload' ? ' is-ok' : '');
                                    const inner = (
                                        <>
                                            <span className={'fin-pp__sheet-item-ic' + icCls}>{action.icon}</span>
                                            <span className="fin-pp__sheet-item-txt">
                                                <span className="fin-pp__sheet-item-label">{action.label}</span>
                                                {action.description && <span className="fin-pp__sheet-item-desc">{action.description}</span>}
                                            </span>
                                            {action.disabled && <span className="fin-pp__sheet-badge">Indisponível</span>}
                                        </>
                                    );
                                    if (action.type === 'link') {
                                        return (
                                            <Link key={index} className="fin-pp__sheet-item" to={action.to} onClick={() => setShowActionsModal(false)}>
                                                {inner}
                                            </Link>
                                        );
                                    }
                                    return (
                                        <button
                                            key={index}
                                            type="button"
                                            className={'fin-pp__sheet-item' + (action.disabled ? ' is-disabled' : '')}
                                            disabled={!!action.disabled}
                                            onClick={(e) => {
                                                if (action.disabled) return;
                                                e.stopPropagation();
                                                if (action.type === 'upload') {
                                                    handleFileUpload(action.acaoApi, action.dados, action.callBack);
                                                } else if (action.onClick) {
                                                    action.onClick();
                                                }
                                                setShowActionsModal(false);
                                            }}
                                        >
                                            {inner}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal +NF Retroativa */}
                {showModalNFRetroativa && (
                    <>
                        <div className="modal-backdrop fade show fin-pp__modalbg" style={{ zIndex: 1040 }} onClick={fecharModalNFRetroativa}></div>
                        <div className="modal fade show d-block fin-pp" style={{ zIndex: 1050 }} tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content fin-pp__modal">
                                    <div className="fin-pp__modal-head">
                                        <span className="fin-pp__modal-head-ic"><FaFileInvoice size={17} /></span>
                                        <h3 className="fin-pp__modal-title">Upload de NF Retroativa</h3>
                                        <button type="button" className="fin-pp__modal-close" onClick={fecharModalNFRetroativa}><FaTimes size={16} /></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="mb-3">
                                            <small className="text-muted d-block">Evento</small>
                                            <strong>
                                                {itemNFRetroativa?.orcamento?.evento?.codigo ? `${itemNFRetroativa.orcamento.evento.codigo} - ` : ''}
                                                {itemNFRetroativa?.orcamento?.evento?.nome || 'N/A'}
                                            </strong>
                                        </div>
                                        <div className="mb-3">
                                            <small className="text-muted d-block">Orçamento</small>
                                            <strong>{itemNFRetroativa?.orcamento?.codigo || 'N/A'}</strong>
                                        </div>
                                        <div className="mb-3">
                                            <small className="text-muted d-block">Fornecedor</small>
                                            <strong>
                                                {itemNFRetroativa?.fornecedorpagamento?.nomefantasia ||
                                                    itemNFRetroativa?.fornecedorpagamento?.nome ||
                                                    itemNFRetroativa?.fornecedor?.nomefantasia ||
                                                    itemNFRetroativa?.fornecedor?.nome ||
                                                    'N/A'}
                                            </strong>
                                        </div>
                                        <div className="fin-pp__field">
                                            <label className="fin-pp__label">Arquivos da NF (PDF/JPG/PNG)</label>
                                            <input
                                                type="file"
                                                className="fin-pp__input"
                                                style={{ height: 'auto', padding: '8px 12px' }}
                                                multiple
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={(e) => setArquivosNFRetroativa(Array.from(e.target.files || []))}
                                            />
                                            {arquivosNFRetroativa.length > 0 && (
                                                <small className="text-muted d-block mt-2">
                                                    {arquivosNFRetroativa.length} arquivo(s) selecionado(s)
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="fin-pp__modal-foot">
                                        <button type="button" className="fin-pp__btn" onClick={fecharModalNFRetroativa} disabled={enviandoNFRetroativa}>
                                            Cancelar
                                        </button>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={enviarNFRetroativa} disabled={enviandoNFRetroativa}>
                                            {enviandoNFRetroativa ? 'Enviando...' : 'Enviar NF'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Modal de Aprovação */}
                {showModalAprovar && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalAprovar(false); setComentarios(''); } }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic is-ok"><FaCheck size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Aprovar Parcela(s)
                                        <span className="fin-pp__modal-sub">{tableSelect.selectedRows.length} parcela(s) selecionada(s)</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalAprovar(false); setComentarios(''); }}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <p>Você está prestes a aprovar <strong>{tableSelect.selectedRows.length}</strong> parcela(s).</p>
                                    <div className="fin-pp__field">
                                        <label htmlFor="comentarios" className="fin-pp__label">Comentários (opcional)</label>
                                        <textarea
                                            id="comentarios"
                                            className="fin-pp__input"
                                            style={{ height: 'auto', padding: '10px 14px' }}
                                            rows="4"
                                            value={comentarios}
                                            onChange={(e) => setComentarios(e.target.value)}
                                            placeholder="Descreva os comentários sobre a aprovação..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={() => { setShowModalAprovar(false); setComentarios(''); }}>Cancelar</button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={aprovarParcelas}><FaCheck size={16} /> Aprovar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de Reprovação */}
                {showModalReprovar && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalReprovar(false); setComentarios(''); } }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic is-danger"><FaTimes size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Reprovar Parcela(s)
                                        <span className="fin-pp__modal-sub">{tableSelect.selectedRows.length} parcela(s) selecionada(s)</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalReprovar(false); setComentarios(''); }}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <p>Você está prestes a reprovar <strong>{tableSelect.selectedRows.length}</strong> parcela(s).</p>
                                    <div className="fin-pp__field">
                                        <label htmlFor="comentarios" className="fin-pp__label">Comentários *</label>
                                        <textarea
                                            id="comentarios"
                                            className="fin-pp__input"
                                            style={{ height: 'auto', padding: '10px 14px' }}
                                            rows="4"
                                            value={comentarios}
                                            onChange={(e) => setComentarios(e.target.value)}
                                            placeholder="Descreva os comentários sobre a reprovação..."
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={() => { setShowModalReprovar(false); setComentarios(''); }}>Cancelar</button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--danger" onClick={reprovarParcelas} disabled={!comentarios.trim()}><FaTimes size={16} /> Reprovar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* ── Modal: Pagar Parcela ── */}
            {pagarModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) setPagarModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-ok"><FaThumbsUp size={17} /></span>
                                <h3 className="fin-pp__modal-title">Pagar Parcela
                                    {pagarModal.parcela?.descricao && <span className="fin-pp__modal-sub">{pagarModal.parcela.descricao}</span>}
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setPagarModal(null)}><FaTimes size={16} /></button>
                            </div>
                            {/* Corpo rola: com várias linhas de dedução o modal passava da tela e o
                                botão Pagar sumia (Rafael, 13/09). Cabeçalho e rodapé ficam fixos. */}
                            <div className="modal-body" style={{ maxHeight: 'calc(100vh - 230px)', overflowY: 'auto' }}>
                                <PagamentoLegadoParcela info={pagarModal.parcela?.pagamento_legado} editavel={false} />
                                <PagamentoLegadoContextual previsoes={pagarModal.parcela?.pagamentos_legados_do_plano} />
                                <div className="fin-pp__filters" style={{ alignItems: 'stretch' }}>
                                    <FinField label="Pagar com" full>
                                        <ReactSelect
                                            placeholder="-- Selecione --"
                                            options={caixas.map(function (c) {
                                                var isCartao = parseFloat(c.cartaolimite || 0) > 0;
                                                var saldo = isCartao ? ' · Saldo: R$ ' + moeda(parseFloat(c.cartaosaldo || 0)) : '';
                                                return { value: String(c.id), label: (isCartao ? '💳 ' : '🏦 ') + c.nome + saldo };
                                            })}
                                            value={pagarModal.caixa ? { value: String(pagarModal.caixa) } : null}
                                            onChange={(e) => setPagarModal({ ...pagarModal, caixa: e ? String(e.value) : '' })}
                                        />
                                    </FinField>
                                    <FinField label="Data Pagamento" full>
                                        <FinInput type="date" value={pagarModal.dataPagamento} onChange={(e) => setPagarModal({ ...pagarModal, dataPagamento: e.target.value })} />
                                    </FinField>
                                    <FinField label={'Novo Valor (opcional) — atual R$ ' + moeda(pagarModal.parcela?.valor)} full
                                        ajuda="Corrige quanto se DEVE nesta parcela (recalcula o total do título). Use quando o valor da conta estava errado.">
                                        <FinInput type="text" placeholder={'R$ ' + moeda(pagarModal.parcela?.valor)} value={pagarModal.novoValor} onChange={(e) => setPagarModal({ ...pagarModal, novoValor: e.target.value })} />
                                    </FinField>
                                    {/* Valor REAL pago (Megui/Kátia, 04/09): imposto retido, juros de
                                        atraso ou desconto fazem o desembolso diferir da nota. Não altera
                                        o valor da parcela — é o que permite apurar lucro e prejuízo. */}
                                    <FinField label="Valor real pago (opcional)" full
                                        ajuda="Quanto SAIU do caixa, se for diferente da nota (imposto retido, juros, desconto). Não altera o valor da parcela.">
                                        <FinInput type="text" placeholder="deixe em branco se pagou o valor cheio"
                                            value={pagarModal.valorPago || ''}
                                            onChange={(e) => setPagarModal({ ...pagarModal, valorPago: e.target.value, valorPagoEditado: true })} />
                                    </FinField>
                                </div>
                                {/* Deduções/acréscimos (Roteiro T6): o porquê de o pago diferir da nota.
                                    Só Financeiro/admin/diretor (pode_deduzir vem da API). As linhas
                                    calculam o "Valor real pago"; digitar diferente AVISA, não trava
                                    (decisão Rafael 13/09). */}
                                {pagarModal.parcela?.pode_deduzir && (function () {
                                    var linhas = pagarModal.deducoes || [];
                                    var base = (pagarModal.novoValor && pagarModal.novoValor.trim() !== '') ? numBr(pagarModal.novoValor) : numBr(pagarModal.parcela?.valor);
                                    var calculado = calcularPagoDeducoes(base, linhas);
                                    var digitado = (pagarModal.valorPago && pagarModal.valorPago.trim() !== '') ? numBr(pagarModal.valorPago) : null;
                                    var diverge = linhas.length > 0 && digitado !== null && Math.round(digitado * 100) !== Math.round(calculado * 100);
                                    var atualizar = function (novas) {
                                        var calc = calcularPagoDeducoes(base, novas);
                                        setPagarModal({
                                            ...pagarModal,
                                            deducoes: novas,
                                            valorPago: (!pagarModal.valorPagoEditado && novas.length > 0) ? fmtBr(calc) : pagarModal.valorPago,
                                        });
                                    };
                                    var setLinha = function (i, campos) { var novas = linhas.slice(); novas[i] = { ...linhas[i], ...campos }; atualizar(novas); };
                                    return (
                                        <div className="mt-2 p-2 rounded" style={{ background: '#f6f8fb', border: '1px solid #dfe5ee', fontSize: 12 }}>
                                            <div style={{ fontWeight: 600, marginBottom: 6 }}>
                                                Deduções e acréscimos <span style={{ fontWeight: 400, color: '#6b7280' }}>— por que o pago difere da nota (interno, só o Financeiro vê)</span>
                                            </div>
                                            {linhas.map(function (l, i) {
                                                return (
                                                    <div key={i} className="d-flex align-items-center gap-2 mb-1">
                                                        <select className="form-control form-control-sm" style={{ maxWidth: 130 }} value={l.tipo}
                                                            onChange={function (e) {
                                                                var t = TIPOS_DEDUCAO.find(function (x) { return x.value === e.target.value; });
                                                                setLinha(i, { tipo: e.target.value, natureza: (t && t.natureza) ? t.natureza : (l.natureza || 'deducao') });
                                                            }}>
                                                            {TIPOS_DEDUCAO.map(function (t) { return <option key={t.value} value={t.value}>{t.label}</option>; })}
                                                        </select>
                                                        {l.tipo === 'outros' && (
                                                            <select className="form-control form-control-sm" style={{ maxWidth: 100 }} value={l.natureza || 'deducao'}
                                                                onChange={function (e) { setLinha(i, { natureza: e.target.value }); }}>
                                                                <option value="deducao">Deduz</option>
                                                                <option value="acrescimo">Acresce</option>
                                                            </select>
                                                        )}
                                                        {l.tipo === 'outros' && (
                                                            <input className="form-control form-control-sm" placeholder="descrição" value={l.descricao || ''}
                                                                onChange={function (e) { setLinha(i, { descricao: e.target.value }); }} />
                                                        )}
                                                        <select className="form-control form-control-sm" style={{ maxWidth: 62 }} value={l.modo || 'valor'} title="Lançar em reais ou em % sobre a nota"
                                                            onChange={function (e) { setLinha(i, { modo: e.target.value }); }}>
                                                            <option value="valor">R$</option>
                                                            <option value="percentual">%</option>
                                                        </select>
                                                        {l.modo === 'percentual' ? (
                                                            <input className="form-control form-control-sm" style={{ maxWidth: 80, textAlign: 'right' }} placeholder="0,00" value={l.percentual || ''}
                                                                onChange={function (e) { setLinha(i, { percentual: e.target.value }); }} />
                                                        ) : (
                                                            <input className="form-control form-control-sm" style={{ maxWidth: 120, textAlign: 'right' }} placeholder="0,00" value={l.valor || ''}
                                                                onChange={function (e) { setLinha(i, { valor: e.target.value }); }} />
                                                        )}
                                                        <span style={{ minWidth: 12, fontWeight: 600, color: l.natureza === 'acrescimo' ? 'var(--fin-wn)' : 'var(--fin-ok)' }}>{l.natureza === 'acrescimo' ? '+' : '−'}</span>
                                                        {l.modo === 'percentual' && (
                                                            <span style={{ color: '#6b7280', whiteSpace: 'nowrap' }}>= R$ {moeda(valorLinhaDeducao(l, base))}</span>
                                                        )}
                                                        <button type="button" className="fin-pp__rowbtn" title="Remover linha"
                                                            onClick={function () { var novas = linhas.slice(); novas.splice(i, 1); atualizar(novas); }}>×</button>
                                                    </div>
                                                );
                                            })}
                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                onClick={function () { atualizar(linhas.concat([{ tipo: 'desconto', natureza: 'deducao', modo: 'valor', percentual: '', descricao: '', valor: '' }])); }}>
                                                + Adicionar linha
                                            </button>
                                            {linhas.length > 0 && (
                                                <div style={{ marginTop: 6 }}>
                                                    Nota R$ {moeda(base)} → <strong>calculado R$ {moeda(calculado)}</strong>
                                                    {diverge && (
                                                        <div style={{ marginTop: 4, color: '#8a5206' }}>
                                                            ⚠️ O valor real pago digitado (R$ {moeda(digitado)}) difere do calculado (R$ {moeda(calculado)}). Pode prosseguir, mas confira as linhas.
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                                {/* Aviso, não trava. Dava para dar baixa numa conta sem dado nenhum
                                    e depois não saber para onde o dinheiro foi ("cliquei em pagar e
                                    ele foi, só que aí eu não sei para onde" — Tatianne, 19/08).
                                    Bloquear aqui prenderia conta antiga que precisa ser paga mesmo
                                    incompleta; o gate duro fica na liberação, antes de virar conta. */}
                                {pagarModal.parcela?.cambio_banco?.aprovado_em && (
                                    <div className="fin-pp__banner is-info mt-2">
                                        <span>Pagamento no exterior pela <strong>invoice</strong> (câmbio aprovado pelo Eventos): os dados de pagamento estão nela.</span>
                                    </div>
                                )}
                                {!pagarModal.parcela?.cambio_banco?.aprovado_em && (pagarModal.parcela?.efetivo_pendencias || []).length > 0 && (
                                    <div className="mt-2 p-2 rounded" style={{ background: '#fdf3e2', border: '1px solid #e8c88a', fontSize: 12, color: '#8a5206' }}>
                                        ⚠️ <strong>Esta conta não tem os dados de pagamento completos.</strong>
                                        <div style={{ marginTop: 4 }}>Falta: {pagarModal.parcela.efetivo_pendencias.join(', ')}.</div>
                                        <div style={{ marginTop: 4 }}>
                                            Dá para pagar assim mesmo, mas o sistema fica <strong>sem registro de para onde o dinheiro foi</strong>.
                                            Se puder, peça ao operador do evento para completar na aba Efetivo.
                                        </div>
                                    </div>
                                )}
                                {/* Sem plano de contas: aviso leve, não trava (mesma postura dos dados de
                                    pagamento). A conta continua editável na listagem; classificada uma vez,
                                    as próximas do fornecedor já nascem com o mesmo plano (herança na API). */}
                                {!pagarModal.parcela?.conta && (
                                    <div className="mt-2 p-2 rounded" style={{ background: '#fdf3e2', border: '1px solid #e8c88a', fontSize: 12, color: '#8a5206' }}>
                                        ⚠️ <strong>Sem plano de contas.</strong> Dá para pagar, mas classifique
                                        (coluna Plano de Contas da listagem) para o DRE não ficar furado — a
                                        próxima conta deste fornecedor já nasce classificada igual.
                                    </div>
                                )}
                                {pagarModal.parcela?.adiantamento_fornecedor?.valor > 0 && (
                                    <div className="mt-2 p-2 rounded" style={{ background: '#f0f9ff', border: '1px solid #bae6fd', fontSize: 12, color: '#0369a1' }}>
                                        {parteAdiantamentoDaConta(pagarModal.parcela.adiantamento_fornecedor) !== null ? (<>
                                            🟠 Esta parcela usa <strong>R$ {moeda(parteAdiantamentoDaConta(pagarModal.parcela.adiantamento_fornecedor))}</strong> do
                                            adiantamento do cliente (já debitado da conta do evento). O valor líquido já veio preenchido acima.
                                            {Math.max(0, (parseFloat(pagarModal.parcela.valor) || 0) - parteAdiantamentoDaConta(pagarModal.parcela.adiantamento_fornecedor)) <= 0
                                                && ' Coberta pelo adiantamento: confirmar o pagamento é o que dá a baixa.'}
                                        </>) : pagarModal.parcela.adiantamento_fornecedor.sem_parcela ? (<>
                                            🟠 Este fornecedor tem <strong>R$ {moeda(pagarModal.parcela.adiantamento_fornecedor.valor)}</strong> de
                                            adiantamento ainda sem parcela: o Eventos não escolheu em qual descontar. Confira antes de pagar.
                                        </>) : pagarModal.parcela.adiantamento_fornecedor.valor_parcela === undefined ? (<>
                                            🟠 Este fornecedor tem <strong>R$ {moeda(pagarModal.parcela.adiantamento_fornecedor.valor)}</strong> abatidos
                                            do adiantamento do cliente. Valor por fornecedor — confira quanto abater nesta parcela.
                                        </>) : (<>
                                            🟠 O adiantamento deste fornecedor (R$ {moeda(pagarModal.parcela.adiantamento_fornecedor.valor)}) foi
                                            atribuído a outra parcela — nada a descontar nesta.
                                        </>)}
                                    </div>
                                )}
                                {motivoBloqueioPagar(pagarModal) && (
                                    <div className="mt-2 p-2 rounded" style={{ background: '#fdecec', border: '1px solid #f0a5a5', fontSize: 12, color: '#9b1c1c' }}>
                                        ⛔ <strong>Não dá para pagar assim.</strong> {motivoBloqueioPagar(pagarModal)}
                                    </div>
                                )}
                                <div style={{ fontSize: 11.5, color: 'var(--fin-ft)', marginTop: 6 }}>Deixe o Novo Valor em branco para manter o valor original.</div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setPagarModal(null)}>Sair</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={confirmarPagamento}
                                    disabled={salvandoPagamento || !!motivoBloqueioPagar(pagarModal)}
                                    title={motivoBloqueioPagar(pagarModal) || ''}>
                                    <FaThumbsUp size={16} /> {salvandoPagamento ? 'Pagando…' : 'Pagar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Aprovar Plano de Pagamento ── */}
            {planoAprovarModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                    {/* Plano Inter (cotação do banco) é alto: modal mais largo + corpo com rolagem própria (01/10). */}
                    <div className={'modal-dialog modal-dialog-centered' + (planoAprovarModal.cotacao_base && planoAprovarModal.cotacao_base.pode_cotar ? ' modal-lg' : '')}>
                        <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-ok"><FaCheck size={17} /></span>
                                <h3 className="fin-pp__modal-title">Aprovar Plano de Pagamento</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setPlanoAprovarModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="fin-pp__sumcard">
                                    <div className="fin-pp__sumrow">
                                        <span className="fin-pp__sumlabel">Fornecedor</span>
                                        <span className="fin-pp__sumval" title={nomeFornecedorPlano(planoAprovarModal)}>{nomeFornecedorPlano(planoAprovarModal)}</span>
                                    </div>
                                    {planoAprovarModal.evento_nome && (
                                        <div className="fin-pp__sumrow">
                                            <span className="fin-pp__sumlabel">Evento</span>
                                            <span className="fin-pp__sumval" title={planoAprovarModal.evento_nome}>{planoAprovarModal.evento_nome}</span>
                                        </div>
                                    )}
                                    <div className="fin-pp__sumrow fin-pp__sumrow--total">
                                        <span className="fin-pp__sumlabel">Valor total</span>
                                        <span className="fin-pp__sumval--money">R$ {moeda(planoAprovarModal.total)} <small>· {planoAprovarModal.parcelas?.length || 1} parcela(s)</small></span>
                                    </div>
                                    {/* Item 15: câmbio que a aprovação congela nas parcelas a pagar. */}
                                    {origemOpf[planoAprovarModal.id] && (
                                        <div className="fin-pp__sumrow">
                                            <span className="fin-pp__sumlabel">Moeda de origem</span>
                                            <span className="fin-pp__sumval"><OrigemMoeda origem={origemDoPlano(origemOpf[planoAprovarModal.id], planoAprovarModal.total)} comBrl inline /></span>
                                        </div>
                                    )}
                                </div>
                                {/* Previsão Inter (28/09): cotação do banco → valor a pagar (numa conta só). */}
                                {planoAprovarModal.cotacao_base && planoAprovarModal.cotacao_base.pode_cotar && (() => {
                                    const b = planoAprovarModal.cotacao_base;
                                    const c = calcularCotacao(b, cotacaoForm);
                                    const sim = b.simbolo || b.codigo || '';
                                    const tipoBtn = (campo, tipo, rotulo) => (
                                        <button type="button" className={'fin-pp__btn fin-pp__btn--sm' + (cotacaoForm[campo] === tipo ? ' fin-pp__btn--primary' : '')}
                                            style={{ minWidth: 40 }} onClick={() => campoCotacao(campo, tipo)}>{rotulo}</button>
                                    );
                                    return (
                                        <div style={{ background: 'var(--fin-sf2)', border: '1px solid var(--fin-bd)', borderRadius: 'var(--fin-rds)', padding: 14, marginBottom: 12 }}>
                                            <div className="fw-semibold" style={{ fontSize: '0.88rem' }}>Câmbio do banco — fornecedor pago no exterior</div>
                                            <div className="text-muted mb-2" style={{ fontSize: '0.78rem' }}>
                                                Plano: {sim} {moeda(b.valor_moeda)} (câmbio do orçamento {formatarCambio(b.cambio_base)})
                                                {b.brl_nacional > 0 ? ' + R$ ' + moeda(b.brl_nacional) + ' pagos no Brasil' : ''}
                                            </div>
                                            <div className="fin-pp__cotacao-grid">
                                            <div className="fin-pp__cotacao-campos">
                                                <FinField label={'Cotação (R$/' + (b.codigo || sim) + ')'} required>
                                                    <FinInput inputMode="decimal" style={{ paddingLeft: 14 }} value={cotacaoForm.cotacao} placeholder="ex.: 5,40"
                                                        onChange={(e) => campoCotacao('cotacao', e.target.value)} />
                                                </FinField>
                                                <FinField label="Taxa operacional (R$)">
                                                    <FinInput inputMode="decimal" style={{ paddingLeft: 14 }} value={cotacaoForm.taxa} placeholder="0"
                                                        onChange={(e) => campoCotacao('taxa', e.target.value)} />
                                                </FinField>
                                                <FinField label="IOF">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        {tipoBtn('iofTipo', 'percentual', '%')}{tipoBtn('iofTipo', 'valor', 'R$')}
                                                        <FinInput inputMode="decimal" style={{ paddingLeft: 14 }} value={cotacaoForm.iof} placeholder="0"
                                                            onChange={(e) => campoCotacao('iof', e.target.value)} />
                                                    </div>
                                                </FinField>
                                                <FinField label="IR">
                                                    <div className="d-flex gap-1 align-items-center">
                                                        {tipoBtn('irTipo', 'percentual', '%')}{tipoBtn('irTipo', 'valor', 'R$')}
                                                        <FinInput inputMode="decimal" style={{ paddingLeft: 14 }} value={cotacaoForm.ir} placeholder="0"
                                                            onChange={(e) => campoCotacao('ir', e.target.value)} />
                                                    </div>
                                                </FinField>
                                            </div>
                                            <table className="fin-pp__tbl" style={{ fontSize: '0.82rem', background: 'var(--fin-sf)', borderRadius: 'var(--fin-rds)' }}>
                                                <tbody>
                                                    <tr><td>{sim} {moeda(b.valor_moeda)} × cotação</td><td className="fin-pp__cell-num">R$ {moeda(c.principal)}</td></tr>
                                                    {c.brlNacional > 0 && <tr><td>Parte paga no Brasil</td><td className="fin-pp__cell-num">R$ {moeda(c.brlNacional)}</td></tr>}
                                                    <tr><td>IOF</td><td className="fin-pp__cell-num">R$ {moeda(c.iofBrl)}</td></tr>
                                                    <tr><td>IR</td><td className="fin-pp__cell-num">R$ {moeda(c.irBrl)}</td></tr>
                                                    <tr><td>Taxa operacional</td><td className="fin-pp__cell-num">R$ {moeda(c.taxaBrl)}</td></tr>
                                                    <tr><td className="fin-pp__cell-strong">Total a pagar (uma conta)</td><td className="fin-pp__cell-num fin-pp__cell-strong">R$ {moeda(c.total)}</td></tr>
                                                </tbody>
                                            </table>
                                            </div>
                                            <div className="text-muted mt-1" style={{ fontSize: '0.75rem' }}>
                                                As parcelas do plano são corrigidas na mesma proporção, nas mesmas datas. A cotação vai para o "Câmbio negociado" do orçamento, sem recalcular o orçamento.
                                            </div>
                                        </div>
                                    );
                                })()}
                                <FinField label="Observação" full>
                                    <FinTextarea rows={2} style={{ height: 'auto', padding: '10px 14px' }} value={cotacaoForm.observacao}
                                        onChange={(e) => campoCotacao('observacao', e.target.value)} />
                                </FinField>
                                {pendenciaCotacao(planoAprovarModal.cotacao_base, cotacaoForm) && (
                                    <div className="fin-pp__banner is-warn mt-2">
                                        <span>{pendenciaCotacao(planoAprovarModal.cotacao_base, cotacaoForm)}</span>
                                    </div>
                                )}
                                <div className="fin-pp__banner is-info mt-3">
                                    <FaFileInvoiceDollar className="fin-pp__banner-ic" size={16} />
                                    {/* 07/10: plano com conta já em Contas Pendentes — a parcela entra no mesmo título. */}
                                    {vaiParaContasPagar(planoAprovarModal) && planoAprovarModal.orcamento_alterado ? (
                                        <span>A(s) parcela(s) entra(m) no <strong>mesmo título</strong> que já está em Contas a Pagar — as parcelas antigas não mudam. O responsável do evento será notificado por e-mail.</span>
                                    ) : vaiParaContasPagar(planoAprovarModal) ? (
                                        <span>Um <strong>título financeiro</strong> será criado automaticamente em Contas a Pagar e o responsável do evento será notificado por e-mail.</span>
                                    ) : (
                                        <span>Este fornecedor está marcado como <strong>não vai para Contas a Pagar</strong>: nenhum título de pagamento será criado, e ele segue normalmente para o faturamento. O responsável do evento será notificado por e-mail.</span>
                                    )}
                                </div>

                                {/* Toggle: notificar fornecedor */}
                                {(() => {
                                    // Prioridade de e-mail: campo específico da Previsão → e-mail do cadastro do fornecedor
                                    const emailEfetivo = planoAprovarModal.email_fornecedor_nf || planoAprovarModal.fornecedor_email;
                                    const origemEmail  = planoAprovarModal.email_fornecedor_nf
                                        ? null   // nulo = vem da Previsão de Pagamento (não precisa indicar origem)
                                        : planoAprovarModal.fornecedor_email
                                            ? '(e-mail do cadastro do fornecedor)'
                                            : null;
                                    return (
                                        <div style={{ background: 'var(--fin-sf2)', border: '1px solid var(--fin-bd)', borderRadius: 'var(--fin-rds)', padding: 14, marginBottom: 4 }}>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div>
                                                    <div className="fw-semibold" style={{ fontSize: '0.88rem' }}>📧 Notificar fornecedor por e-mail</div>
                                                    <div className="text-muted" style={{ fontSize: '0.78rem' }}>Enviar solicitação de NF com link para upload</div>
                                                </div>
                                                <div className="form-check form-switch mb-0 ms-3">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="enviarEmailNF"
                                                        role="switch"
                                                        style={{ width: '2.5em', height: '1.3em', cursor: emailEfetivo ? 'pointer' : 'not-allowed' }}
                                                        checked={enviarEmailFornecedorNF}
                                                        disabled={!emailEfetivo}
                                                        onChange={e => setEnviarEmailFornecedorNF(e.target.checked)}
                                                    />
                                                </div>
                                            </div>

                                            {/* Feedback contextual */}
                                            {emailEfetivo ? (
                                                <div style={{ fontSize: '0.78rem' }}>
                                                    {enviarEmailFornecedorNF ? (
                                                        <span className="text-success">
                                                            ✅ E-mail será enviado para <strong>{emailEfetivo}</strong>
                                                        </span>
                                                    ) : (
                                                        <span className="text-warning">
                                                            ⚠️ E-mail <strong>NÃO</strong> será enviado ao fornecedor
                                                        </span>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="text-danger" style={{ fontSize: '0.78rem' }}>
                                                    🚫 Nenhum e-mail disponível — nem na Previsão de Pagamento nem no cadastro do fornecedor
                                                </div>
                                            )}

                                            <div className="text-muted mt-2" style={{ fontSize: '0.75rem' }}>
                                                ℹ️ Esta informação será incluída no e-mail enviado ao responsável do evento.
                                            </div>
                                        </div>
                                    );
                                })()}

                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => { setPlanoAprovarModal(null); setEnviarEmailFornecedorNF(false); }}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--ok" disabled={salvandoPlano || !!pendenciaCotacao(planoAprovarModal.cotacao_base, cotacaoForm)} onClick={aprovarPlano}>
                                    <FaCheck size={13} /> {salvandoPlano ? 'Aprovando...' : 'Confirmar Aprovação'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Solicitar NF ao Fornecedor (seção Aprovados) ── */}
            {solicitarNFUnifModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                    <div className={'modal-dialog modal-dialog-centered' + (nfParcelasDoItem(solicitarNFUnifModal).length ? ' modal-lg' : '')}>
                        <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileInvoice size={17} /></span>
                                <h3 className="fin-pp__modal-title">Solicitar NF ao Fornecedor
                                    <span className="fin-pp__modal-sub">{solicitarNFUnifModal.fornecedor}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setSolicitarNFUnifModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">
                                    <><strong>Link de upload</strong> enviado ao fornecedor — ele acessa a página segura e envia o documento fiscal diretamente pelo sistema.</>
                                    {' '}Ref.: <strong>{solicitarNFUnifModal.referencia}</strong>
                                </p>
                                {nfParcelasDoItem(solicitarNFUnifModal).length > 0 && (
                                    <div className="mb-3" data-pedido-parcelas>
                                        <div className="fin-pp__label" style={{ marginBottom: 6 }}>Parcelas que precisam de nota</div>
                                        <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                                            <NfParcelasTabela parcelas={nfParcelasDoItem(solicitarNFUnifModal)} marcadas={parcelasSolicitarNFUnif}
                                                disabled={enviandoNFSolicitacaoUnif} rotuloSoma="Valor das parcelas pedidas" idPrefixo="fin-nfped"
                                                onAlternar={(id) => setParcelasSolicitarNFUnif(prev => alternar(prev, id))} />
                                        </div>
                                        <small className="text-muted d-block mt-1">
                                            {parcelasSolicitarNFUnif.length === 0
                                                ? 'Marque ao menos uma parcela para pedir a nota.'
                                                : 'O fornecedor recebe um link só, com estas parcelas, e marca quais cada nota cobre.'}
                                        </small>
                                        {avisoPedidoDeNovo(nfParcelasDoItem(solicitarNFUnifModal), parcelasSolicitarNFUnif) && (
                                            <div className="fin-pp__banner is-warn" style={{ marginTop: 8, marginBottom: 0, fontSize: 13 }} data-aviso-pedido-de-novo>
                                                {avisoPedidoDeNovo(nfParcelasDoItem(solicitarNFUnifModal), parcelasSolicitarNFUnif)}
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="mb-2">
                                    <label className="form-label small fw-bold">
                                        E-mails para envio
                                        {solicitarNFUnifModal.fornecedor_email && (
                                            <span className="text-muted fw-normal ms-2" style={{ fontSize: '0.78rem' }}>
                                                (pré-preenchido do cadastro do fornecedor)
                                            </span>
                                        )}
                                    </label>
                                    {emailsSolicitarNFUnif.map(function(email, idx) {
                                        return (
                                            <div key={idx} className="d-flex gap-2 mb-2 align-items-center">
                                                <input
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    placeholder="email@fornecedor.com"
                                                    value={email}
                                                    onChange={function(e) {
                                                        setEmailsSolicitarNFUnif(function(prev) {
                                                            return prev.map(function(v, i) { return i === idx ? e.target.value : v; });
                                                        });
                                                    }}
                                                />
                                                {emailsSolicitarNFUnif.length > 1 && (
                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                                        onClick={function() {
                                                            setEmailsSolicitarNFUnif(function(prev) {
                                                                return prev.filter(function(_, i) { return i !== idx; });
                                                            });
                                                        }}>
                                                        <FaTimes size={12} />
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={function() { setEmailsSolicitarNFUnif(function(prev) { return [...prev, '']; }); }}>
                                        <FaPlus size={12} /> Adicionar e-mail
                                    </button>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setSolicitarNFUnifModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={enviarSolicitacaoNFUnif}
                                    disabled={enviandoNFSolicitacaoUnif || (nfParcelasDoItem(solicitarNFUnifModal).length > 0 && parcelasSolicitarNFUnif.length === 0)}>
                                    <FaFileInvoice size={13} /> {enviandoNFSolicitacaoUnif ? 'Enviando...' : 'Enviar Solicitação'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Vincular NF Internamente (seção Aprovados) ── */}
            {vincularNFModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                    <div className={'modal-dialog modal-dialog-centered ' + (nfParcelasDoItem(vincularNFModal).length > 1 ? 'modal-lg' : 'modal-md')}>
                        <div className="modal-content fin-pp__modal fin-pp__modal--scroll">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileAlt size={17} /></span>
                                <h3 className="fin-pp__modal-title">Vincular Nota Fiscal (Upload Interno)
                                    <span className="fin-pp__modal-sub">{vincularNFModal.fornecedor} — {vincularNFModal.referencia}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setVincularNFModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Arquivo da NF <span className="text-danger">*</span></label>
                                    <input
                                        type="file"
                                        className="form-control form-control-sm"
                                        accept=".pdf,.xml,.jpg,.jpeg,.png"
                                        onChange={function(e) { setVincularNFFile(e.target.files[0] || null); }}
                                    />
                                    <small className="text-muted">PDF, XML ou imagem — máx. 10 MB</small>
                                </div>
                                <div className="row g-2 mb-3">
                                    <div className="col-5">
                                        <label className="form-label small fw-bold">Tipo de Documento <span className="text-danger">*</span></label>
                                        <select className="form-select form-select-sm" value={vincularNFTipoDoc}
                                            onChange={function(e) { setVincularNFTipoDoc(e.target.value); }}>
                                            <option value="nf">NF / NFS-e</option>
                                            <option value="nd">Nota de Débito</option>
                                            <option value="recibo">Recibo</option>
                                            <option value="fatura">Fatura</option>
                                            <option value="apolice">Apólice de seguro</option>
                                        </select>
                                    </div>
                                    <div className="col-7">
                                        <label className="form-label small fw-bold">Número / Referência <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Ex: 1234 / NFS-e 0056"
                                            value={vincularNFNumero}
                                            onChange={function(e) { setVincularNFNumero(e.target.value); }}
                                        />
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label className="form-label small fw-bold">Observação (opcional)</label>
                                    <textarea className="form-control form-control-sm" rows={2}
                                        placeholder="Ex: NF entregue em mãos, escaneada pela Katia"
                                        value={vincularNFObs}
                                        onChange={function(e) { setVincularNFObs(e.target.value); }}
                                    />
                                </div>
                                {nfParcelasDoItem(vincularNFModal).length > 1 && (
                                    <div className="mb-3" data-vincular-parcelas>
                                        <div className="fin-pp__label" style={{ marginBottom: 6 }}>Parcelas que esta nota cobre <span className="text-danger">*</span></div>
                                        <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                                            <NfParcelasTabela parcelas={nfParcelasDoItem(vincularNFModal)} marcadas={parcelasVincularNF}
                                                disabled={salvandoVincularNF} rotuloSoma="Valor desta nota" idPrefixo="fin-nfvinc"
                                                onAlternar={(id) => setParcelasVincularNF(prev => alternar(prev, id))} />
                                        </div>
                                    </div>
                                )}
                                <div className="fin-pp__banner is-info" style={{ marginBottom: 0 }}>
                                    <FaFileInvoiceDollar className="fin-pp__banner-ic" size={16} />
                                    <span>O arquivo será processado (extração automática de dados via OCR) e vinculado às parcelas financeiras do fornecedor. A NF aparecerá na seção <strong>Contas Pendentes</strong>.</span>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setVincularNFModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={submeterVincularNF}
                                    disabled={salvandoVincularNF || (nfParcelasDoItem(vincularNFModal).length > 1 && parcelasVincularNF.length === 0)}>
                                    <FaFileAlt size={13} /> {salvandoVincularNF ? 'Processando...' : 'Vincular Nota Fiscal'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Reprovar Plano de Pagamento ── */}
            {planoReprovarModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><FaTimes size={17} /></span>
                                <h3 className="fin-pp__modal-title">Reprovar Plano de Pagamento</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setPlanoReprovarModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="mb-3">
                                    Reprovar o plano de <strong>{nomeFornecedorPlano(planoReprovarModal)}</strong>
                                    {planoReprovarModal.evento_nome && <> — evento <strong>{planoReprovarModal.evento_nome}</strong></>}?
                                    O operador será notificado por e-mail e in-app.
                                </p>
                                <div className="mb-2">
                                    <label className="form-label small fw-bold">Motivo / Observação (opcional)</label>
                                    <textarea className="form-control form-control-sm" rows={3}
                                        placeholder="Ex: Data de previsão incorreta, valor divergente..."
                                        value={motivoReprovacaoPlano}
                                        onChange={e => setMotivoReprovacaoPlano(e.target.value)} />
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setPlanoReprovarModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" disabled={salvandoPlano} onClick={reprovarPlano}>
                                    <FaTimes size={13} /> {salvandoPlano ? 'Reprovando...' : 'Confirmar Reprovação'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* ── Modal: Voltar para Planos de Pagamento (D-0097) ── */}
            {voltaPlanosModal && (
                <ModalVoltaParaPlanos
                    plano={{ id: voltaPlanosModal._id, fornecedor: voltaPlanosModal.fornecedor, referencia: voltaPlanosModal.referencia_codigo }}
                    onFechar={(falhou) => { setVoltaPlanosModal(null); if (falhou) recarregarCustoPrevisto(); }}
                    onConcluido={() => { setVoltaPlanosModal(null); recarregarCustoPrevisto(); buscarPlanosPrevistos(); }} />
            )}

            {/* ── Modal: Status de Pagamento do Adiantamento ── */}
            {modalStatusPgto && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 480 }}>
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileInvoiceDollar size={17} /></span>
                                <h3 className="fin-pp__modal-title">Status do Pagamento — Adiantamento
                                    <span className="fin-pp__modal-sub">{modalStatusPgto.referencia}{modalStatusPgto.evento_nome !== '(sem evento)' ? ' · ' + modalStatusPgto.evento_nome : ''}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={fecharModalStatusPgto}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">O responsável do evento receberá um e-mail com o status atualizado.</p>

                                {/* Seleção de status */}
                                <div className="d-flex gap-2 mb-3">
                                    <button
                                        type="button"
                                        onClick={() => setModalStatusPgtoSel('creditado')}
                                        style={{
                                            flex: 1, padding: '12px 8px', borderRadius: 8, cursor: 'pointer',
                                            border: modalStatusPgtoSel === 'creditado' ? '2px solid #198754' : '2px solid #dee2e6',
                                            background: modalStatusPgtoSel === 'creditado' ? '#d1e7dd' : '#fff',
                                            color: modalStatusPgtoSel === 'creditado' ? '#0f5132' : '#6c757d',
                                            fontWeight: modalStatusPgtoSel === 'creditado' ? 700 : 400,
                                            textAlign: 'center', fontSize: '0.88rem',
                                        }}>
                                        ✅ Creditado<br />
                                        <small style={{ fontWeight: 400, fontSize: '0.72rem' }}>Pagamento recebido</small>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setModalStatusPgtoSel('nao_creditado')}
                                        style={{
                                            flex: 1, padding: '12px 8px', borderRadius: 8, cursor: 'pointer',
                                            border: modalStatusPgtoSel === 'nao_creditado' ? '2px solid #dc3545' : '2px solid #dee2e6',
                                            background: modalStatusPgtoSel === 'nao_creditado' ? '#f8d7da' : '#fff',
                                            color: modalStatusPgtoSel === 'nao_creditado' ? '#842029' : '#6c757d',
                                            fontWeight: modalStatusPgtoSel === 'nao_creditado' ? 700 : 400,
                                            textAlign: 'center', fontSize: '0.88rem',
                                        }}>
                                        ❌ Não Creditado<br />
                                        <small style={{ fontWeight: 400, fontSize: '0.72rem' }}>Pagamento não recebido</small>
                                    </button>
                                </div>

                                {/* Observação */}
                                <div className="mb-1">
                                    <label className="form-label small fw-bold">Observação <span className="text-muted fw-normal">(opcional — aparece no e-mail)</span></label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        rows={3}
                                        placeholder={modalStatusPgtoSel === 'nao_creditado'
                                            ? 'Ex: Cliente informou dificuldade de caixa, nova data acordada para 15/07...'
                                            : 'Ex: Pagamento recebido via TED em 05/06, comprovante enviado...'}
                                        value={modalStatusPgtoObs}
                                        onChange={e => setModalStatusPgtoObs(e.target.value)}
                                    />
                                </div>

                                {/* Aviso específico para Não Creditado */}
                                {modalStatusPgtoSel === 'nao_creditado' && (
                                    <div className="mt-3 p-2 rounded small" style={{ background: '#fff3cd', border: '1px solid #ffc107', color: '#664d03' }}>
                                        ⚠️ O operador responsável será notificado para renegociar a data com o fornecedor e atualizar a Previsão de Pagamento.
                                    </div>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={fecharModalStatusPgto}>Cancelar</button>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--sm"
                                    disabled={!modalStatusPgtoSel || !!salvandoStatusPgto[modalStatusPgto._parcelaId]}
                                    style={{
                                        background: modalStatusPgtoSel === 'creditado' ? 'var(--fin-ok)' : modalStatusPgtoSel === 'nao_creditado' ? 'var(--fin-dg)' : 'var(--fin-mt)',
                                        color: '#fff', borderColor: 'transparent',
                                    }}
                                    onClick={salvarStatusPgto}>
                                    {salvandoStatusPgto[modalStatusPgto._parcelaId] ? 'Salvando...' : 'Salvar e enviar e-mail'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* ── Modal: Cartão Seguro — Inserir/Alterar Dados (Financeiro) ── */}
            {cartaoModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal fin-pp__modal--flow">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaCreditCard size={17} /></span>
                                <h3 className="fin-pp__modal-title">Cartão — Pagamento Seguro
                                    <span className="fin-pp__modal-sub">{cartaoModal.parcela?.descricao}{cartaoModal.contexto?.evento?.nome ? ' · ' + cartaoModal.contexto.evento.nome : ''}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setCartaoModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: 280 }}>
                                <div className="mb-3 p-2 rounded small" style={{ background: 'var(--fin-acw)', border: '1px solid var(--fin-acb)', color: 'var(--fin-tx)' }}>
                                    🔒 Os dados são criptografados e acessíveis apenas via código de uso único enviado ao e-mail do operador. O CVV é removido após a primeira visualização.
                                </div>
                                <div className="fin-pp__filters">
                                    {cartoesDisponiveis.length > 0 && (
                                        <FinField label="Cartão cadastrado (Caixa)" grow>
                                            <ReactSelect
                                                isClearable
                                                placeholder="Selecionar cartão cadastrado..."
                                                options={cartoesDisponiveis.map(cx => ({ value: cx.id, label: cx.nome + ' — ' + cx.mascara + ' · ' + cx.titular + ' · val. ' + cx.validade }))}
                                                value={cartoesDisponiveis.filter(cx => cx.id === formCartao.caixa_cartao_id).map(cx => ({ value: cx.id, label: cx.nome + ' — ' + cx.mascara + ' · ' + cx.titular + ' · val. ' + cx.validade }))[0] ?? null}
                                                onChange={e => setFormCartao(f => ({ ...f, caixa_cartao_id: e ? e.value : '', numero: '', titular: '', validade: '' }))}
                                            />
                                        </FinField>
                                    )}
                                    <FinField label="&nbsp;">
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ height: 44 }}
                                            title="Cadastrar um novo cartão no Caixa (número, titular e validade — sem CVV)"
                                            onClick={() => history.push('/cadastroCaixa')}>
                                            <FaPlus size={12} /> Cadastrar novo cartão
                                        </button>
                                    </FinField>
                                    {!formCartao.caixa_cartao_id && (
                                        <>
                                            <FinField label="Número do cartão" required>
                                                <FinInput value={formCartao.numero} placeholder="0000 0000 0000 0000"
                                                    onChange={e => setFormCartao(f => ({ ...f, numero: e.target.value }))} />
                                            </FinField>
                                            <FinField label="Titular" required>
                                                <FinInput value={formCartao.titular} placeholder="Nome impresso no cartão"
                                                    onChange={e => setFormCartao(f => ({ ...f, titular: e.target.value }))} />
                                            </FinField>
                                            <FinField label="Validade" required>
                                                <FinInput value={formCartao.validade} placeholder="MM/AA"
                                                    onChange={e => setFormCartao(f => ({ ...f, validade: e.target.value }))} />
                                            </FinField>
                                        </>
                                    )}
                                    <FinField label="CVV (não fica armazenado)" required>
                                        <FinInput value={formCartao.cvv} placeholder="000" type="password"
                                            onChange={e => setFormCartao(f => ({ ...f, cvv: e.target.value }))} />
                                    </FinField>
                                    <FinField label="Operador (vinculado ao evento)">
                                        <ReactSelect
                                            isClearable
                                            placeholder="Selecionar operador..."
                                            options={(cartaoModal.contexto?.operadores ?? []).map(op => ({ value: op.id, label: op.nome + ' — ' + op.email, email: op.email }))}
                                            value={(cartaoModal.contexto?.operadores ?? []).filter(op => op.id === formCartao.operador_id).map(op => ({ value: op.id, label: op.nome + ' — ' + op.email }))[0] ?? null}
                                            onChange={e => setFormCartao(f => ({ ...f, operador_id: e ? e.value : '', operador_email: e ? e.email : (cartaoModal.contexto?.responsavel?.email ?? '') }))}
                                        />
                                    </FinField>
                                    <FinField label="E-mail que recebe o código" required>
                                        <FinInput value={formCartao.operador_email} placeholder="operador@email.com" type="email"
                                            onChange={e => setFormCartao(f => ({ ...f, operador_email: e.target.value }))} />
                                    </FinField>
                                </div>
                                {cartaoModal.contexto?.responsavel && !formCartao.operador_id && (
                                    <p className="small text-muted mt-2 mb-0">E-mail pré-preenchido com o responsável do evento: <strong>{cartaoModal.contexto.responsavel.nome}</strong>.</p>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setCartaoModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                                    disabled={loadingCartao || !formCartao.cvv || !formCartao.operador_email || (!formCartao.caixa_cartao_id && (!formCartao.numero || !formCartao.titular || !formCartao.validade))}
                                    onClick={salvarDadosCartao}>
                                    <FaCreditCard size={13} /> {loadingCartao ? 'Salvando...' : 'Salvar com segurança'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Cartão Seguro — Status (Financeiro) ── */}
            {cartaoStatusModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaCreditCard size={17} /></span>
                                <h3 className="fin-pp__modal-title">Cartão — Pagamento Seguro
                                    <span className="fin-pp__modal-sub">{cartaoStatusModal.parcela?.descricao}{cartaoStatusModal.contexto?.evento?.nome ? ' · ' + cartaoStatusModal.contexto.evento.nome : ''}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setCartaoStatusModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                    <span className="fin-pp__pill is-ok">🔐 Dados armazenados com segurança</span>
                                    {(cartaoStatusModal.contexto?.cartao?.arquivo_comprovante_id || cartaoStatusModal.parcela?.arquivocomprovantepagamento?.id) && (
                                        <span className="fin-pp__pill is-info">Comprovante enviado pelo operador</span>
                                    )}
                                </div>

                                <p className="small text-muted mb-2">
                                    O operador <strong>{cartaoStatusModal.contexto?.cartao?.operador_email ?? ''}</strong> recebeu um e-mail com o link da página de pagamento. Lá ele solicita o código de acesso, visualiza os dados do cartão, paga o fornecedor e anexa o comprovante.
                                </p>
                                <p className="small text-muted mb-3">
                                    A parcela permanece em <strong>Contas Pendentes</strong> até você confirmar o pagamento pelo botão <strong>Pagar</strong>.
                                </p>

                                <div className="d-flex gap-2 flex-wrap align-items-center">
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={loadingCartao}
                                        onClick={() => reenviarAvisoCartao(cartaoStatusModal.parcela.id)}>
                                        <FaSync size={12} /> {loadingCartao ? 'Enviando...' : 'Reenviar aviso ao operador'}
                                    </button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={() => { const p = cartaoStatusModal.parcela; const ctx = cartaoStatusModal.contexto; setCartaoStatusModal(null); abrirInserirDadosCartao(p, ctx); }}>
                                        <FaPen size={12} /> Alterar dados / trocar operador
                                    </button>
                                    {/* Banco recusou: libera o envio de outro cartão */}
                                    <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm"
                                        onClick={() => { const p = cartaoStatusModal.parcela; setCartaoStatusModal(null); setNegarCartaoModal({ parcela: p, motivo: '' }); }}>
                                        <FaTimes size={12} /> Cartão negado pelo banco
                                    </button>
                                    {(cartaoStatusModal.contexto?.cartao?.arquivo_comprovante_id || cartaoStatusModal.parcela?.arquivocomprovantepagamento?.id) && (
                                        <FormButton method="get" title="Ver comprovante"
                                            action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + cartaoStatusModal.parcela.id}
                                            icon={<FaFileInvoiceDollar size={14} />} color="primary"
                                            data={{ token: localStorage.getItem('token'), tipoArquivo: 'comprovantepagamento' }} />
                                    )}
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setCartaoStatusModal(null)}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: cartão negado pelo banco (padrão fin-pp) ──────────────────
                Modal próprio em vez de window.confirm porque o MOTIVO vira
                histórico — é ele que explica depois por que outro cartão foi
                cadastrado, e evita reenviar o recusado por engano. */}
            {negarCartaoModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={function (e) { if (e.target === e.currentTarget) setNegarCartaoModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><FaTimes size={17} /></span>
                                <h3 className="fin-pp__modal-title">Cartão negado pelo banco
                                    <span className="fin-pp__modal-sub">{negarCartaoModal.parcela?.descricao || ''}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setNegarCartaoModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">
                                    O cartão sai desta parcela e você poderá <strong>enviar outro</strong>. O registro
                                    do cartão recusado fica no histórico — quem negou, quando e o motivo.
                                </p>
                                <label className="fin-pp__label">Motivo (opcional)</label>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    placeholder="Ex.: limite insuficiente, cartão bloqueado"
                                    value={negarCartaoModal.motivo}
                                    onChange={function (e) { setNegarCartaoModal({ ...negarCartaoModal, motivo: e.target.value }); }} />
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setNegarCartaoModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" disabled={loadingCartao}
                                    onClick={() => negarCartao(negarCartaoModal.parcela.id, negarCartaoModal.motivo)}>
                                    {loadingCartao ? 'Registrando...' : 'Confirmar — cartão recusado'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Voltar item para "Aprovados pelo Financeiro" (padrão fin-pp) ── */}
            {travarModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget && !travando) setTravarModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaLock size={16} /></span>
                                <h3 className="fin-pp__modal-title">Travar para pagamento
                                    {travarModal.titulo && <span className="fin-pp__modal-sub">{travarModal.titulo}</span>}
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setTravarModal(null)} disabled={travando}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <ul style={{ paddingLeft: 18, marginBottom: 12, fontSize: '0.85rem' }}>
                                    {travarModal.parcelas.map(function (r) {
                                        return <li key={r.id}>R$ {moeda(r.valor)} · vence {r.vencimento ? moment(r.vencimento).format('DD/MM/YYYY') : '—'}</li>;
                                    })}
                                </ul>
                                <p style={{ margin: 0 }}>Os <strong>responsáveis do evento</strong> recebem um e-mail avisando que {travarModal.parcelas.length > 1 ? 'estas parcelas entraram' : 'esta parcela entrou'} no pagamento. A partir daí o Eventos <strong>não altera</strong> dados bancários, quem paga, NF nem adiantamento. Para destravar, use <strong>Voltar para Custo Previsto</strong>.</p>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setTravarModal(null)} disabled={travando}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={travando} data-confirmar-travar
                                    onClick={() => {
                                        setTravando(true);
                                        api({ method: 'put', action: '/financeiroParcela/travarPagamento', token, data: { ids: travarModal.parcelas.map(function (r) { return String(r.id); }) } })
                                            .then(function (res) {
                                                setTravarModal(null);
                                                buscar();
                                                var msg = (res && res.data && res.data.msg) || 'Parcela travada para pagamento.';
                                                if (msg.indexOf('⚠️') >= 0 || (res && res.data && res.data.fora_de_pendentes > 0)) toast.warning(msg); else toast.success(msg);
                                            })
                                            .catch(function (err) {
                                                var erro = (err && err.response && err.response.data && err.response.data.error) || 'Erro ao travar para pagamento.';
                                                toast.error(erro);
                                                // 10/10 (item 23): conta já voltou para o Custo Previsto — recarrega para sumir da lista.
                                                if (/Atualize a tela/.test(erro)) { setTravarModal(null); buscar(); }
                                            })
                                            .finally(function () { setTravando(false); });
                                    }}>
                                    <FaLock size={13} /> {travando ? 'Travando...' : 'Travar para pagamento'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {reverterModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget && !revertendo) setReverterModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><ImCancelCircle size={17} /></span>
                                <h3 className="fin-pp__modal-title">Remover de Contas Pendentes
                                    {reverterModal.descricao && <span className="fin-pp__modal-sub">{reverterModal.descricao}</span>}
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setReverterModal(null)} disabled={revertendo}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                {reverterModal.liberado_financeiro_at ? (
                                    <p style={{ margin: 0 }}>O item voltará para <strong>Aprovados pelo Financeiro</strong> no Custo Previsto e precisará ser liberado novamente. Se houver complemento do orçamento aguardando, ele é somado a esta parcela e ela volta para aprovação.</p>
                                ) : (
                                    <p style={{ margin: 0 }}>Esta conta não veio de uma Previsão de Pagamento. Ela vai para a aba <strong>Cancelado</strong> (com o motivo) e o mesmo valor entra no <strong>Custo Previsto</strong>, aguardando aprovação — sem fornecedor, entra como "(Fornecedor a definir)".</p>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setReverterModal(null)} disabled={revertendo}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" disabled={revertendo}
                                    onClick={() => {
                                        setRevertendo(true);
                                        api({ method: 'put', action: '/financeiroParcela/' + reverterModal.id + '/reverterLiberacao', token, data: {} })
                                            .then(function (res) {
                                                setReverterModal(null);
                                                buscar();
                                                recarregarCustoPrevisto();
                                                toast.success((res && res.data && res.data.msg) || 'Item revertido para Custo Previsto.');
                                            })
                                            .catch(function (err) { toast.error((err && err.response && err.response.data && err.response.data.error) || 'Erro ao reverter item.'); })
                                            .finally(function () { setRevertendo(false); });
                                    }}>
                                    <FaThumbsUp size={16} /> Voltar para Custo Previsto
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Documentos da parcela (1:N) ────────────────────────────────── */}
            {!!modalArquivos && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={(e) => { if (e.target === e.currentTarget) setModalArquivos(null); }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileAlt size={17} /></span>
                                <h3 className="fin-pp__modal-title">
                                    Documentos da parcela
                                    <span className="fin-pp__modal-sub">{modalArquivos.row.descricao}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setModalArquivos(null)}>
                                    <FaTimes size={16} />
                                </button>
                            </div>
                            <div className="modal-body" style={{ padding: 0 }}>
                                {(function () {
                                    if (modalArquivos.carregando) {
                                        return <div className="fin-pp__empty" style={{ padding: '34px 0' }}>Carregando documentos…</div>;
                                    }
                                    var linhas = [];
                                    TIPOS_DOC.forEach(function (t) {
                                        var docs = (modalArquivos.docs && modalArquivos.docs[t.key]) || [];
                                        docs.forEach(function (d) { linhas.push({ tipo: t, doc: d, total: docs.length }); });
                                    });
                                    if (linhas.length === 0) {
                                        // Sem o endpoint 1:N (ou sem registro na tabela nova), cai no
                                        // arquivo único legado, que é o que a coluna mostrava antes.
                                        return (
                                            <div style={{ padding: 16 }}>
                                                <div className="fin-pp__cell-muted" style={{ marginBottom: 10 }}>
                                                    Documentos anexados antes do controle de múltiplos arquivos.
                                                </div>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {modalArquivos.row.arquivoboleto && modalArquivos.row.arquivoboleto.id && (
                                                        <FormButton method="get" title="Boleto" label="Boleto" action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + modalArquivos.row.id} icon={<FaFileInvoice size={14} />} color="outline-primary" data={{ token: localStorage.getItem('token'), tipoArquivo: 'boleto' }} />)}
                                                    {modalArquivos.row.arquivonotafiscal && modalArquivos.row.arquivonotafiscal.id && (
                                                        <FormButton method="get" title="Nota Fiscal" label="Nota Fiscal" action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + modalArquivos.row.id} icon={<FaFileAlt size={14} />} color="outline-primary" data={{ token: localStorage.getItem('token'), tipoArquivo: 'notafiscal' }} />)}
                                                    {modalArquivos.row.arquivocomprovantepagamento && modalArquivos.row.arquivocomprovantepagamento.id && (
                                                        <FormButton method="get" title="Comprovante" label="Comprovante" action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + modalArquivos.row.id} icon={<FaFileInvoiceDollar size={14} />} color="outline-primary" data={{ token: localStorage.getItem('token'), tipoArquivo: 'comprovantepagamento' }} />)}
                                                    {modalArquivos.row.arquivoreciboadiantamento && modalArquivos.row.arquivoreciboadiantamento.id && (
                                                        <FormButton method="get" title="Recibo" label="Recibo" action={process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + modalArquivos.row.id} icon={<FaFileAlt size={14} />} color="outline-primary" data={{ token: localStorage.getItem('token'), tipoArquivo: 'reciboadiantamento' }} />)}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div className="fin-pp__tblwrap">
                                            <table className="fin-pp__tbl">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '22%' }}>Tipo</th>
                                                        <th>Documento</th>
                                                        <th style={{ width: '22%' }}>Enviado em</th>
                                                        <th style={{ width: '16%' }}>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {linhas.map(function (l) {
                                                        return (
                                                            <tr key={l.tipo.key + '_' + l.doc.id}>
                                                                <td className="fin-pp__cell-muted" style={{ whiteSpace: 'nowrap' }}>{l.tipo.icone} {l.doc.rotulo_tipo || l.tipo.rotulo}</td>
                                                                <td className="fin-pp__cell-strong fin-pp__ellipsis" title={l.doc.nome}>
                                                                    {l.doc.nome}
                                                                    {l.doc.principal && l.total > 1 && (
                                                                        <span className="fin-pp__minitag is-info" style={{ marginLeft: 6 }}>principal</span>
                                                                    )}
                                                                </td>
                                                                <td className="fin-pp__cell-muted" style={{ whiteSpace: 'nowrap' }}>
                                                                    {l.doc.created_at ? moment(l.doc.created_at).format('DD/MM/YYYY HH:mm') : '—'}
                                                                </td>
                                                                <td>
                                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                                        onClick={() => window.open(process.env.REACT_APP_API_URL + '/arquivo/download/' + l.doc.arquivo_id, '_blank')}>
                                                                        Baixar
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                })()}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setModalArquivos(null)}>Fechar</button>
                                <Link className="fin-pp__btn fin-pp__btn--primary" to={'/financeiroParcelaDetalhe/' + modalArquivos.row.id}>
                                    Abrir detalhe da conta
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Notas fiscais do item (Custo Previsto, 1:N) ────────────────── */}
            {!!modalNFs && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={(e) => { if (e.target === e.currentTarget) setModalNFs(null); }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-ok"><FaFileAlt size={17} /></span>
                                <h3 className="fin-pp__modal-title">
                                    Notas fiscais
                                    <span className="fin-pp__modal-sub">
                                        {modalNFs.item.fornecedor} · {modalNFs.item.referencia}
                                    </span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setModalNFs(null)}>
                                    <FaTimes size={16} />
                                </button>
                            </div>
                            <div className="modal-body" style={{ padding: 0 }}>
                                <div className="fin-pp__tblwrap">
                                    <table className="fin-pp__tbl">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '16%' }}>Número</th>
                                                <th>Arquivo</th>
                                                <th style={{ width: '16%' }}>Emissão</th>
                                                <th className="text-end" style={{ width: '16%' }}>Valor</th>
                                                <th style={{ width: '19%' }}>Conferência</th>
                                                <th style={{ width: '10%' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(modalNFs.item.nfs || []).map(function (nf) {
                                                return (
                                                    <React.Fragment key={nf.nota_fiscal_id}>
                                                    <tr>
                                                        <td className="fin-pp__cell-strong" style={{ whiteSpace: 'nowrap' }}>
                                                            {nf.numero || '—'}
                                                            {nf.tipo ? <span className="fin-pp__minitag is-info" style={{ marginLeft: 6 }}>{String(nf.tipo).toUpperCase()}</span> : null}
                                                            {nfParcelasDoItem(modalNFs.item).length > 1 && (
                                                                <div className="fin-pp__cell-muted" style={{ fontWeight: 400, fontSize: 12 }}>
                                                                    {rotuloParcelasDaNf(nf.parcelas, nfParcelasDoItem(modalNFs.item))}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="fin-pp__cell-muted fin-pp__ellipsis" title={nf.nome}>{nf.nome}</td>
                                                        <td className="fin-pp__cell-muted" style={{ whiteSpace: 'nowrap' }}>
                                                            {nf.data_emissao
                                                                ? moment(nf.data_emissao).format('DD/MM/YYYY')
                                                                : (nf.created_at ? moment(nf.created_at).format('DD/MM/YYYY') : '—')}
                                                        </td>
                                                        <td className="fin-pp__cell-num">
                                                            {moeda(nf.valor_bruto)}
                                                            {nf.valor_adiantamento > 0 && (
                                                                <div className="fin-pp__cell-muted" style={{ fontWeight: 400 }}>
                                                                    Adt − {moeda(nf.valor_adiantamento)} · Pagar {moeda(nf.valor_liquido)}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>{nf.validacao ? <NfValidacaoPill validacao={nf.validacao} /> : <span className="fin-pp__cell-muted">—</span>}</td>
                                                        <td>
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                                onClick={() => baixarArquivoNF(nf.arquivo_id, nf.nome)}>
                                                                Baixar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    {nf.validacao && (
                                                        <tr className="fin-pp__tbl-sub">
                                                            <td colSpan={6} style={{ paddingTop: 0 }}>
                                                                <NfValidacaoDetalhe validacao={nf.validacao} compacto />
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </React.Fragment>
                                                );
                                            })}
                                            {/* NF cancelada enviada pelo fornecedor (13/10): comprovante, não soma */}
                                            {(modalNFs.item.nfs_canceladas || []).map(function (nfc) {
                                                return (
                                                    <React.Fragment key={'c' + nfc.id}>
                                                    <tr>
                                                        <td className="fin-pp__cell-strong" style={{ whiteSpace: 'nowrap' }}>
                                                            {nfc.numero || '—'}
                                                            <span className="fin-pp__minitag" style={{ marginLeft: 6, background: 'var(--fin-dgb)', color: 'var(--fin-dg)' }} title="NF cancelada enviada pelo fornecedor">CANCELADA</span>
                                                        </td>
                                                        <td className="fin-pp__cell-muted fin-pp__ellipsis" title={nfc.nome}>{nfc.nome}</td>
                                                        <td className="fin-pp__cell-muted" style={{ whiteSpace: 'nowrap' }}>
                                                            {nfc.created_at ? moment(nfc.created_at).format('DD/MM/YYYY') : '—'}
                                                        </td>
                                                        <td className="fin-pp__cell-num fin-pp__cell-muted" style={{ textDecoration: 'line-through' }}>{moeda(nfc.valor)}</td>
                                                        <td><span className="fin-pp__cell-muted">Comprovante, não soma</span></td>
                                                        <td>
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                                                onClick={() => baixarArquivoNF(nfc.arquivo_id, nfc.nome)}>
                                                                Baixar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    {nfc.nf_ativa && (
                                                        <tr className="fin-pp__tbl-sub">
                                                            <td colSpan={6} style={{ paddingTop: 0 }}>
                                                                <div className="fin-pp__banner is-warn" style={{ margin: 0 }}>
                                                                    A NF {nfc.nf_ativa.numero ? 'nº ' + nfc.nf_ativa.numero : ''} continua ativa no sistema. Se é a mesma nota cancelada, remova no Efetivo do orçamento.
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setModalNFs(null)}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </ErpTemplate>
    );
}
